var dibs_buyer_layout =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpdibs_buyer_layout"];
/******/ 	window["webpackJsonpdibs_buyer_layout"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		13: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"tradeOnboarding","1":"contactModal","2":"AuthModal","3":"responsiveHeader","4":"makeOfferModal","5":"mobileHeader","6":"checkoutSurvey","7":"mobileAds","8":"collabPurchaseModalAction","9":"abandonCheckoutAutoModal","10":"NotificationsBodyComponents","11":"FavNotifications","12":"CartNavDropdownContent"}[chunkId]||chunkId) + "_22.0.6_" + "60c513c88d20559e42ec" + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://a.1stdibscdn.com/assets/buyer-layout/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./exports/makeOfferLauncher.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = makeOfferLauncher;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeOfferLauncher() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var modalContainer = document.createElement('div');
    var currency = options.currency,
        currentModal = options.currentModal,
        itemId = options.itemId,
        environment = options.environment,
        quantitySelected = options.quantitySelected;

    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "./src/MakeOfferModal/makeOfferAsyncImports.js")).then(function (mod) {
        var components = mod.components,
            helpers = mod.helpers;
        var MakeOfferModal = components.MakeOfferModal,
            IntlProvider = components.IntlProvider;
        var serverVars = helpers.serverVars;


        _reactDom2.default.hydrate(_react2.default.createElement(
            IntlProvider,
            {
                locale: serverVars.get('locale') || 'en',
                messages: serverVars.get('messages')
            },
            _react2.default.createElement(MakeOfferModal, {
                environment: environment,
                itemId: itemId,
                pageCurrency: currency,
                quantitySelected: quantitySelected
            })
        ), modalContainer);
    });
}

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/define-property.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(212);

/***/ }),

/***/ "./node_modules/babel-runtime/core-js/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js"), __esModule: true };

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/classCallCheck.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(6);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/createClass.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__("./node_modules/babel-runtime/core-js/object/define-property.js");

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/defineProperty.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(147);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/extends.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(18);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/inherits.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(77);

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/objectWithoutProperties.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),

/***/ "./node_modules/babel-runtime/helpers/possibleConstructorReturn.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(78);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/fn/object/get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js");
module.exports = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js").Object.getPrototypeOf;


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(28);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(43);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(61);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(241);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_export.js");
var core = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_core.js");
var fails = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_fails.js");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(104);

/***/ }),

/***/ "./node_modules/babel-runtime/node_modules/core-js/library/modules/es6.object.get-prototype-of.js":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_to-object.js");
var $getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-gpo.js");

__webpack_require__("./node_modules/babel-runtime/node_modules/core-js/library/modules/_object-sap.js")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "./node_modules/charenc/charenc.js":
/***/ (function(module, exports) {

var charenc = {
  // UTF-8 encoding
  utf8: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
    }
  },

  // Binary encoding
  bin: {
    // Convert a string to a byte array
    stringToBytes: function(str) {
      for (var bytes = [], i = 0; i < str.length; i++)
        bytes.push(str.charCodeAt(i) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a string
    bytesToString: function(bytes) {
      for (var str = [], i = 0; i < bytes.length; i++)
        str.push(String.fromCharCode(bytes[i]));
      return str.join('');
    }
  }
};

module.exports = charenc;


/***/ }),

/***/ "./node_modules/classnames/index.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ "./node_modules/cookie/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ "./node_modules/crypt/crypt.js":
/***/ (function(module, exports) {

(function() {
  var base64map
      = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',

  crypt = {
    // Bit-wise rotation left
    rotl: function(n, b) {
      return (n << b) | (n >>> (32 - b));
    },

    // Bit-wise rotation right
    rotr: function(n, b) {
      return (n << (32 - b)) | (n >>> b);
    },

    // Swap big-endian to little-endian and vice versa
    endian: function(n) {
      // If number given, swap endian
      if (n.constructor == Number) {
        return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
      }

      // Else, assume array and swap all items
      for (var i = 0; i < n.length; i++)
        n[i] = crypt.endian(n[i]);
      return n;
    },

    // Generate an array of any length of random bytes
    randomBytes: function(n) {
      for (var bytes = []; n > 0; n--)
        bytes.push(Math.floor(Math.random() * 256));
      return bytes;
    },

    // Convert a byte array to big-endian 32-bit words
    bytesToWords: function(bytes) {
      for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)
        words[b >>> 5] |= bytes[i] << (24 - b % 32);
      return words;
    },

    // Convert big-endian 32-bit words to a byte array
    wordsToBytes: function(words) {
      for (var bytes = [], b = 0; b < words.length * 32; b += 8)
        bytes.push((words[b >>> 5] >>> (24 - b % 32)) & 0xFF);
      return bytes;
    },

    // Convert a byte array to a hex string
    bytesToHex: function(bytes) {
      for (var hex = [], i = 0; i < bytes.length; i++) {
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
      }
      return hex.join('');
    },

    // Convert a hex string to a byte array
    hexToBytes: function(hex) {
      for (var bytes = [], c = 0; c < hex.length; c += 2)
        bytes.push(parseInt(hex.substr(c, 2), 16));
      return bytes;
    },

    // Convert a byte array to a base-64 string
    bytesToBase64: function(bytes) {
      for (var base64 = [], i = 0; i < bytes.length; i += 3) {
        var triplet = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2];
        for (var j = 0; j < 4; j++)
          if (i * 8 + j * 6 <= bytes.length * 8)
            base64.push(base64map.charAt((triplet >>> 6 * (3 - j)) & 0x3F));
          else
            base64.push('=');
      }
      return base64.join('');
    },

    // Convert a base-64 string to a byte array
    base64ToBytes: function(base64) {
      // Remove non-base-64 characters
      base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');

      for (var bytes = [], i = 0, imod4 = 0; i < base64.length;
          imod4 = ++i % 4) {
        if (imod4 == 0) continue;
        bytes.push(((base64map.indexOf(base64.charAt(i - 1))
            & (Math.pow(2, -2 * imod4 + 8) - 1)) << (imod4 * 2))
            | (base64map.indexOf(base64.charAt(i)) >>> (6 - imod4 * 2)));
      }
      return bytes;
    }
  };

  module.exports = crypt;
})();


/***/ }),

/***/ "./node_modules/deep-freeze/index.js":
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),

/***/ "./node_modules/deepmerge/dist/es.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, optionsArgument) {
	var clone = !optionsArgument || optionsArgument.clone !== false;

	return (clone && isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, optionsArgument)
		: value
}

function defaultArrayMerge(target, source, optionsArgument) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, optionsArgument)
	})
}

function mergeObject(target, source, optionsArgument) {
	var destination = {};
	if (isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], optionsArgument);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], optionsArgument);
		} else {
			destination[key] = deepmerge(target[key], source[key], optionsArgument);
		}
	});
	return destination
}

function deepmerge(target, source, optionsArgument) {
	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var options = optionsArgument || { arrayMerge: defaultArrayMerge };
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, optionsArgument)
	} else if (sourceIsArray) {
		var arrayMerge = options.arrayMerge || defaultArrayMerge;
		return arrayMerge(target, source, optionsArgument)
	} else {
		return mergeObject(target, source, optionsArgument)
	}
}

deepmerge.all = function deepmergeAll(array, optionsArgument) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, optionsArgument)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["default"] = (deepmerge_1);


/***/ }),

/***/ "./node_modules/dibs-browser-storage/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
var Cookies = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var root = 'undefined' === typeof window ? global : window;
var LocalStorage;
var SessionStorage;
var initializedSessionStorage;

function Storage() {
    this.data = {};
}

Storage.prototype = {
    _storage: {},
    _supported: false,
    initialize: function (storage) {
        this._storage = storage || root.localStorage;
        this._supported = this.isSupported();
        return this;
    },
    isSupported: function () {
        try {
            // FINDING-1393 - trying this first fixes private mode browsing in safari
            // https://github.com/marcuswestin/store.js/issues/42
            this._storage.setItem('dibsy', '');
            this._storage.removeItem('dibsy');
            return true;
        } catch (e) {
            return false;
        }
    },
    /**
     * Sets whether or not local/session storage is supported
     * @param {boolean} supported
     */
    setSupported: function (supported) {
        this._supported = supported;
    },
    getItems: function () {
        if (!this._supported) {
            return 'localStorage is not supported';
        }
        return this._storage;
    },
    /**
     * Set storage value by the key
     *
     * @param key - {string}
     * @param value - {mixed}
     * @returns {Storage}
     */
    setItem: function (key, value) {
        switch (typeof value) {
            case 'object':
                value = JSON.stringify(value);
                break;
            default:
                value += '';
        }

        if (!this._supported) {
            this.data[key] = value;
            Cookies.set(key, value, {path: '/', domain: '.1stdibs.com'});
        } else {
            try {
                this._storage.setItem(key, value);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    },
    /**
     * Get storage value by the key
     *
     * @param key - {string}
     * @returns {mixed}
     */
    getItem: function (key) {
        var value;

        if (!key) {
            return false;
        }
        if (!this._supported) {
            value = Cookies.get(key);
            if (!value && this.data[key]) {
                value = this.data[key];
            }
        } else {
            value = this._storage[key];
        }

        try {
            return JSON.parse(value);
        } catch (e) {
            return value;
        }
    },
    /**
     * Delete storage by the key
     *
     * @param key - {string}
     * @returns {Storage}
     */
    deleteItem: function (key) {
        if (!this._supported) {
            delete this.data[key];
            Cookies.remove(key, {path: '/'});
        } else {
            try {
                this._storage.removeItem(key);
            } catch (e) {
                // do nothing
            }
        }
        return this;
    }
};

LocalStorage = new Storage();
SessionStorage = new Storage();
initializedSessionStorage = SessionStorage.initialize(root.sessionStorage);

module.exports = {
    localStorage: LocalStorage.initialize(),
    sessionStorage: initializedSessionStorage
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-client-check/dist/mobileCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * User: daletan
 * Date: 6/23/14
 * Time: 10:44 AM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 *
 * formerly:
 * js/global/core/dibs.js#isMobile
 * js/global/core/dibs.js#isTouchDevice
 * dibs.isMobile
 * dibs.isTouchDevice
 */


var getUserAgent = function () { // eslint-disable-line no-var
    return window.navigator && window.navigator.userAgent;
};

/**
 * Detect if user is on mobile device
 * this is a jenky solution since it relies on the user agent
 * it should rely on feature detection instead
 */
module.exports = {
    Android: function (ua) {
        return (/Android/i).test(ua || getUserAgent());
    },
    BlackBerry: function (ua) {
        return (/BlackBerry/i).test(ua || getUserAgent());
    },
    BlackBerry10: function (ua) {
        return (/BB10/i).test(ua || getUserAgent());
    },
    iPhone: function (ua) {
        return (/iPhone/i).test(ua || getUserAgent());
    },
    iPad: function (ua) {
        return (/iPad/i).test(ua || getUserAgent());
    },
    iPod: function (ua) {
        return (/iPod/i).test(ua || getUserAgent());
    },
    iOS: function (ua) {
        return this.iPhone(ua) || this.iPad(ua) || this.iPod(ua);
    },
    Opera: function (ua) {
        return (/Opera Mobi/i).test(ua || getUserAgent());
    },
    Windows: function (ua) {
        return (/IEMobile/i).test(ua || getUserAgent());
    },
    iOSVersion: function (version, ua) {
        var r = new RegExp('(iPad|iPhone|iPod);.*CPU.*OS ' + version + '_\\d', 'i'); // eslint-disable-line no-var
        return r.test(ua || getUserAgent());
    },
    any: function (ua) {
        var isMobile = false; // eslint-disable-line no-var
        var blacklist = [ // eslint-disable-line no-var
            'hasTouch',
            'isTouchDevice',
            'any',
            'iOSVersion'
        ];
        var p; // eslint-disable-line no-var

        for (p in this) {
            if (this.hasOwnProperty(p) && blacklist.indexOf(p) === -1) {
                isMobile = this[p](ua || getUserAgent());
                if (isMobile) {
                    return isMobile;
                }
            }
        }
        return isMobile;
    },
    /**
     * @returns {boolean}
     */
    hasTouch: function () {
        // http://stackoverflow.com/a/4819886
        // reference  GFoley83 Sep 4 '13 at 6:20 comment
        //
        // added non-prefixed maxTouchPoints based on this post:
        // http://msdn.microsoft.com/en-us/library/ie/hh772144%28v=vs.85%29.aspx
        return (window.navigator && !!(window.navigator.msMaxTouchPoints) || !!(window.navigator.maxTouchPoints)) || 'ontouchstart' in window;
    }
};


//DETECT TOUCH CAPABILITIES


/***/ }),

/***/ "./node_modules/dibs-cookie-jar/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var cookieMonster = __webpack_require__("./node_modules/cookie/index.js");

/**
 * @ignore
 * Created by daletan on 9/13/16.
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined$1; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var undefined$1 = void 0;

var keys = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    USER_EMAIL: 'userEmail',
    USER_LEGACY: 'userreg',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken'
});

/**
 * @param {string} value
 * @returns {object|null}
 */
var getMasqueradeValues = function getMasqueradeValues() {
    var value = arguments.length > 0 && arguments[0] !== undefined$1 ? arguments[0] : '';

    if (!value) {
        return null;
    }

    var _value$split = value.split('_');

    var _value$split2 = _slicedToArray(_value$split, 3);

    var type = _value$split2[0];
    var id = _value$split2[1];
    var vertical = _value$split2[2];

    var parts = {
        type: type,
        id: id
    };
    if (vertical) {
        parts.vertical = vertical;
    }
    return parts;
};

/**
 * @param {string|object} cookie
 * @param {string} cookieKey
 * @returns {string|undefined}
 */
var getCookieValue = function getCookieValue(cookie, cookieKey) {
    var parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return parsed && parsed[cookieKey] || undefined$1;
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeSellerInfo = function getMasqueradeSellerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_SELLER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeBuyerInfo = function getMasqueradeBuyerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_BUYER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeSellerId = function getMasqueradeSellerId(cookie) {
    var parts = getMasqueradeSellerInfo(cookie);
    return parts ? parts.vertical.toLowerCase() + '_' + parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeBuyerId = function getMasqueradeBuyerId(cookie) {
    var parts = getMasqueradeBuyerInfo(cookie);
    return parts ? parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getUserTokenString = function getUserTokenString(cookie) {
    return getCookieValue(cookie, keys.USER);
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getSellerTokenString = function getSellerTokenString(cookie) {
    return getCookieValue(cookie, keys.SELLER);
};

/**
 * @param {*} token seller token
 * @returns {boolean}
 */
var isSellerToken = function isSellerToken(token) {
    return (/^[fjva]_/i.test(token)
    );
};

/**
 * @param {*} token user token
 * @returns {boolean}
 */
var isBuyerToken = function isBuyerToken(token) {
    return (/^\d+_/i.test(token)
    );
};

/**
 *
 * @param {string} token user or seller token
 * @returns {string|null}
 */
var splitToken = function splitToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined$1 ? arguments[0] : '';

    var parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return parts[0] + '_' + parts[1];
        } else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
};

/**
 * based off of bunsen/libraries/bunsen#getMasqueradeAsUserId
 * The bunsen version returned an `object.userId`
 * This version only returns a string or null
 * @param {string|object} cookie
 * @param {string} type
 * @returns {string|null}
 */
var getMasqueradeUserIdByType = function getMasqueradeUserIdByType(cookie, type) {
    if (type === keys.MASQUERADE_SELLER) {
        return getMasqueradeSellerId(cookie);
    } else if (type === keys.MASQUERADE_BUYER) {
        return getMasqueradeBuyerId(cookie);
    }
    return null;
};

/**
 * @param {string} cookie
 * @param {string} [userType] The type of user masquerade info to return
 * @returns {string|null}
 */
var getMasqueradeValue = function getMasqueradeValue(cookie, userType) {
    var parsed = cookieMonster.parse(cookie);
    return getMasqueradeUserIdByType(parsed, userType) || null;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookieJarConstants = keys;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getPasswordReset(cookie) {
    return getCookieValue(cookie, keys.PASSWORD_RESET);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getUserType(cookie) {
    return getCookieValue(cookie, keys.USER_TYPE);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getGuestId(cookie) {
    return getCookieValue(cookie, keys.GUEST_ID);
}

/**
 * backwards compatibility
 * public api method will be removed in next major release, use {@link getBuyerToken}
 * @deprecated
 * @param {string} cookie
 */
var getUserToken = getUserTokenString;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getEverLoggedIn(cookie) {
    return getCookieValue(cookie, keys.EVER_LOGGED_IN);
}

/**
 * based off of bunsen/models/identity/User#getUserId
 * The additional change here is adding the `userType` as the bunsen
 * version only assumed the buyer. The seller is also taken into account
 * @param {string} cookie document.cookie or req.cookie string
 * @param {string} [userType] The type of user masquerade info to return
 * @param {boolean} [getRealUser] returns the actual user (usually internal) if you happen to be masquerading
 * @returns {string|null}
 */
function getUserId(cookie, userType, getRealUser) {
    console.warn('DEPRECATION WARNING: getUserId is deprecated, use getBuyerId(cookie: string, { getRealUser: boolean })');

    if (typeof cookie !== 'string') {
        throw new Error('a cookie string must be passed in. a ' + (typeof cookie === 'undefined' ? 'undefined' : _typeof(cookie)) + ' was passed passed in instead.');
    }

    var masqueradeInfo = getMasqueradeValue(cookie, userType);

    if (masqueradeInfo && !getRealUser) {
        return masqueradeInfo;
    }

    var userId = splitToken(getUserTokenString(cookie));
    return userId || null;
}

function getBuyerId(cookie) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var getRealUser = options.getRealUser;


    var masqueradedUserId = getMasqueradeUserIdByType(cookie, keys.MASQUERADE_BUYER);
    var realUserId = splitToken(getUserTokenString(cookie)) || null;

    if (getRealUser) {
        return realUserId;
    }

    return masqueradedUserId || realUserId;
}

/**
 *
 * @param {string} cookie
 * @returns {string|null}
 */
function getSellerId(cookie) {
    var sellerId = splitToken(getSellerTokenString(cookie));
    return sellerId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {function}
 */
function isMasqueradingByType(cookie) {
    var userId = getBuyerId(cookie);
    /**
     * @param {string} userType
     * @returns {boolean}
     */
    return function (userType) {
        // return `false` instead of `null`
        return (userId ? userId : false) && !!getMasqueradeUserIdByType(cookie, userType);
    };
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsSeller(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_SELLER);
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsBuyer(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_BUYER);
}

/**
 * based off of bunsen/helpers/actingUser#isMasquerading
 * The bunsen version would pull the buyer user info from server vars
 * There should be a `userToken` cookie value set for the internal
 * user if you are masquerading
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasquerading(cookie) {
    var sellerId = isMasqueradingAsSeller(cookie);
    var buyerId = isMasqueradingAsBuyer(cookie);
    return !!(sellerId || buyerId);
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * @param {string} cookie
 * @returns {object}
 */
function getBuyerToken(cookie) {
    var userToken = getUserTokenString(cookie);
    if (userToken) {
        return {
            userToken: userToken
        };
    }
    return {};
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * sellerToken takes precedence over userToken (userToken case should
 * only be hit while masquerading)
 * @param {string} cookie
 * @returns {object}
 */
function getAdminToken(cookie) {
    // if seller token, return seller token
    var sellerToken = getSellerTokenString(cookie);
    if (sellerToken) {
        return {
            sellerToken: sellerToken
        };
    }

    // either a logged in admin user or masquerading as a seller
    // leveraging `getBuyerToken` logic
    // returns an object already
    // and will also return an empty object
    // for a falsey value
    return getBuyerToken(cookie);
}

function getAdminUser(cookie) {
    return getBuyerId(cookie, { getRealUser: true });
}

exports.cookieJarConstants = cookieJarConstants;
exports.getPasswordReset = getPasswordReset;
exports.getUserType = getUserType;
exports.getGuestId = getGuestId;
exports.getUserToken = getUserToken;
exports.getEverLoggedIn = getEverLoggedIn;
exports.getUserId = getUserId;
exports.getBuyerId = getBuyerId;
exports.getSellerId = getSellerId;
exports.isMasqueradingByType = isMasqueradingByType;
exports.isMasqueradingAsSeller = isMasqueradingAsSeller;
exports.isMasqueradingAsBuyer = isMasqueradingAsBuyer;
exports.isMasquerading = isMasquerading;
exports.getBuyerToken = getBuyerToken;
exports.getAdminToken = getAdminToken;
exports.getAdminUser = getAdminUser;


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var currencies = __webpack_require__("./node_modules/dibs-currency-helpers/currencies.js");
var constants = {
    currencies: {},
    symbols: {
        GBP: '£',
        EUR: '€',
        USD: '$',
        CAD: '$',
        AUD: '$',
        CHF: '', // Swiss francs don't have a currency symbol
        MXN: '$'
    },
    abbreviations: {
        CAD: 'CAD',
        AUD: 'AUD',
        MXN: 'MXN',
        CHF: 'CHF'
    },
    flags: {
        sm: {},
        md: {}
    }
};
currencies.forEach(function (currency) {
    constants.flags.sm[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/1x/flag_'+currency.toLowerCase()+'.png';
    constants.flags.md[currency] = 'https://a.1stdibscdn.com/assets/currency-flags/2x/flag_'+currency.toLowerCase()+'.png';
});
currencies.forEach(function (currency) {
    constants.currencies['CURRENCY_' + currency] = currency;
});

module.exports = constants;


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/currencies.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = ['USD', 'GBP', 'EUR', 'CAD', 'AUD', 'CHF', 'MXN'];


/***/ }),

/***/ "./node_modules/dibs-currency-helpers/getCurrencySymbol.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var symbols = __webpack_require__("./node_modules/dibs-currency-helpers/constants.js").symbols;

module.exports = function getCurrencySymbol(currencyENUM) {
    return symbols[currencyENUM];
};


/***/ }),

/***/ "./node_modules/dibs-elements/dist/BarHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BarHeader = __webpack_require__("./node_modules/dibs-elements/lib/BarHeader/index.js");

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'headerWrapper': 'BarHeader__headerWrapper___1tOVZ',
  'title': 'BarHeader__title___3Yc_T',
  'small': 'BarHeader__small___2CPVz',
  'medium': 'BarHeader__medium___1WY1g',
  'large': 'BarHeader__large___2oKY6',
  'subtitle': 'BarHeader__subtitle___2DgA6',
  'bottomBorder': 'BarHeader__bottomBorder___3GVMZ'
};

var DefaultBarHeader = (0, _mergeThemeHoc2.default)(style)(_BarHeader2.default);
DefaultBarHeader.displayName = 'DefaultBarHeader';
exports.default = DefaultBarHeader;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/Primary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Button = __webpack_require__("./node_modules/dibs-elements/lib/Button/index.js");

var _Button2 = _interopRequireDefault(_Button);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'small': 'Button__small___1mUB3',
  'medium': 'Button__medium___GQjew',
  'large': 'Button__large___27Jt8',
  'button': 'Button__button___3Jloz',
  'isDangerousAction': 'Button__isDangerousAction___1ZqcB'
};

var PrimaryButton = (0, _mergeThemeHoc2.default)(style)(_Button2.default);
PrimaryButton.displayName = 'PrimaryButton';
exports.default = PrimaryButton;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/Button/buyer/Primary.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Button__small___1mUB3":"Button__small___1mUB3","Button__medium___GQjew":"Button__medium___GQjew","Button__large___27Jt8":"Button__large___27Jt8","Button__button___3Jloz":"Button__button___3Jloz","Button__isDangerousAction___1ZqcB":"Button__isDangerousAction___1ZqcB"};

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalBody/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalBody = __webpack_require__("./node_modules/dibs-elements/lib/ModalBody/index.js");

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'modalBody': 'ModalBody__modalBody___2EzQf'
};

var DefaultModalBody = (0, _mergeThemeHoc2.default)(style)(_ModalBody2.default);
DefaultModalBody.displayName = 'DefaultModalBody';
exports.default = DefaultModalBody;

/***/ }),

/***/ "./node_modules/dibs-elements/dist/ModalContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalContainer = __webpack_require__("./node_modules/dibs-elements/lib/ModalContainer/index.js");

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = __webpack_require__("./node_modules/merge-theme-hoc/dist/index.js");

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'stopBodyScroll': 'ModalContainer__stopBodyScroll___3oNKK',
  'overlayDefault': 'ModalContainer__overlayDefault___1Vj5A',
  'overlayFadeStart': 'ModalContainer__overlayFadeStart___sMsD1',
  'overlayDefaultOpening': 'ModalContainer__overlayDefaultOpening___8a5KA',
  'overlayDefaultClosing': 'ModalContainer__overlayDefaultClosing___3ToWB',
  'modalDefault': 'ModalContainer__modalDefault___2BfP6',
  'modalMedium': 'ModalContainer__modalMedium___yt_fR',
  'modalLarge': 'ModalContainer__modalLarge___1yXsP',
  'modalFullscreen': 'ModalContainer__modalFullscreen___1Un8X',
  'modalHeightCenter': 'ModalContainer__modalHeightCenter___1uOBs'
};

var DefaultModalContainer = (0, _mergeThemeHoc2.default)(style)(_ModalContainer2.default);
DefaultModalContainer.displayName = 'DefaultModalContainer';
exports.default = DefaultModalContainer;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/BarHeader/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BarHeader = function BarHeader(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        title = props.title,
        subtitle = props.subtitle,
        theme = props.theme,
        dataTn = props.dataTn;


    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: theme.headerWrapper },
        _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-title' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.title, theme[size])
            },
            title
        ),
        subtitle && _react2.default.createElement(
            'div',
            {
                'data-tn': 'bar-header-subtitle' + (dataTn ? '-' + dataTn : ''),
                className: (0, _classnames2.default)(theme.subtitle, theme[size])
            },
            subtitle
        ),
        _react2.default.createElement('div', { className: theme.bottomBorder })
    );
};

BarHeader.displayName = 'BarHeader';

exports.default = BarHeader;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/Button/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__("./node_modules/babel-runtime/helpers/extends.js");

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__("./node_modules/babel-runtime/helpers/objectWithoutProperties.js");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(props) {
    var _props$size = props.size,
        size = _props$size === undefined ? 'large' : _props$size,
        children = props.children,
        theme = props.theme,
        className = props.className,
        dataTn = props.dataTn,
        isDangerousAction = props.isDangerousAction,
        href = props.href,
        btnProps = (0, _objectWithoutProperties3.default)(props, ['size', 'children', 'theme', 'className', 'dataTn', 'isDangerousAction', 'href']);


    if (theme) {
        var outputClassName = (0, _classnames2.default)((0, _defineProperty3.default)({}, theme.isDangerousAction, isDangerousAction), theme.button, theme[size], className);
        if (href) {
            return _react2.default.createElement(
                'a',
                (0, _extends3.default)({}, btnProps, {
                    className: outputClassName,
                    'data-tn': dataTn,
                    href: href
                }),
                children
            );
        }
        return _react2.default.createElement(
            'button',
            (0, _extends3.default)({}, btnProps, {
                className: outputClassName,
                'data-tn': dataTn
            }),
            children
        );
    }
    return null;
};

Button.displayName = 'Button';

exports.default = Button;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalBody/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(props) {
    var theme = props.theme,
        className = props.className,
        children = props.children;

    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.modalBody, className) },
        children
    );
};

ModalBody.displayName = 'ModalBody';

exports.default = ModalBody;

/***/ }),

/***/ "./node_modules/dibs-elements/lib/ModalContainer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("./node_modules/babel-runtime/helpers/defineProperty.js");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__("./node_modules/babel-runtime/core-js/object/get-prototype-of.js");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("./node_modules/babel-runtime/helpers/classCallCheck.js");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("./node_modules/babel-runtime/helpers/createClass.js");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__("./node_modules/babel-runtime/helpers/possibleConstructorReturn.js");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("./node_modules/babel-runtime/helpers/inherits.js");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactPortal = __webpack_require__("./node_modules/react-portal/build/portal.js");

var _reactPortal2 = _interopRequireDefault(_reactPortal);

var _elementClass = __webpack_require__("./node_modules/element-class/index.js");

var _elementClass2 = _interopRequireDefault(_elementClass);

var _classnames3 = __webpack_require__("./node_modules/classnames/index.js");

var _classnames4 = _interopRequireDefault(_classnames3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isTest = "production" === 'test';

var ModalContainer = function (_Component) {
    (0, _inherits3.default)(ModalContainer, _Component);

    function ModalContainer(props) {
        (0, _classCallCheck3.default)(this, ModalContainer);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ModalContainer.__proto__ || (0, _getPrototypeOf2.default)(ModalContainer)).call(this, props));

        _this.handleKeydown = _this.handleKeydown.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.endCloseAnimation = _this.endCloseAnimation.bind(_this);
        _this.timeouts = [];
        _this.scrollY = 0;
        _this.state = {
            modalOpened: false,
            animation: null
        };
        return _this;
    }

    (0, _createClass3.default)(ModalContainer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            /* istanbul ignore else */
            if (this.props.isOpen && !this.state.modalOpened) {
                this.openModal();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            /* istanbul ignore else */
            if (nextProps.isOpen && !this.state.modalOpened) {
                this.openModal();
            } else if (!nextProps.isOpen && this.state.modalOpened) {
                this.closeModal();
            };
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
            var _props = this.props,
                theme = _props.theme,
                preventBackScroll = _props.preventBackScroll;
            /* istanbul ignore else */

            if (theme && preventBackScroll) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);
            }
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            this.timeouts.forEach(clearTimeout);
        }
    }, {
        key: 'openModal',
        value: function openModal() {
            var _this2 = this;

            var _props2 = this.props,
                closeOnEsc = _props2.closeOnEsc,
                theme = _props2.theme,
                preventBackScroll = _props2.preventBackScroll,
                animates = _props2.animates,
                onOpen = _props2.onOpen;

            /* istanbul ignore else */

            if (closeOnEsc) {
                document.addEventListener('keydown', this.handleKeydown);
            }

            if (theme && preventBackScroll) {
                this.scrollY = window.pageYOffset;
                (0, _elementClass2.default)(document.body).add(theme.stopBodyScroll);

                // No need to scroll if position doesn't change - look at `.stopBodyScroll` styles
                if (this.scrollY === window.pageYOffset) {
                    this.scrollY = 0;
                }
            }

            if (onOpen) {
                onOpen();
            }

            if (animates) {
                this.setState({
                    modalOpened: true
                }, function () {
                    _this2.timeouts.push(setTimeout(function () {
                        return _this2.setState({ animation: "opening" });
                    }, 10));
                });
            } else {
                this.setState({
                    modalOpened: true
                });
            }
        }
    }, {
        key: 'endCloseAnimation',
        value: function endCloseAnimation() {
            this.setState({ modalOpened: false, animation: null });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            var _this3 = this;

            var _props3 = this.props,
                closeOnEsc = _props3.closeOnEsc,
                theme = _props3.theme,
                preventBackScroll = _props3.preventBackScroll,
                animates = _props3.animates;
            /* istanbul ignore else */

            if (closeOnEsc) {
                document.removeEventListener('keydown', this.handleKeydown);
            }

            if (theme && preventBackScroll) {
                (0, _elementClass2.default)(document.body).remove(theme.stopBodyScroll);

                // Scroll back to previous position
                if (this.scrollY) {
                    window.scrollTo(0, this.scrollY);
                }
            }

            if (animates && this.state.modalOpened) {
                this.setState({
                    animation: "closing"
                }, function () {
                    _this3.timeouts.push(setTimeout(_this3.endCloseAnimation, 300));
                });
            } else {
                this.setState({
                    modalOpened: false
                });
            }
        }
    }, {
        key: 'handleKeydown',
        value: function handleKeydown(e) {
            switch (e.key) {
                case "Esc":
                case "Escape":
                    if (this.props.closeOnEsc) {
                        this.props.onClose();
                    };
                    break;
                default:
                    break;
            }
        }
    }, {
        key: 'handleOutsideClick',
        value: function handleOutsideClick() {
            var _props4 = this.props,
                closeOnOutsideClick = _props4.closeOnOutsideClick,
                onClose = _props4.onClose;
            /* istanbul ignore else */

            if (closeOnOutsideClick) {
                onClose();
            }
        }
    }, {
        key: 'handleInsideClick',
        value: function handleInsideClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props5 = this.props,
                animates = _props5.animates,
                overlayClass = _props5.overlayClass,
                modalClass = _props5.modalClass,
                children = _props5.children,
                dataTn = _props5.dataTn,
                modalPosition = _props5.modalPosition,
                modalSize = _props5.modalSize,
                theme = _props5.theme,
                appendToBody = _props5.appendToBody;
            var _state = this.state,
                modalOpened = _state.modalOpened,
                animation = _state.animation;


            if (!theme) {
                return null;
            }

            var overlayClasses = (0, _classnames4.default)(theme.overlayDefault, (_classnames = {}, (0, _defineProperty3.default)(_classnames, theme.overlayFadeStart, animates), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultOpening, animates && animation === "opening"), (0, _defineProperty3.default)(_classnames, theme.overlayDefaultClosing, animates && animation === "closing"), _classnames), overlayClass);

            var modalClasses = (0, _classnames4.default)(theme.modalDefault, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.modalMedium, modalSize === 'medium'), (0, _defineProperty3.default)(_classnames2, theme.modalLarge, modalSize === 'large'), (0, _defineProperty3.default)(_classnames2, theme.modalFullscreen, modalSize === 'fullscreen'), (0, _defineProperty3.default)(_classnames2, theme.modalHeightCenter, modalPosition === 'center'), _classnames2), modalClass);

            var modal = _react2.default.createElement(
                'div',
                { onClick: this.handleOutsideClick, id: 'ModalOverlay', className: overlayClasses },
                _react2.default.createElement(
                    'div',
                    {
                        id: 'Modal',
                        onClick: this.handleInsideClick,
                        className: modalClasses,
                        'data-tn': dataTn
                    },
                    children
                )
            );
            if (appendToBody) {
                return _react2.default.createElement(
                    _reactPortal2.default,
                    {
                        isOpened: modalOpened,
                        closeOnOutsideClick: false,
                        closeOnEsc: false
                    },
                    modal
                );
            }

            return modal;
        }
    }]);
    return ModalContainer;
}(_react.Component);

ModalContainer.defaultProps = {
    animates: true,
    closeOnEsc: true,
    closeOnOutsideClick: true,
    modalPosition: 'top',
    modalSize: 'default',
    appendToBody: !isTest,
    preventBackScroll: true
};
;

ModalContainer.displayName = 'ModalContainer';

exports.default = ModalContainer;

/***/ }),

/***/ "./node_modules/dibs-gas/index.js":
/***/ (function(module, exports) {

/**
 * @preserve Copyright 2013, Cardinal Path and DigitalInc.
 *
 * GAS - Google Analytics on Steroids
 * https://github.com/CardinalPath/gas
 *
 * @author Eduardo Cereto <eduardocereto@gmail.com>
 * Licensed under the GPLv3 license.
 *
 */

// Modified 2013-07-30 by Michael Harrison
// Added non-interaction flags to event tracking and added dc.js reference

(function (e, t) {
    if (!e) {
        // not in the client aka window
        return;
    }
    var global = e;
    try {
        if (Object.prototype.toString.call(global.process) === '[object process]') {
            return;
        }
    } catch(e) {}

    function p() {
        var e = this;
        e.version = "1.9", e._accounts = {}, e._accounts_length = 0, e._queue = r, e._default_tracker = "_gas1", e.gh = {}, e._hooks = {
            _addHook: [e._addHook]
        }, e.push(function () {
            e.gh = new n
        })
    }

    function d(e) {
        return e === _gas._default_tracker ? "" : e + "."
    }

    function v(t) {
        if (_gas.debug_mode) try {
            console.log(t)
        } catch (n) {}
        return e._gaq.push(t)
    }

    function m(e, t) {
        if (typeof e != "string") return !1;
        var n = e.split("?")[0];
        return n = n.split("."), n = n[n.length - 1], n && this.inArray(t, n) ? n : !1
    }

    function y(e) {
        while (e && e.nodeName !== "HTML") {
            if (e.nodeName === "FORM") break;
            e = e.parentNode
        }
        return e.nodeName === "FORM" ? e.name || e.id || "none" : "none"
    }

    function w(e) {
        _gas.push(["_trackEvent", this.tagName, e.type, this.currentSrc])
    }

    function N() {
        return e.innerHeight || h.clientHeight || i.body.clientHeight || 0
    }

    function C() {
        return e.pageYOffset || i.body.scrollTop || h.scrollTop || 0
    }

    function k() {
        return Math.max(i.body.scrollHeight || 0, h.scrollHeight || 0, i.body.offsetHeight || 0, h.offsetHeight || 0, i.body.clientHeight || 0, h.clientHeight || 0)
    }

    function L() {
        return (C() + N()) / k() * 100
    }

    function M(e) {
        A && clearTimeout(A);
        if (e === !0) {
            O = Math.max(L(), O);
            return
        }
        A = setTimeout(function () {
            O = Math.max(L(), O)
        }, 400)
    }

    function _() {
        M(!0), O = Math.floor(O);
        if (O <= 0 || O > 100) return;
        var e = (O > 10 ? 1 : 0) * (Math.floor((O - 1) / 10) * 10 + 1);
        e = String(e) + "-" + String(Math.ceil(O / 10) * 10), _gas.push(["_trackEvent", D.category, c, e, Math.floor(O), !0])
    }

    function P(t) {
        if ( !! this._maxScrollTracked) return;
        this._maxScrollTracked = !0, D = t || {}, D.category = D.category || "Max Scroll", this._addEventListener(e, "scroll", M), this._addEventListener(e, "beforeunload", _)
    }

    function j(e) {
        if (!this._multidomainTracked) {
            this._multidomainTracked = !0;
            var t = i.location.hostname,
                n = this,
                r, s, o, u = i.getElementsByTagName("a");
            e !== "now" && e !== "mousedown" && (e = "click");
            for (r = 0; r < u.length; r++) {
                o = u[r];
                if (l.call(o.href, "http") === 0) {
                    if (o.hostname == t || l.call(o.hostname, B) >= 0) continue;
                    for (s = 0; s < H.length; s++) l.call(o.hostname, H[s]) >= 0 && (e === "now" ? o.href = n.tracker._getLinkerUrl(o.href, _gas._allowAnchor) : e === "click" ? this._addEventListener(o, e, function (e) {
                        return _gas.push(["_link", this.href, _gas._allowAnchor]), e.preventDefault ? e.preventDefault() : e.returnValue = !1, !1
                    }) : this._addEventListener(o, e, function () {
                        this.href = n.tracker._getLinkerUrl(this.href, _gas._allowAnchor)
                    }))
                }
            }
            return !1
        }
        return
    }

    function z(e) {
        R[e.player_id] || (R[e.player_id] = {}, R[e.player_id].timeTriggers = a.call(q));
        if (R[e.player_id].timeTriggers.length > 0 && e.data.percent * 100 >= R[e.player_id].timeTriggers[0]) {
            var t = R[e.player_id].timeTriggers.shift();
            _gas.push(["_trackEvent", "Vimeo Video", t + "%", U[e.player_id], 0, true])
        }
    }

    function W(e, t, n) {
        if (!n.contentWindow || !n.contentWindow.postMessage || !JSON) return !1;
        var r = n.getAttribute("src").split("?")[0],
            i = JSON.stringify({
                method: e,
                value: t
            });
        return n.contentWindow.postMessage(i, r), !0
    }

    function $(e) {
        if (l.call(e.origin, "//player.vimeo.com") > -1) {
            var t = JSON.parse(e.data);
            t.event === "ready" ? J.call(_gas.gh) : t.method ? t.method == "getVideoUrl" && (U[t.player_id] = t.value) : t.event === "playProgress" ? z(t) : _gas.push(["_trackEvent", V.category, t.event, U[t.player_id], 0, true])
        }
    }

    function J() {
        var t = i.getElementsByTagName("iframe"),
            n = 0,
            r, s, o, u = V.force,
            a = V.percentages;
        for (var f = 0; f < t.length; f++)
            if (l.call(t[f].src, "//player.vimeo.com") > -1) {
                r = "gas_vimeo_" + f, s = t[f].src, o = "?", l.call(s, "?") > -1 && (o = "&");
                if (l.call(s, "api=1") < 0) {
                    if (!u) continue;
                    s += o + "api=1&player_id=" + r
                } else l.call(s, "player_id=") < -1 && (s += o + "player_id=" + r);
                n++, t[f].id = r;
                if (t[f].src !== s) {
                    t[f].src = s;
                    break
                }
                W("getVideoUrl", "", t[f]), W("addEventListener", "play", t[f]), W("addEventListener", "pause", t[f]), W("addEventListener", "finish", t[f]), a && (q = a, W("addEventListener", "playProgress", t[f]))
            }
        n > 0 && X === !1 && (this._addEventListener(e, "message", $, !1), X = !0)
    }

    function Z(e) {
        if (Q && Q.length) {
            var t = e.getVideoData().video_id;
            Y[t] ? tt(e) : (Y[t] = {}, Y[t].timeTriggers = a.call(Q)), Y[t].timer = setTimeout(et, 1e3, e, t)
        }
    }

    function et(e, n) {
        if (Y[n] == t || Y[n].timeTriggers.length <= 0) return !1;
        var r = e.getCurrentTime() / e.getDuration() * 100;
        if (r >= Y[n].timeTriggers[0]) {
            var i = Y[n].timeTriggers.shift();
            _gas.push(["_trackEvent", G.category, i + "%", e.getVideoUrl(), 0, true])
        }
        Y[n].timer = setTimeout(et, 1e3, e, n)
    }

    function tt(e) {
        var t = e.getVideoData().video_id;
        Y[t] && Y[t].timer && (et(e, t), clearTimeout(Y[t].timer))
    }

    function nt(e) {
        var t = "";
        switch (e.data) {
            case 0:
                t = "finish", tt(e.target);
                break;
            case 1:
                t = "play", Z(e.target);
                break;
            case 2:
                t = "pause", tt(e.target)
        }
        t && _gas.push(["_trackEvent", G.category, t, e.target.getVideoUrl(), 0, true])
    }

    function rt(e) {
        _gas.push(["_trackEvent", G.category, "error (" + e.data + ")", e.target.getVideoUrl(), true])
    }

    function it() {
        var e = i.getElementsByTagName("object"),
            t, n, r, s = /(https?:\/\/www\.youtube(-nocookie)?\.com[^/]*).*\/v\/([^&?]+)/;
        for (var o = 0; o < e.length; o++) {
            t = e[o].getElementsByTagName("param");
            for (var u = 0; u < t.length; u++)
                if (t[u].name == "movie" && t[u].value) {
                    r = t[u].value.match(s), r && r[1] && r[3] && (n = i.createElement("iframe"), n.src = r[1] + "/embed/" + r[3] + "?enablejsapi=1", n.width = e[o].width, n.height = e[o].height, n.setAttribute("frameBorder", "0"), n.setAttribute("allowfullscreen", ""), e[o].parentNode.insertBefore(n, e[o]), e[o].parentNode.removeChild(e[o]), o--);
                    break
                }
        }
    }

    function st(t) {
        var n = t.force,
            r = t.percentages;
        if (n) try {
            it()
        } catch (s) {
            _gas.push(["_trackException", s, "GAS Error on youtube.js:_ytMigrateObjectEmbed"])
        }
        var o = [],
            u = i.getElementsByTagName("iframe");
        for (var a = 0; a < u.length; a++)
            if (l.call(u[a].src, "//www.youtube.com/embed") > -1) {
                if (l.call(u[a].src, "enablejsapi=1") < 0) {
                    if (!n) continue;
                    l.call(u[a].src, "?") < 0 ? u[a].src += "?enablejsapi=1" : u[a].src += "&enablejsapi=1"
                }
                o.push(u[a])
            }
        if (o.length > 0) {
            r && r.length && (Q = r), e.onYouTubePlayerAPIReady = function () {
                var t;
                for (var n = 0; n < o.length; n++) t = new e.YT.Player(o[n]), t.addEventListener("onStateChange", nt), t.addEventListener("onError", rt)
            };
            var f = i.createElement("script"),
                c = "http:";
            i.location.protocol === "https:" && (c = "https:"), f.src = c + "//www.youtube.com/player_api", f.type = "text/javascript", f.async = !0;
            var h = i.getElementsByTagName("script")[0];
            h.parentNode.insertBefore(f, h)
        }
    }
    var n = function () {
        this._setDummyTracker()
    };
    n.prototype._setDummyTracker = function () {
        if (!this.tracker) {
            var t = e._gat._getTrackers();
            t.length > 0 && (this.tracker = t[0])
        }
    }, n.prototype.inArray = function (e, t) {
        if (e && e.length)
            for (var n = 0; n < e.length; n++)
                if (e[n] === t) return !0;
        return !1
    }, n.prototype._sanitizeString = function (e, t) {
        return e = e.toLowerCase().replace(/^\ +/, "").replace(/\ +$/, "").replace(/\s+/g, "_").replace(/[\u00e1\u00e0\u00e2\u00e3\u00e5\u00e4\u00e6\u00aa]/g, "a").replace(/[\u00e9\u00e8\u00ea\u00eb\u0404\u20ac]/g, "e").replace(/[\u00ed\u00ec\u00ee\u00ef]/g, "i").replace(/[\u00f3\u00f2\u00f4\u00f5\u00f6\u00f8\u00ba]/g, "o").replace(/[\u00fa\u00f9\u00fb\u00fc]/g, "u").replace(/[\u00e7\u00a2\u00a9]/g, "c"), t && (e = e.replace(/[^a-z0-9_-]/g, "_")), e.replace(/_+/g, "_")
    }, n.prototype._addEventListener = function (t, n, r, i) {
        var s = function (n) {
            if (!n || !n.target) n = e.event, n.target = n.srcElement;
            return r.call(t, n)
        };
        return t.addEventListener ? (t.addEventListener(n, s, !! i), !0) : t.attachEvent ? t.attachEvent("on" + n, s) : (n = "on" + n, typeof t[n] == "function" && (s = function (e, t) {
            return function () {
                e.apply(this, arguments), t.apply(this, arguments)
            }
        }(t[n], s)), t[n] = s, !0)
    }, n.prototype._liveEvent = function (e, t, n) {
        var r = this;
        e = e.toUpperCase(), e = e.split(","), r._addEventListener(i, t, function (t) {
            for (var i = t.target; i.nodeName !== "HTML"; i = i.parentNode)
                if (r.inArray(e, i.nodeName) || i.parentNode === null) break;
            i && r.inArray(e, i.nodeName) && n.call(i, t)
        }, !0)
    }, n.prototype._DOMReady = function (t) {
        function r() {
            if (r.done) return;
            r.done = !0, t.apply(n, arguments)
        }
        var n = this;
        if (/^(interactive|complete)/.test(i.readyState)) return r();
        this._addEventListener(i, "DOMContentLoaded", r, !1), this._addEventListener(e, "load", r, !1)
    }, e._gaq = e._gaq || [];
    var r = e._gas || [];
    if (r._accounts_length >= 0) return;
    var i = e.document,
        s = Object.prototype.toString,
        o = Object.prototype.hasOwnProperty,
        u = Array.prototype.push,
        a = Array.prototype.slice,
        f = String.prototype.trim,
        l = String.prototype.indexOf,
        c = i.location.href,
        h = i.documentElement;
    p.prototype._addHook = function (e, t) {
        return typeof e == "string" && typeof t == "function" && (typeof _gas._hooks[e] == "undefined" && (_gas._hooks[e] = []), _gas._hooks[e].push(t)), !1
    }, p.prototype._execute = function () {
        var e = a.call(arguments),
            n = this,
            r = e.shift(),
            i = !0,
            s, u, f, c, h, p = 0;
        if (typeof r == "function") return v(function (e, t) {
            return function () {
                e.call(t)
            }
        }(r, n.gh));
        if (typeof r == "object" && r.length > 0) {
            u = r.shift(), l.call(u, ".") >= 0 ? (c = u.split(".")[0], u = u.split(".")[1]) : c = t, f = n._hooks[u];
            if (f && f.length > 0)
                for (s = 0; s < f.length; s++) try {
                    h = f[s].apply(n.gh, r), h === !1 ? i = !1 : h && h.length > 0 && (r = h)
                } catch (m) {
                    u !== "_trackException" && n.push(["_trackException", m])
                }
            if (i === !1) return 1;
            if (u === "_setAccount") {
                for (s in n._accounts)
                    if (n._accounts[s] == r[0] && c === t) return 1;
                return c = c || "_gas" + String(n._accounts_length + 1), typeof n._accounts["_gas1"] == "undefined" && l.call(c, "_gas") != -1 && (c = "_gas1"), n._accounts[c] = r[0], n._accounts_length += 1, c = d(c), p = v([c + u, r[0]]), n.gh._setDummyTracker(), p
            }
            if (u === "_link" || u === "_linkByPost" || u === "_require" || u === "_anonymizeIp") return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            var g;
            if (c && n._accounts[c]) return g = d(c) + u, e = a.call(r), e.unshift(g), v(e);
            if (n._accounts_length > 0) {
                for (s in n._accounts) o.call(n._accounts, s) && (g = d(s) + u, e = a.call(r), e.unshift(g), p += v(e));
                return p ? 1 : 0
            }
            return e = a.call(r), e.unshift(u), v(e)
        }
    }, p.prototype.push = function () {
        var t = this,
            n = a.call(arguments);
        for (var r = 0; r < n.length; r++)(function (t, n) {
            e._gaq.push(function () {
                n._execute.call(n, t)
            })
        })(n[r], t)
    }, e._gas = _gas = new p, _gas.push(["_addHook", "_trackException",
        function (e, t) {
            return _gas.push(["_trackEvent", "Exception " + (e.name || "Error"), t || e.message || e, c, 0, true]), !1
        }
    ]), _gas.push(["_addHook", "_setDebug",
        function (e) {
            _gas.debug_mode = !! e
        }
    ]), _gas.push(["_addHook", "_popHook",
        function (e) {
            var t = _gas._hooks[e];
            return t && t.pop && t.pop(), !1
        }
    ]), _gas.push(["_addHook", "_gasSetDefaultTracker",
        function (e) {
            return _gas._default_tracker = e, !1
        }
    ]), _gas.push(["_addHook", "_trackPageview",
        function () {
            var e = a.call(arguments);
            return e.length >= 2 && typeof e[0] == "string" && typeof e[1] == "string" ? [{
                page: e[0],
                title: e[1]
            }] : e
        }
    ]);
    var g = function (e) {
        var t = this;
        if (!t._downloadTracked) {
            t._downloadTracked = !0, e ? typeof e == "string" ? e = {
                extensions: e.split(",")
            } : e.length >= 1 && (e = {
                extensions: e
            }) : e = {
                extensions: []
            }, e.category = e.category || "Download";
            var n = "xls,xlsx,doc,docx,ppt,pptx,pdf,txt,zip";
            return n += ",rar,7z,exe,wma,mov,avi,wmv,mp3,csv,tsv", n = n.split(","), e.extensions = e.extensions.concat(n), t._liveEvent("a", "mousedown", function (n) {
                var r = this;
                if (r.href) {
                    var i = m.call(t, r.href, e.extensions);
                    i && _gas.push(["_trackEvent", e.category, i, r.href])
                }
            }), !1
        }
        return
    };
    _gas.push(["_addHook", "_trackDownloads", g]), _gas.push(["_addHook", "_trackEvent",
        function () {
            var e = a.call(arguments);
            return e[3] && (e[3] = (e[3] < 0 ? 0 : Math.round(e[3])) || 0), e
        }
    ]);
    var b = function (e) {
        if ( !! this._formTracked) return;
        this._formTracked = !0;
        var t = this;
        typeof e != "object" && (e = {}), e.category = e.category || "Form Tracking";
        var n = function (t) {
            var n = t.target,
                r = n.name || n.id || n.type || n.nodeName,
                i = y(n),
                s = "form (" + i + ")",
                o = r + " (" + t.type + ")";
            _gas.push(["_trackEvent", e.category, s, o, 0, true])
        };
        t._DOMReady(function () {
            var e = ["input", "select", "textarea", "hidden"],
                r = ["form"],
                s = [],
                o, u;
            for (o = 0; o < e.length; o++) {
                s = i.getElementsByTagName(e[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "change", n)
            }
            for (o = 0; o < r.length; o++) {
                s = i.getElementsByTagName(r[o]);
                for (u = 0; u < s.length; u++) t._addEventListener(s[u], "submit", n)
            }
        })
    };
    _gas.push(["_addHook", "_trackForms", b]);
    var E = function (e) {
        var t = this;
        t._liveEvent(e, "play", w), t._liveEvent(e, "pause", w), t._liveEvent(e, "ended", w)
    }, S = function () {
        if ( !! this._videoTracked) return;
        this._videoTracked = !0, E.call(this, "video")
    }, x = function () {
        if ( !! this._audioTracked) return;
        this._audioTracked = !0, E.call(this, "audio")
    };
    _gas.push(["_addHook", "_trackVideo", S]), _gas.push(["_addHook", "_trackAudio", x]);
    var T = function (e) {
        if (!this._mailtoTracked) return this._mailtoTracked = !0, e || (e = {}), e.category = e.category || "Mailto", this._liveEvent("a", "mousedown", function (t) {
            var n = t.target;
            n && n.href && n.href.toLowerCase && l.call(n.href.toLowerCase(), "mailto:") === 0 && _gas.push(["_trackEvent", e.category, n.href.substr(7), undefined, 0, true])
        }), !1;
        return
    };
    _gas.push(["_addHook", "_trackMailto", T]);
    var A = null,
        O = 0,
        D;
    _gas.push(["_addHook", "_trackMaxScroll", P]), _gas._allowAnchor = !1, _gas.push(["_addHook", "_setAllowAnchor",
        function (e) {
            _gas._allowAnchor = !! e
        }
    ]), _gas.push(["_addHook", "_link",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]), _gas.push(["_addHook", "_linkByPost",
        function (e, n) {
            return n === t && (n = _gas._allowAnchor), [e, n]
        }
    ]);
    var H = [],
        B = t;
    _gas.push(["_addHook", "_setDomainName",
        function (e) {
            if (l.call("." + i.location.hostname, e) < 0) return H.push(e), !1;
            B = e
        }
    ]), _gas.push(["_addHook", "_addExternalDomainName",
        function (e) {
            return H.push(e), !1
        }
    ]);
    var F = function () {
        var e = this,
            t = a.call(arguments);
        e._DOMReady(function () {
            j.apply(e, t)
        })
    };
    _gas.push(["_addHook", "_setMultiDomain", F]);
    var I = function (e) {
        if ( !! this._outboundTracked) return;
        this._outboundTracked = !0;
        var t = this;
        e || (e = {}), e.category = e.category || "Outbound", t._liveEvent("a", "mousedown", function (t) {
            var n = this;
            if ((n.protocol == "http:" || n.protocol == "https:") && l.call(n.hostname, i.location.hostname) === -1) {
                var r = n.pathname + n.search + "",
                    s = l.call(r, "__utm");
                s !== -1 && (r = r.substring(0, s)), _gas.push(["_trackEvent", e.category, n.hostname, r, 0, true])
            }
        })
    };
    _gas.push(["_addHook", "_trackOutboundLinks", I]);
    var q = [],
        R = {}, U = {}, X = !1,
        V, K = function (e) {
            var t = this;
            if (typeof e == "boolean" || e === "force") e = {
                force: !! e
            };
            return e = e || {}, e.category = e.category || "Vimeo Video", e.percentages = e.percentages || [], e.force = e.force || !1, V = e, t._DOMReady(function () {
                J.call(t)
            }), !1
        };
    _gas.push(["_addHook", "_trackVimeo", K]);
    var Q = [],
        G, Y = {}, ot = function (e) {
            var t = a.call(arguments);
            t[0] && (typeof t[0] == "boolean" || t[0] === "force") && (e = {
                force: !! t[0]
            }, t[1] && t[1].length && (e.percentages = t[1])), e = e || {}, e.force = e.force || !1, e.category = e.category || "YouTube Video", e.percentages = e.percentages || [], G = e;
            var n = this;
            return n._DOMReady(function () {
                st.call(n, e)
            }), !1
        };
    _gas.push(["_addHook", "_trackYoutube", ot]);
    while (_gas._queue.length > 0) _gas.push(_gas._queue.shift());
    global._gaq && global._gaq.length >= 0 && function () {
        var e = i.createElement("script");
        e.type = "text/javascript", e.async = !0, e.src = ("https:" == i.location.protocol ? "https://" : "http://") + "stats.g.doubleclick.net/dc.js";
        if (window.document.body) {
            // This is used by the unit test
            window.document.body.appendChild(e, t);
        } else {
            // Removing this causes a JS error since document.body may not be defined at the time it's called
            var t = i.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(e, t);
        }
    }()
})(typeof window !== 'undefined' ? window : null);


/***/ }),

/***/ "./node_modules/dibs-relay-network-layer/client.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // client code is ES6 Module


exports.createFetcher = createFetcher;

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-relay-network-layer/node_modules/dibs-cookie-jar/dist/index.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

__webpack_require__("./node_modules/isomorphic-fetch/fetch-npm-browserify.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createFetcher(_ref) {
    var _ref$getQueries = _ref.getQueries,
        getQueries = _ref$getQueries === undefined ? function () {
        return {};
    } : _ref$getQueries;

    return function fetchQuery(operation, variables) {
        var queryObj = getQueries();
        var queries = Object.keys(queryObj).map(function (key) {
            return key + '=' + queryObj[key];
        });

        var body = { variables: variables };
        if (operation.id) {
            // persisted query support
            body.id = operation.id;
        } else {
            body.query = operation.text;
        }

        return fetch('/soa/graphql/?' + queries.join('&'), {
            method: 'post',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(body)
        }).then(function (response) {
            return response.json();
        }).then(function (json) {
            if (json.errors) {
                if (window.newrelic) {
                    json.errors.forEach(function (e) {
                        return newrelic.noticeError(e);
                    });
                }
                // all errors are critical, null out data so relay treats as an error
                return _extends({}, json, { data: null });
            }
            return json;
        });
    };
};

/***/ }),

/***/ "./node_modules/dibs-relay-network-layer/node_modules/dibs-cookie-jar/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var cookieMonster = __webpack_require__("./node_modules/cookie/index.js");

/**
 * @ignore
 * Created by daletan on 9/13/16.
 */

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined$1; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var undefined$1 = void 0;

var keys = Object.freeze({
    USER: 'userToken', // <id>_<hash>
    SELLER: 'sellerToken', // <VERTICAL PREFIX>_<id>_<hash>
    MASQUERADE_BUYER: 'masqueradeBuyer', // U_<id>
    MASQUERADE_SELLER: 'masqueradeSeller', // S_<id>_<VERTICAL PREFIX>
    USER_TYPE: 'userType',
    USER_EMAIL: 'userEmail',
    USER_LEGACY: 'userreg',
    GUEST_ID: 'guestId',
    EVER_LOGGED_IN: 'eli',
    PASSWORD_RESET: 'passwordToken'
});

/**
 * @param {string} value
 * @returns {object|null}
 */
var getMasqueradeValues = function getMasqueradeValues() {
    var value = arguments.length > 0 && arguments[0] !== undefined$1 ? arguments[0] : '';

    if (!value) {
        return null;
    }

    var _value$split = value.split('_'),
        _value$split2 = _slicedToArray(_value$split, 3),
        type = _value$split2[0],
        id = _value$split2[1],
        vertical = _value$split2[2];

    var parts = {
        type: type,
        id: id
    };
    if (vertical) {
        parts.vertical = vertical;
    }
    return parts;
};

/**
 * @param {string|object} cookie
 * @param {string} cookieKey
 * @returns {string|undefined}
 */
var getCookieValue = function getCookieValue(cookie, cookieKey) {
    var parsed = typeof cookie === 'string' ? cookieMonster.parse(cookie) : cookie;
    return parsed && parsed[cookieKey] || undefined$1;
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeSellerInfo = function getMasqueradeSellerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_SELLER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {object|null}
 */
var getMasqueradeBuyerInfo = function getMasqueradeBuyerInfo(cookie) {
    var token = getCookieValue(cookie, keys.MASQUERADE_BUYER);
    return getMasqueradeValues(token);
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeSellerId = function getMasqueradeSellerId(cookie) {
    var parts = getMasqueradeSellerInfo(cookie);
    return parts ? parts.vertical.toLowerCase() + '_' + parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|null}
 */
var getMasqueradeBuyerId = function getMasqueradeBuyerId(cookie) {
    var parts = getMasqueradeBuyerInfo(cookie);
    return parts ? parts.id : null;
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getUserTokenString = function getUserTokenString(cookie) {
    return getCookieValue(cookie, keys.USER);
};

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
var getSellerTokenString = function getSellerTokenString(cookie) {
    return getCookieValue(cookie, keys.SELLER);
};

/**
 * @param {*} token seller token
 * @returns {boolean}
 */
var isSellerToken = function isSellerToken(token) {
    return (/^[fjva]_/i.test(token)
    );
};

/**
 * @param {*} token user token
 * @returns {boolean}
 */
var isBuyerToken = function isBuyerToken(token) {
    return (/^\d+_/i.test(token)
    );
};

/**
 *
 * @param {string} token user or seller token
 * @returns {string|null}
 */
var splitToken = function splitToken() {
    var token = arguments.length > 0 && arguments[0] !== undefined$1 ? arguments[0] : '';

    var parts = token.split('_');
    // an empty string will still return an array length of 1
    if (parts[0] !== '') {
        if (isSellerToken(token)) {
            return parts[0] + '_' + parts[1];
        } else if (isBuyerToken(token)) {
            // need this check otherwise an invalid
            // seller token will be used
            return parts[0];
        }
    }
    return null;
};

/**
 * based off of bunsen/libraries/bunsen#getMasqueradeAsUserId
 * The bunsen version returned an `object.userId`
 * This version only returns a string or null
 * @param {string|object} cookie
 * @param {string} type
 * @returns {string|null}
 */
var getMasqueradeUserIdByType = function getMasqueradeUserIdByType(cookie, type) {
    if (type === keys.MASQUERADE_SELLER) {
        return getMasqueradeSellerId(cookie);
    } else if (type === keys.MASQUERADE_BUYER) {
        return getMasqueradeBuyerId(cookie);
    }
    return null;
};

/**
 * @param {string} cookie
 * @param {string} [userType] The type of user masquerade info to return
 * @returns {string|null}
 */
var getMasqueradeValue = function getMasqueradeValue(cookie, userType) {
    var parsed = cookieMonster.parse(cookie);
    return getMasqueradeUserIdByType(parsed, userType) || null;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var cookieJarConstants = keys;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getPasswordReset(cookie) {
    return getCookieValue(cookie, keys.PASSWORD_RESET);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getUserType(cookie) {
    return getCookieValue(cookie, keys.USER_TYPE);
}

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getGuestId(cookie) {
    return getCookieValue(cookie, keys.GUEST_ID);
}

/**
 * backwards compatibility
 * public api method will be removed in next major release, use {@link getBuyerToken}
 * @deprecated
 * @param {string} cookie
 */
var getUserToken = getUserTokenString;

/**
 * @param {string|object} cookie
 * @returns {string|undefined}
 */
function getEverLoggedIn(cookie) {
    return getCookieValue(cookie, keys.EVER_LOGGED_IN);
}

/**
 * based off of bunsen/models/identity/User#getUserId
 * The additional change here is adding the `userType` as the bunsen
 * version only assumed the buyer. The seller is also taken into account
 * @param {string} cookie document.cookie or req.cookie string
 * @param {string} [userType] The type of user masquerade info to return
 * @param {boolean} [getRealUser] returns the actual user (usually internal) if you happen to be masquerading
 * @returns {string|null}
 */
function getUserId(cookie, userType, getRealUser) {
    console.warn('DEPRECATION WARNING: getUserId is deprecated, use getBuyerId(cookie: string, { getRealUser: boolean })');

    if (typeof cookie !== 'string') {
        throw new Error('a cookie string must be passed in. a ' + (typeof cookie === 'undefined' ? 'undefined' : _typeof(cookie)) + ' was passed passed in instead.');
    }

    var masqueradeInfo = getMasqueradeValue(cookie, userType);

    if (masqueradeInfo && !getRealUser) {
        return masqueradeInfo;
    }

    var userId = splitToken(getUserTokenString(cookie));
    return userId || null;
}

function getBuyerId(cookie) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var getRealUser = options.getRealUser;


    var masqueradedUserId = getMasqueradeUserIdByType(cookie, keys.MASQUERADE_BUYER);
    var realUserId = splitToken(getUserTokenString(cookie)) || null;

    if (getRealUser) {
        return realUserId;
    }

    return masqueradedUserId || realUserId;
}

/**
 *
 * @param {string} cookie
 * @returns {string|null}
 */
function getSellerId(cookie) {
    var sellerId = splitToken(getSellerTokenString(cookie));
    return sellerId || null;
}

/**
 *
 * @param {string} cookie
 * @returns {function}
 */
function isMasqueradingByType(cookie) {
    var userId = getBuyerId(cookie);
    /**
     * @param {string} userType
     * @returns {boolean}
     */
    return function (userType) {
        // return `false` instead of `null`
        return (userId ? userId : false) && !!getMasqueradeUserIdByType(cookie, userType);
    };
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsSeller(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_SELLER);
}

/**
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasqueradingAsBuyer(cookie) {
    return isMasqueradingByType(cookie)(keys.MASQUERADE_BUYER);
}

/**
 * based off of bunsen/helpers/actingUser#isMasquerading
 * The bunsen version would pull the buyer user info from server vars
 * There should be a `userToken` cookie value set for the internal
 * user if you are masquerading
 * @param {string} cookie
 * @returns {boolean}
 */
function isMasquerading(cookie) {
    var sellerId = isMasqueradingAsSeller(cookie);
    var buyerId = isMasqueradingAsBuyer(cookie);
    return !!(sellerId || buyerId);
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * @param {string} cookie
 * @returns {object}
 */
function getBuyerToken(cookie) {
    var userToken = getUserTokenString(cookie);
    if (userToken) {
        return {
            userToken: userToken
        };
    }
    return {};
}

/**
 * based off of bunsen#getToken, only used for admin functionality
 * sellerToken takes precedence over userToken (userToken case should
 * only be hit while masquerading)
 * @param {string} cookie
 * @returns {object}
 */
function getAdminToken(cookie) {
    // if seller token, return seller token
    var sellerToken = getSellerTokenString(cookie);
    if (sellerToken) {
        return {
            sellerToken: sellerToken
        };
    }

    // either a logged in admin user or masquerading as a seller
    // leveraging `getBuyerToken` logic
    // returns an object already
    // and will also return an empty object
    // for a falsey value
    return getBuyerToken(cookie);
}

function getAdminUser(cookie) {
    return getBuyerId(cookie, { getRealUser: true });
}

exports.cookieJarConstants = cookieJarConstants;
exports.getPasswordReset = getPasswordReset;
exports.getUserType = getUserType;
exports.getGuestId = getGuestId;
exports.getUserToken = getUserToken;
exports.getEverLoggedIn = getEverLoggedIn;
exports.getUserId = getUserId;
exports.getBuyerId = getBuyerId;
exports.getSellerId = getSellerId;
exports.isMasqueradingByType = isMasqueradingByType;
exports.isMasqueradingAsSeller = isMasqueradingAsSeller;
exports.isMasqueradingAsBuyer = isMasqueradingAsBuyer;
exports.isMasquerading = isMasquerading;
exports.getBuyerToken = getBuyerToken;
exports.getAdminToken = getAdminToken;
exports.getAdminUser = getAdminUser;


/***/ }),

/***/ "./node_modules/dibs-tracking/gas.js":
/***/ (function(module, exports) {

/*
 * File created for running jasmine tests in node.
 * Webpack config makes require call to _gas return window._gas.
 * However webpack is not used when running tests from node. Hence,
 * check if _gas exists on window (as webpack does) and return it if it exists
 * else it returns []
 */

// check for `window` since `window` is undefined if this file is run via node
module.exports = typeof window !== 'undefined' ? (window._gas || []) : [];


/***/ }),

/***/ "./node_modules/dibs-tracking/gtmDataLayer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * For Google Tag Manager
 */


var root = typeof window === 'undefined' ? global : window;
root.dataLayer = root.dataLayer || [];
module.exports = root.dataLayer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-tracking/tracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__("./node_modules/dibs-gas/index.js");

var serverVars = __webpack_require__("./node_modules/server-vars/index.js");
var _gas = __webpack_require__("./node_modules/dibs-tracking/gas.js");
var gtmDataLayer = __webpack_require__("./node_modules/dibs-tracking/gtmDataLayer.js");
var parseurl = __webpack_require__("./node_modules/parseurl/index.js");
var jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");
var Deferred = __webpack_require__("./node_modules/simply-deferred/deferred.js").Deferred;
var merge = __webpack_require__("./node_modules/deepmerge/dist/es.js");
// After being compiled with webpack, merge functions are under merge.default
// Assign to merge.default after being compiled, 
// leave as merge when running locally for tests
merge = typeof merge === 'function' ? merge : merge.default;

var undefined = void(0);
var root = typeof window === 'undefined' ? global : window;
var location = root.document ? root.document.location : {hostname: ''};
var cookieSettings = {
    path : '/',
    domain : location.hostname.split('.').slice(-2).join('.')
};

function isEmpty(value) {
    return value ? !Object.keys(value).length : true;
}

function pick(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) !== -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

function omit(data, dataKeys) {
    var newObject = {};
    Object.keys(data).forEach(function (key) {
        if (dataKeys.indexOf(key) === -1) {
            newObject[key] = data[key];
        }
    });
    return newObject;
}

/*
 *
 * SETUP 1STDIBS-SPECIFIC TRACKING HERE, DON'T PUT OUTSIDE DEPENDENCIES IN GAS.SETUP
 *
 */

// serverVars is undefined on legacy pages
// TODO: May have to do this for data layers
serverVars = serverVars || {};
var serverVarsTracking = serverVars.tracking;
var customVarLoginStr = 'login='; // used for tracking.getLoggedInStatus
var tracking = {};
var defaults = {
    'opt_label': undefined,
    'opt_value': undefined,
    'opt_noninteraction': undefined
};

// provide backward-compatibility for the legacy
// dibs.tracking.customVars array
if (serverVarsTracking) {
    tracking.customVars = serverVarsTracking.customVars || [];
}

// Boolean flags and methods used to ensure events are fired to Google Tag Manager in the correct order
// (see startTrackingEvents method description)
var gtmInitialInfoFired     = false;
var gtmInitialPageViewFired = false;
var startTrackingEvents;

var ecomParseUrl;
var ecomGetProducts;
var mergeAdditionalData;
var useShippingStatusData;
var shippingStatusDfd       = Deferred();
var gtmEventQueue           = [];
var gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo') || {};
var gtmUserAttributeKeys    = [
    'loginStatus',
    'registrationStatus',
    'userID',
    'guestID',
    'userEmail',
    'userEmailAddress',
    'emailToken',
    'userZip',
    'defaultCurrency',
    'firstSessionDate',
    'contactDealerStatus',
    'buyerStatus',
    'tradeStatus',
    'customerType',
    'tradeTier',
    'tradeFirmId'
];
var gtmContentGroupKeys     = ['pageType', 'pageSubType', 'pageLevel', 'pageSection', 'pageCategory'];
var comCustomDimensionMap = {
    dimension1  : 'timePeriod',
    dimension2  : 'creator',
    dimension8  : 'onSale',
    dimension9  : 'newListing',
    dimension11 : 'dealerName',
    dimension12 : 'dealerID',
    dimension13 : 'dealerLocation',
    dimension20 : 'itemPostingLocation',
    dimension37 : 'purchaseStatus',
    dimension38 : 'askingPrice',
    dimension76 : 'priceType'
};

/**
 * For Google Tag Manager to work properly the order in which data is added to the dataLayer is important
 *  1. initial page data/user info
 *  2. initial page view event
 *  3. any ga events fired on the page
 * This is a private function which is called by either tracking.trackPageView or tracking.addUserAttributes and
 * controls this flow of how events are fired.
 * @private
 */
startTrackingEvents = function () {
    // need to check that we aren't already tracking events so that forEach call
    // doesn't accidentally put us in an infinite loop
    if (gtmEventQueue === gtmDataLayer) {
        return;
    }

    // add each of the events in the queue to the gtmDataLayer (in fifo order)
    gtmEventQueue.forEach(function (event, index) {
        gtmDataLayer.push(event);
    });

    // change reference
    gtmEventQueue = gtmDataLayer;
};

/**
 * helper method used to parse a pdp url for an item's category level (L1/L2/L3), name and id
 * @param url
 * @returns {*}
 */
ecomParseUrl = function (url) {
    var pathArr;
    if (typeof url !== 'string') {
        return {};
    }
    // given a pdp url of the form -->
    //      https://www.1stdibs.com/{L1}/{l2}/{L3}/{product name}/id-{item pk}/?{random params}
    // set pathArr to
    //      [path, {L1/L2/L3}, {L1}, {L2}, {L3}, {product name}, {item pk}]
    pathArr = /^\/(?:([^\/]*)\/([^\/]*)(?:(?:\/([^\/]*)(?:\/([^\/]*)))|(?:\/([^\/]*))?))\/id-([^/]+)\/?$/i.exec(parseurl({url: url}).pathname);
    if (isEmpty(pathArr)) {
        return {};
    }
    // grab the item id, the product name and the uri substring for the categories
    return {
        category: [pathArr[1], pathArr[2], pathArr[3]].filter(function (elem) {
            return !!elem;
        }).join('/'),  // {L1/L2/L3}
        name: (pathArr[4] || pathArr[5] || '').split('-').join(' '),
        id: pathArr[6]
    };
};

/**
 * helper method (used in ecommerceProduct) that takes the trackObj products array and returns a product array
 * formatted for the GTM tracking object.
 * @param prodArr
 * @returns {Array}
 */
ecomGetProducts = function (productArray) {
    var outArr = [];
    var productData;
    if (productArray !== undefined && productArray.length) {
        productArray.forEach(function (product, index) {
            productData = merge(ecomParseUrl(product.url), product);
            productData = mergeAdditionalData(productData, product);
            productData = omit(productData, ['url', 'additional']);
            outArr.push(productData);
        });
    }
    return outArr;
};

/**
 * this helper function is used in tracking.trackPageView, tracking.trackSocial, and tracking.trackEvent
 * to merge additional data into the trackObject that is pushed to the dataLayer
 * @param gtmData
 * @param trackObj
 */
mergeAdditionalData = function (gtmData, trackObj) {
    var additionalData = trackObj && trackObj.additional ? trackObj.additional : {};
    return merge(gtmData, additionalData);
};

/**
 * Sets flag to ensure we wait for shipping status data to resolve before we track it
 */
tracking.setupShippingStatusTracking = function () {
    useShippingStatusData = true;
};

/**
 * Resolves the shippingStatusDfd singleton with the passed data
 */
tracking.resolveShippingStatusDfdWith = function (data) {
    shippingStatusDfd.resolve(data);
};

/**
 * check for this value at run time instead of setting it once at run time
 * @returns {boolean}
 */
tracking.isGaAllowed = function () {
    // phpstorm says this condition can be simplified
    // but it makes it less readable IMO
    // return !(serverVars.settings && serverVars.settings.allowGa === false);
    // is what it like instead
    if (serverVars.settings && serverVars.settings.allowGa === false) {
        return false;
    }
    return true;
};

/**
 * returns the logged in status of the user
 * @param {boolean} status Whether the user is logged in or not
 * @returns {string}
 */
tracking.getLoggedInStatus = function (status) {
    if (typeof status !== 'boolean') {
        return customVarLoginStr + 'n';
    }
    return customVarLoginStr + (status ? 'y' : 'n');
};

/**
 * pushes userAttributes into the dataLayer (along with the gtmPageInfo)
 * @param trackObj
 */
tracking.addUserAttributes = function addUserAttributes(trackObj) {
    var gtmUserAttributes;
    if (!isEmpty(trackObj) && !gtmInitialInfoFired) {
        // filters out invalid userAttribute keys
        gtmUserAttributes = pick(trackObj, gtmUserAttributeKeys);

        // Once the shipping status data is available, proceed setting attributes to the gtmDataLayer
        // If not using shipping status data, go forward and resolve the deferred object
        if (!useShippingStatusData) {
            shippingStatusDfd.resolve();
        }
        shippingStatusDfd.done(function (userQuoteData) {

            // pushing the initial dataLayerInfo directly to the dataLayer
            gtmDataLayer.push(merge.all([gtmUserAttributes, gtmPageInfo, userQuoteData || {}]));
            gtmInitialInfoFired = true;

            // if the pageView has not been fired then we want to wait for it to be fired to start tracking events
            if (gtmInitialPageViewFired) {
                startTrackingEvents();
            }
        });

    }
};

tracking.resetGTMPageView = function resetGTMPageView() {
    gtmInitialPageViewFired = false;
    gtmEventQueue           = [];
};

/**
 * resets the google tag manager tracking by setting all the flags back to false, recreating the event queue
 * ** FOR TESTING **
 */
tracking.resetGtmTracking = function resetGtmTracking() {
    gtmInitialInfoFired     = false;
    gtmPageInfo             = serverVars.get('tracking.initialDataLayerInfo') || {};
    this.resetGTMPageView();
};

/**
 * when tracking object is not known in client, there has to be a way
 * around setting it without using server-vars.
 */
tracking.setGtmPageInfo = function setGtmPageInfo(trackingObj) {
    gtmPageInfo = trackingObj;
};

/**
 * add/update aditional page info vars
 */
tracking.updateGtmPageInfo = function updateGtmPageInfo(trackingObj) {
    gtmPageInfo = merge(gtmPageInfo, trackingObj || {});
};

/**
 * sets te google tag manager tracking flags to true and calls startTrackingEvents()
 * ** FOR TESTING **
 */
tracking.setGtmFlagsTrue = function setGtmFlagsTrue() {
    gtmInitialInfoFired     = true;
    gtmInitialPageViewFired = true;
    startTrackingEvents();
};

/**
 * The main page view tracking call
 * @param {string || object} trackObj       Can either be the literal url or an object with a url key
 *                                          (can also be undefined in which case GTM will internally grab
 *                                          the url from the page)
 * @param {string} trackObj.url
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 *                                          added to gtmData in mergeAdditionalData(gtmData, trackObj)
 */
tracking.trackPageview = function trackPageview(trackObj) {
    var gtmData;

    // this is necessary for stale logins on checkout
    // so that the page view tracking doesn't fire twice
    if (this.isGaAllowed()) {

        gtmData = {
            'event'         : 'e_ga_pageview',
            'opt_pageURL'   : (typeof trackObj === 'object') ? trackObj.url : trackObj
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);
        gtmData.opt_pageURL = gtmData.opt_pageURL || undefined; // eslint-disable-line

        // If this is not the initial page view then just push it like a regular event
        if (gtmInitialPageViewFired) {
            gtmEventQueue.push(gtmData);

            // If it is the initial page view then add it to the beginning of the queue, switch flag
        } else {
            gtmEventQueue.unshift(gtmData);
            gtmInitialPageViewFired = true;

            // if the initial dataLayer info has not been added then we want to wait to start tracking events
            if (gtmInitialInfoFired) {
                startTrackingEvents();
            }
        }
    }
};

// TODO: REMOVE CUSTOM VARIABLE STUFF BECAUSE GA IS NO LONGER USING CUSTOM VARIABLES IN UNIVERSAL ANALYTICS
/**
 * set a custom var for google analytics.  Having one spot to set this allows for better control of determining
 * when to fire and when not to fire these events
 * FINDING-2644 - do not allow browser "previews" from firing tracking
 * https://developers.google.com/analytics/devguides/collection/gajs/gaTrackingCustomVariables
 *
 * @param {object}  trackObj        The tracking object used by google analytics
 * @param {int}     trackObj.slot   The slot number for the custom var. Defaults to 1
 * @param {string}  trackObj.name   The 2nd-level name for your online content categories
 * @param {string}  trackObj.value  The value to set trackObj.name to
 * @param {int}     trackObj.scope  The scope of the page level based on the GA docs (1, 2 or 3).  Defaults to 1
 */
tracking.setCustomVar = function setCustomVar(trackObj) {
    if (this.isGaAllowed() && !isEmpty(trackObj)) {
        _gas.push([
            '_setCustomVar',
            trackObj.slot || 1,
            trackObj.name || 'No Page Name',
            trackObj.value || 'No Page Value',
            trackObj.scope || 1
        ]);
        this.setCustomVarLocal(trackObj);
    }
};

/**
 * Sets the tracking object to a 'local' cookie representing the
 * current state of custom vars in GA
 * @param {object} trackingObj The tracking object used by google analytics
 */
tracking.setCustomVarLocal = function setCustomVarLocal(trackingObj) {
    var localCustomVars;
    jsCookie.json = true;
    localCustomVars = jsCookie.getJSON('lcv') || {};
    localCustomVars[trackingObj.slot] = trackingObj;
    jsCookie.set('lcv', localCustomVars, cookieSettings);
    delete jsCookie.json;
};

/**
 * Gets the "local" copy of the GA custom vars for the given slot
 * @param {int}     slotNumber
 *
 * @returns {object}
 */
tracking.getCustomVar = function getCustomVar(slotNumber) {
    var localCustomVars;

    jsCookie.json = true;
    localCustomVars = jsCookie.get('lcv') || {};
    delete jsCookie.json;

    return localCustomVars[slotNumber];
};

/**
 * Event tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.category    The tracking category - a way to group objects to track
 * @param {string} trackObj.action      The tracking action - typically the type of event or interaction
 * @param {string} [trackObj.label]     The tracking label - additional dimension to use for tracking
 * @param {number} [trackObj.value]     The tracking value
 * @param {boolean} [trackObj.noninteraction] Affects bounce rate (must be explicitly passed in to trigger a page view)
 *                                            - `true` (default) will not count as another page view which will mean if a user visits one page, interacts, and leaves, a bounce will be triggered (expected)
 *                                            - `false` will essentially treat the interaction as a page view and not trigger a bounce if the user leaves the page
 * @param {object} [trackObj.additional] An object with any additional key/value pairs to pass to GTM
 */
tracking.trackEvent = function trackEvent(trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_ga_event',
            'category'      : (trackObj.category || 'no category').toLowerCase(),
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};
/**
 * Form Error tracking using Google Tag Manager
 * @param trackObj
 */
tracking.trackFormError = function (trackObj) {
    var gtmData;
    if (!isEmpty(trackObj)) {
        trackObj.value          = (trackObj.value !== undefined) ? trackObj.value : 0;
        trackObj.noninteraction = (trackObj.noninteraction !== undefined) ? trackObj.noninteraction : 1;

        gtmData = {
            'event'         : 'e_form_error',
            'category'      : 'form error',
            'action'        : trackObj.action || 'no action',
            'label'         : trackObj.label || 'none',
            'value'         : trackObj.value,
            'noninteraction': trackObj.noninteraction
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Social tracking using Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.name            The social network name
 * @param {string} trackObj.event           The type of event it is firing
 * @param {object} [trackObj.additional]    An object with any additional key/value pairs to pass to GTM
 */
tracking.trackSocial = function trackSocial(trackObj) {
    var gtmData;

    if (trackObj.name && trackObj.event) {
        gtmData = {
            'event'         : 'e_ga_social',
            'network'       : trackObj.name,
            'socialAction'  : trackObj.event,
            'opt_target'    : trackObj.opt_target   || undefined,
            'opt_pagePath'  : trackObj.opt_pagePath || undefined
        };
        gtmData = mergeAdditionalData(gtmData, trackObj);

        gtmEventQueue.push(gtmData);
    }
};

/**
 * Ecommerce Tracking used in Google Tag Manager
 * @param {object} trackObj
 * @param {string} trackObj.type            - productImpression/productClick/productDetail
 * @param {Array}  trackObj.products        - an array of objects, each containing one product's info
 *                                              {   url     : product url,
 *                                                  brand   : dealer id,
 *                                                  price   : USD price     ... }
 * @param {object} [trackObj.actionField]   - an object containing additional information specific to each tracking type
 *                                          { list : list,
 *                                            step : 1      ... }
 */
tracking.trackEcommerce = function ecommerceProduct(trackObj) {
    var products;
    var ecommerce = {};

    if (!isEmpty(trackObj) && trackObj.type) {
        products = ecomGetProducts(trackObj.products);
        switch (trackObj.type) {
            case 'productImpression' :
                if (products.length) {
                    ecommerce.impressions = products;
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'productClick':
                if (trackObj.actionField && trackObj.actionField.list && products.length) {
                    ecommerce.click = {
                        'actionField' : { list : trackObj.actionField.list },
                        'products'    : products
                    };
                }
                break;
            case 'productDetail':
                if (products.length) {
                    ecommerce.detail = { 'products' : products };
                } else {
                    ecommerce = undefined;
                }
                break;
            case 'addToCart':
                if (products.length) {
                    ecommerce.add = { 'products'  : products };
                }
                break;
            case 'checkout':
                if (trackObj.actionField && trackObj.actionField.step && products.length) {
                    ecommerce.checkout = {
                        'actionField'   : { 'step' : trackObj.actionField.step },
                        'products'      : products
                    };
                    if (trackObj.option) {
                        ecommerce.checkout.option = trackObj.option;
                    }
                }
                break;
            case 'promotionImpression' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoView = { promotions : trackObj.promotions };
                }
                break;
            case 'promoClick' :
                if (trackObj.promotions && trackObj.promotions.length) {
                    ecommerce.promoClick = { promotions : trackObj.promotions };
                }
                break;
        }
        // FINDING-8606 allow ecommerce === undefined because when ecommerce
        // is undefined it removes the event from the data layer. Which stops it from
        // being tracked on every vpv
        if (!isEmpty(ecommerce) || ecommerce === undefined) {
            gtmEventQueue.push({
                'event'     : 'ecommerce_' + trackObj.type,
                'ecommerce' : ecommerce
            });
        }
    }
};

/**
 * Maps the data values to the appropriate custom dimension indexes used by google analytics
 * (e.g. returns object { dimension1 : '1900s', dimension38 : '1000' } which ga will then map on their end
 * to 'timePeriod' and 'askingPrice' respectively).
 * @param   {object} data
 * @param   {array}  [dataKeys]         optional parameter to specify which specific keys in the
 *                                      data param should be tracked.
 * @returns {object} customDimensions
 */
tracking.getCustomDimensions = function (data, dataKeys) {
    var customDimensions = {};

    if (data !== undefined) {
        // removes any key/values that are not wanted
        data = dataKeys ? pick(data, dataKeys) : data;

        // returns an object with the data object values associated with the correct dimension key
        var keys = Object.keys(comCustomDimensionMap);
        keys.forEach(function (key) {
            if (data[comCustomDimensionMap[key]] !== undefined) {
                customDimensions[key] = data[comCustomDimensionMap[key]];
            }
        });
    }

    return customDimensions;
};

/**
 * Ecommerce tracking function (specifically for tracking transactions)
 * This need to be sent to Google before userAttributes, gtmPageInfo or pageview is fired.
 * @param {object} trackObj
 * @param {array} trackObj.products
 * @param {object} trackObj.actionField
 */
tracking.trackEcommercePurchase = function (trackObj) {
    var products = ecomGetProducts(trackObj.products);
    var ecommerce = {};

    if (trackObj.actionField && products.length) {
        ecommerce.purchase = {
            'actionField'   : trackObj.actionField,
            'products'      : products
        };
    }

    if (!isEmpty(ecommerce)) {
        gtmDataLayer.push({
            'event'     : 'ecommerce_' + trackObj.type,
            'ecommerce' : ecommerce
        });
    }
};

tracking.addGTMMessage = function (message) {
    gtmDataLayer.push(message);
};

/**
 * Grabs a page's current content groupings
 * (This is needed when modals are opened and closed so that events are attributed to the correct page without firing
 * pageviews that will inflate GA's page hit numbers)
 * @return {object} contentGroupings
 */
tracking.getOriginContentGroupings = function () {
    return pick(gtmPageInfo || {}, gtmContentGroupKeys);
};

tracking.fireDummyEvent = function () {
    //we need to fire a dummy trackEvent in order to send the custom variable to the GA server
    //http://stackoverflow.com/questions/10038450/setting-a-custom-variable-in-google-analytics-after-trackpageview-is-called
    this.trackEvent({
        category: 'Dummy Event',
        action: 'Dummy Event',
        label: ''
    });
};

tracking.setDefault = function setDefault(what, toWhat) {
    var i;
    if (what && typeof what === 'object') {
        for (i in what) {
            if (what.hasOwnProperty(i)) {
                this.setDefault(i, what[i]);
            }
        }
    }
    what = '' + what;
    if (defaults.hasOwnProperty(what)) {
        defaults[what] = toWhat;
    }
};

tracking.clearDefault = function (what) {
    return this.setDefault(what, undefined);
};

module.exports = tracking;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/app-store.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
  _inherits(Component, _React$Component);

  function Component() {
    _classCallCheck(this, Component);

    return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
  }

  _createClass(Component, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'svg',
        { className: [this.props.className, 'dibsvg-svg dibsvg-app-store'].join(' '), 'data-tn': 'app-store', viewBox: '0 -47 135 135' },
        React.createElement(
          'g',
          null,
          React.createElement('path', { d: 'M130.197,40 L4.729,40 C2.122,40 0,37.872 0,35.267 L0,4.726 C0,2.12 2.122,0 4.729,0 L130.197,0 C132.803,0 135,2.12 135,4.726 L135,35.267 C135,37.872 132.803,40 130.197,40 L130.197,40 L130.197,40 Z', fill: '#404040' }),
          React.createElement('path', { d: 'M134.032,35.268 C134.032,37.384 132.318,39.098 130.198,39.098 L4.729,39.098 C2.61,39.098 0.89,37.384 0.89,35.268 L0.89,4.725 C0.89,2.61 2.61,0.89 4.729,0.89 L130.197,0.89 C132.318,0.89 134.031,2.61 134.031,4.725 L134.032,35.268 L134.032,35.268 L134.032,35.268 Z', fill: '#404040' }),
          React.createElement(
            'g',
            { transform: 'translate(12.000000, 6.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M18.128,13.784 C18.099,10.561 20.767,8.993 20.889,8.92 C19.378,6.717 17.036,6.416 16.213,6.392 C14.246,6.185 12.338,7.569 11.336,7.569 C10.314,7.569 8.771,6.412 7.108,6.446 C4.968,6.479 2.966,7.718 1.868,9.642 C-0.398,13.565 1.292,19.33 3.463,22.501 C4.549,24.054 5.818,25.788 7.479,25.727 C9.104,25.66 9.711,24.691 11.672,24.691 C13.615,24.691 14.185,25.727 15.879,25.688 C17.623,25.66 18.721,24.128 19.769,22.561 C21.024,20.781 21.528,19.028 21.548,18.938 C21.507,18.924 18.161,17.647 18.128,13.784 L18.128,13.784 Z' }),
            React.createElement('path', { d: 'M14.928,4.306 C15.802,3.213 16.4,1.726 16.234,0.217 C14.969,0.273 13.387,1.092 12.476,2.161 C11.67,3.103 10.95,4.647 11.136,6.099 C12.557,6.205 14.016,5.382 14.928,4.306 L14.928,4.306 Z' })
          ),
          React.createElement(
            'g',
            { transform: 'translate(42.000000, 18.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M11.645,13.504 L9.374,13.504 L8.13,9.595 L3.806,9.595 L2.621,13.504 L0.41,13.504 L4.694,0.196 L7.34,0.196 L11.645,13.504 L11.645,13.504 Z M7.755,7.955 L6.63,4.48 C6.511,4.125 6.288,3.289 5.959,1.973 L5.919,1.973 C5.788,2.539 5.577,3.375 5.287,4.48 L4.182,7.955 L7.755,7.955 L7.755,7.955 Z' }),
            React.createElement('path', { d: 'M22.662,8.588 C22.662,10.22 22.221,11.51 21.339,12.457 C20.549,13.3 19.568,13.721 18.397,13.721 C17.133,13.721 16.225,13.267 15.672,12.359 L15.632,12.359 L15.632,17.414 L13.5,17.414 L13.5,7.067 C13.5,6.041 13.473,4.988 13.421,3.908 L15.296,3.908 L15.415,5.429 L15.455,5.429 C16.166,4.283 17.245,3.711 18.693,3.711 C19.825,3.711 20.77,4.158 21.526,5.053 C22.284,5.949 22.662,7.127 22.662,8.588 L22.662,8.588 Z M20.49,8.666 C20.49,7.732 20.28,6.962 19.858,6.356 C19.397,5.724 18.778,5.408 18.002,5.408 C17.476,5.408 16.998,5.584 16.571,5.931 C16.143,6.281 15.863,6.738 15.732,7.304 C15.666,7.568 15.633,7.784 15.633,7.954 L15.633,9.554 C15.633,10.252 15.847,10.841 16.275,11.322 C16.703,11.803 17.259,12.043 17.943,12.043 C18.746,12.043 19.371,11.733 19.818,11.115 C20.266,10.496 20.49,9.68 20.49,8.666 L20.49,8.666 Z' }),
            React.createElement('path', { d: 'M33.699,8.588 C33.699,10.22 33.258,11.51 32.375,12.457 C31.586,13.3 30.605,13.721 29.434,13.721 C28.17,13.721 27.262,13.267 26.71,12.359 L26.67,12.359 L26.67,17.414 L24.538,17.414 L24.538,7.067 C24.538,6.041 24.511,4.988 24.459,3.908 L26.334,3.908 L26.453,5.429 L26.493,5.429 C27.203,4.283 28.282,3.711 29.731,3.711 C30.862,3.711 31.807,4.158 32.565,5.053 C33.32,5.949 33.699,7.127 33.699,8.588 L33.699,8.588 Z M31.527,8.666 C31.527,7.732 31.316,6.962 30.894,6.356 C30.433,5.724 29.816,5.408 29.039,5.408 C28.512,5.408 28.035,5.584 27.607,5.931 C27.179,6.281 26.9,6.738 26.769,7.304 C26.704,7.568 26.67,7.784 26.67,7.954 L26.67,9.554 C26.67,10.252 26.884,10.841 27.31,11.322 C27.738,11.802 28.294,12.043 28.98,12.043 C29.783,12.043 30.408,11.733 30.855,11.115 C31.303,10.496 31.527,9.68 31.527,8.666 L31.527,8.666 Z' }),
            React.createElement('path', { d: 'M46.039,9.772 C46.039,10.904 45.646,11.825 44.857,12.536 C43.99,13.313 42.783,13.701 41.232,13.701 C39.8,13.701 38.652,13.425 37.783,12.872 L38.277,11.095 C39.213,11.661 40.24,11.945 41.359,11.945 C42.162,11.945 42.787,11.763 43.236,11.401 C43.683,11.039 43.906,10.553 43.906,9.947 C43.906,9.407 43.722,8.952 43.353,8.583 C42.986,8.214 42.373,7.871 41.517,7.554 C39.187,6.685 38.023,5.412 38.023,3.738 C38.023,2.644 38.431,1.747 39.248,1.049 C40.062,0.35 41.148,0.001 42.506,0.001 C43.717,0.001 44.723,0.212 45.526,0.633 L44.993,2.371 C44.243,1.963 43.395,1.759 42.446,1.759 C41.696,1.759 41.11,1.944 40.69,2.312 C40.335,2.641 40.157,3.042 40.157,3.517 C40.157,4.043 40.36,4.478 40.768,4.82 C41.123,5.136 41.768,5.478 42.704,5.847 C43.849,6.308 44.69,6.847 45.231,7.465 C45.77,8.081 46.039,8.852 46.039,9.772 L46.039,9.772 Z' }),
            React.createElement('path', { d: 'M53.088,5.508 L50.738,5.508 L50.738,10.167 C50.738,11.352 51.152,11.944 51.982,11.944 C52.363,11.944 52.679,11.911 52.929,11.845 L52.988,13.464 C52.568,13.621 52.015,13.7 51.33,13.7 C50.488,13.7 49.83,13.443 49.355,12.93 C48.882,12.416 48.644,11.554 48.644,10.343 L48.644,5.506 L47.244,5.506 L47.244,3.906 L48.644,3.906 L48.644,2.149 L50.738,1.517 L50.738,3.906 L53.088,3.906 L53.088,5.508 L53.088,5.508 Z' }),
            React.createElement('path', { d: 'M63.691,8.627 C63.691,10.102 63.269,11.313 62.427,12.26 C61.544,13.235 60.372,13.721 58.911,13.721 C57.503,13.721 56.382,13.254 55.546,12.32 C54.71,11.386 54.292,10.207 54.292,8.786 C54.292,7.299 54.722,6.081 55.585,5.134 C56.446,4.186 57.608,3.712 59.069,3.712 C60.477,3.712 61.61,4.179 62.465,5.114 C63.283,6.021 63.691,7.192 63.691,8.627 L63.691,8.627 Z M61.479,8.696 C61.479,7.811 61.29,7.052 60.907,6.419 C60.46,5.653 59.821,5.271 58.993,5.271 C58.136,5.271 57.485,5.654 57.038,6.419 C56.655,7.053 56.466,7.824 56.466,8.736 C56.466,9.621 56.655,10.38 57.038,11.012 C57.499,11.778 58.143,12.16 58.974,12.16 C59.788,12.16 60.427,11.77 60.888,10.992 C61.281,10.347 61.479,9.58 61.479,8.696 L61.479,8.696 Z' }),
            React.createElement('path', { d: 'M70.621,5.783 C70.41,5.744 70.185,5.724 69.949,5.724 C69.199,5.724 68.619,6.007 68.211,6.574 C67.856,7.074 67.678,7.706 67.678,8.469 L67.678,13.504 L65.547,13.504 L65.567,6.93 C65.567,5.824 65.54,4.817 65.487,3.909 L67.344,3.909 L67.422,5.745 L67.481,5.745 C67.706,5.114 68.061,4.606 68.547,4.225 C69.022,3.882 69.535,3.711 70.088,3.711 C70.285,3.711 70.463,3.725 70.621,3.75 L70.621,5.783 L70.621,5.783 Z' }),
            React.createElement('path', { d: 'M80.156,8.252 C80.156,8.634 80.131,8.956 80.078,9.219 L73.682,9.219 C73.707,10.167 74.016,10.892 74.61,11.392 C75.149,11.839 75.846,12.063 76.702,12.063 C77.649,12.063 78.513,11.912 79.29,11.609 L79.624,13.089 C78.716,13.485 77.644,13.682 76.407,13.682 C74.919,13.682 73.751,13.244 72.901,12.369 C72.053,11.494 71.628,10.319 71.628,8.845 C71.628,7.398 72.023,6.193 72.814,5.232 C73.642,4.206 74.761,3.693 76.169,3.693 C77.552,3.693 78.599,4.206 79.31,5.232 C79.873,6.047 80.156,7.055 80.156,8.252 L80.156,8.252 Z M78.123,7.699 C78.137,7.067 77.998,6.521 77.709,6.06 C77.34,5.467 76.773,5.171 76.01,5.171 C75.313,5.171 74.746,5.46 74.313,6.04 C73.958,6.501 73.747,7.054 73.682,7.698 L78.123,7.698 L78.123,7.699 Z' })
          ),
          React.createElement(
            'g',
            { transform: 'translate(43.000000, 6.000000)', fill: '#000000' },
            React.createElement('path', { d: 'M6.05,4.009 C6.05,5.186 5.697,6.072 4.992,6.667 C4.339,7.216 3.411,7.491 2.209,7.491 C1.613,7.491 1.103,7.465 0.676,7.413 L0.676,0.982 C1.233,0.892 1.833,0.846 2.481,0.846 C3.626,0.846 4.489,1.095 5.071,1.593 C5.723,2.156 6.05,2.961 6.05,4.009 L6.05,4.009 Z M4.945,4.038 C4.945,3.275 4.743,2.69 4.339,2.282 C3.935,1.875 3.345,1.671 2.568,1.671 C2.238,1.671 1.957,1.693 1.724,1.739 L1.724,6.628 C1.853,6.648 2.089,6.657 2.432,6.657 C3.234,6.657 3.853,6.434 4.289,5.988 C4.725,5.542 4.945,4.892 4.945,4.038 L4.945,4.038 Z' }),
            React.createElement('path', { d: 'M11.909,5.037 C11.909,5.762 11.702,6.356 11.288,6.822 C10.854,7.301 10.279,7.54 9.561,7.54 C8.869,7.54 8.318,7.311 7.907,6.851 C7.497,6.392 7.292,5.813 7.292,5.115 C7.292,4.385 7.503,3.786 7.927,3.321 C8.351,2.856 8.921,2.623 9.639,2.623 C10.331,2.623 10.887,2.852 11.308,3.311 C11.708,3.757 11.909,4.333 11.909,5.037 L11.909,5.037 Z M10.822,5.071 C10.822,4.636 10.728,4.263 10.541,3.952 C10.321,3.576 10.008,3.388 9.601,3.388 C9.18,3.388 8.86,3.576 8.64,3.952 C8.452,4.263 8.359,4.642 8.359,5.09 C8.359,5.525 8.453,5.898 8.64,6.209 C8.867,6.585 9.183,6.773 9.591,6.773 C9.991,6.773 10.305,6.582 10.531,6.199 C10.725,5.882 10.822,5.506 10.822,5.071 L10.822,5.071 Z' }),
            React.createElement('path', { d: 'M19.765,2.719 L18.29,7.433 L17.33,7.433 L16.719,5.386 C16.564,4.875 16.438,4.367 16.34,3.863 L16.321,3.863 C16.23,4.381 16.104,4.888 15.942,5.386 L15.293,7.433 L14.322,7.433 L12.935,2.719 L14.012,2.719 L14.545,4.96 C14.674,5.49 14.78,5.995 14.865,6.473 L14.884,6.473 C14.962,6.079 15.091,5.577 15.273,4.97 L15.942,2.72 L16.796,2.72 L17.437,4.922 C17.592,5.459 17.718,5.976 17.815,6.474 L17.844,6.474 C17.915,5.989 18.022,5.472 18.164,4.922 L18.736,2.72 L19.765,2.72 L19.765,2.719 Z' }),
            React.createElement('path', { d: 'M25.198,7.433 L24.15,7.433 L24.15,4.733 C24.15,3.901 23.834,3.485 23.2,3.485 C22.889,3.485 22.638,3.599 22.443,3.828 C22.25,4.057 22.152,4.327 22.152,4.636 L22.152,7.432 L21.104,7.432 L21.104,4.066 C21.104,3.652 21.091,3.203 21.066,2.717 L21.987,2.717 L22.036,3.454 L22.065,3.454 C22.187,3.225 22.369,3.036 22.608,2.885 C22.892,2.709 23.21,2.62 23.558,2.62 C23.998,2.62 24.364,2.762 24.655,3.047 C25.017,3.396 25.198,3.917 25.198,4.609 L25.198,7.433 L25.198,7.433 Z' }),
            React.createElement('path', { d: 'M28.088,7.433 L27.041,7.433 L27.041,0.556 L28.088,0.556 L28.088,7.433 L28.088,7.433 Z' }),
            React.createElement('path', { d: 'M34.258,5.037 C34.258,5.762 34.051,6.356 33.637,6.822 C33.203,7.301 32.627,7.54 31.91,7.54 C31.217,7.54 30.666,7.311 30.256,6.851 C29.846,6.392 29.641,5.813 29.641,5.115 C29.641,4.385 29.852,3.786 30.276,3.321 C30.7,2.856 31.27,2.623 31.987,2.623 C32.68,2.623 33.235,2.852 33.657,3.311 C34.057,3.757 34.258,4.333 34.258,5.037 L34.258,5.037 Z M33.17,5.071 C33.17,4.636 33.076,4.263 32.889,3.952 C32.67,3.576 32.356,3.388 31.95,3.388 C31.528,3.388 31.208,3.576 30.989,3.952 C30.801,4.263 30.708,4.642 30.708,5.09 C30.708,5.525 30.802,5.898 30.989,6.209 C31.216,6.585 31.532,6.773 31.94,6.773 C32.34,6.773 32.653,6.582 32.879,6.199 C33.074,5.882 33.17,5.506 33.17,5.071 L33.17,5.071 Z' }),
            React.createElement('path', { d: 'M39.33,7.433 L38.389,7.433 L38.311,6.89 L38.282,6.89 C37.96,7.323 37.501,7.54 36.905,7.54 C36.46,7.54 36.1,7.397 35.829,7.113 C35.583,6.855 35.46,6.534 35.46,6.153 C35.46,5.577 35.7,5.138 36.183,4.834 C36.665,4.53 37.343,4.381 38.216,4.388 L38.216,4.3 C38.216,3.679 37.89,3.369 37.237,3.369 C36.772,3.369 36.362,3.486 36.008,3.718 L35.795,3.03 C36.233,2.759 36.774,2.623 37.412,2.623 C38.644,2.623 39.262,3.273 39.262,4.573 L39.262,6.309 C39.262,6.78 39.285,7.155 39.33,7.433 L39.33,7.433 Z M38.242,5.813 L38.242,5.086 C37.086,5.066 36.508,5.383 36.508,6.036 C36.508,6.282 36.574,6.466 36.709,6.589 C36.844,6.712 37.016,6.773 37.221,6.773 C37.451,6.773 37.666,6.7 37.862,6.555 C38.059,6.409 38.18,6.224 38.225,5.997 C38.236,5.946 38.242,5.884 38.242,5.813 L38.242,5.813 Z' }),
            React.createElement('path', { d: 'M45.285,7.433 L44.355,7.433 L44.306,6.676 L44.277,6.676 C43.98,7.252 43.474,7.54 42.763,7.54 C42.195,7.54 41.722,7.317 41.347,6.871 C40.972,6.425 40.785,5.846 40.785,5.135 C40.785,4.372 40.988,3.754 41.396,3.282 C41.791,2.842 42.275,2.622 42.851,2.622 C43.484,2.622 43.927,2.835 44.179,3.262 L44.199,3.262 L44.199,0.556 L45.248,0.556 L45.248,6.163 C45.248,6.622 45.26,7.045 45.285,7.433 L45.285,7.433 Z M44.199,5.445 L44.199,4.659 C44.199,4.523 44.189,4.413 44.17,4.329 C44.111,4.077 43.984,3.865 43.791,3.694 C43.596,3.523 43.361,3.437 43.09,3.437 C42.699,3.437 42.393,3.592 42.168,3.903 C41.945,4.214 41.832,4.611 41.832,5.096 C41.832,5.562 41.939,5.94 42.154,6.231 C42.381,6.541 42.687,6.696 43.07,6.696 C43.414,6.696 43.689,6.567 43.898,6.308 C44.1,6.069 44.199,5.781 44.199,5.445 L44.199,5.445 Z' }),
            React.createElement('path', { d: 'M54.248,5.037 C54.248,5.762 54.041,6.356 53.627,6.822 C53.193,7.301 52.619,7.54 51.9,7.54 C51.209,7.54 50.658,7.311 50.246,6.851 C49.836,6.392 49.631,5.813 49.631,5.115 C49.631,4.385 49.842,3.786 50.266,3.321 C50.69,2.856 51.26,2.623 51.979,2.623 C52.67,2.623 53.227,2.852 53.647,3.311 C54.047,3.757 54.248,4.333 54.248,5.037 L54.248,5.037 Z M53.162,5.071 C53.162,4.636 53.068,4.263 52.881,3.952 C52.66,3.576 52.348,3.388 51.94,3.388 C51.52,3.388 51.2,3.576 50.979,3.952 C50.791,4.263 50.698,4.642 50.698,5.09 C50.698,5.525 50.792,5.898 50.979,6.209 C51.206,6.585 51.522,6.773 51.93,6.773 C52.33,6.773 52.645,6.582 52.871,6.199 C53.064,5.882 53.162,5.506 53.162,5.071 L53.162,5.071 Z' }),
            React.createElement('path', { d: 'M59.883,7.433 L58.836,7.433 L58.836,4.733 C58.836,3.901 58.52,3.485 57.885,3.485 C57.574,3.485 57.323,3.599 57.129,3.828 C56.935,4.057 56.838,4.327 56.838,4.636 L56.838,7.432 L55.789,7.432 L55.789,4.066 C55.789,3.652 55.777,3.203 55.752,2.717 L56.672,2.717 L56.721,3.454 L56.75,3.454 C56.873,3.225 57.055,3.036 57.293,2.885 C57.578,2.709 57.895,2.62 58.244,2.62 C58.683,2.62 59.049,2.762 59.34,3.047 C59.703,3.396 59.883,3.917 59.883,4.609 L59.883,7.433 L59.883,7.433 Z' }),
            React.createElement('path', { d: 'M66.936,3.504 L65.782,3.504 L65.782,5.794 C65.782,6.376 65.987,6.667 66.393,6.667 C66.581,6.667 66.737,6.651 66.86,6.618 L66.887,7.413 C66.68,7.491 66.408,7.53 66.073,7.53 C65.659,7.53 65.337,7.404 65.104,7.152 C64.87,6.9 64.754,6.476 64.754,5.881 L64.754,3.504 L64.065,3.504 L64.065,2.719 L64.754,2.719 L64.754,1.855 L65.781,1.545 L65.781,2.718 L66.935,2.718 L66.935,3.504 L66.936,3.504 Z' }),
            React.createElement('path', { d: 'M72.484,7.433 L71.435,7.433 L71.435,4.753 C71.435,3.908 71.119,3.485 70.486,3.485 C70,3.485 69.668,3.73 69.486,4.22 C69.455,4.323 69.437,4.449 69.437,4.597 L69.437,7.432 L68.39,7.432 L68.39,0.556 L69.437,0.556 L69.437,3.397 L69.457,3.397 C69.787,2.88 70.26,2.622 70.873,2.622 C71.307,2.622 71.666,2.764 71.951,3.049 C72.306,3.404 72.484,3.932 72.484,4.63 L72.484,7.433 L72.484,7.433 Z' }),
            React.createElement('path', { d: 'M78.207,4.853 C78.207,5.041 78.193,5.199 78.168,5.328 L75.025,5.328 C75.039,5.794 75.189,6.149 75.48,6.395 C75.746,6.615 76.089,6.725 76.509,6.725 C76.974,6.725 77.398,6.651 77.78,6.502 L77.944,7.23 C77.497,7.424 76.971,7.521 76.362,7.521 C75.632,7.521 75.057,7.306 74.641,6.876 C74.223,6.446 74.016,5.869 74.016,5.145 C74.016,4.434 74.209,3.842 74.598,3.37 C75.004,2.866 75.553,2.614 76.246,2.614 C76.924,2.614 77.439,2.866 77.787,3.37 C78.068,3.77 78.207,4.265 78.207,4.853 L78.207,4.853 Z M77.207,4.582 C77.215,4.271 77.146,4.003 77.004,3.777 C76.822,3.486 76.545,3.34 76.17,3.34 C75.828,3.34 75.549,3.482 75.336,3.767 C75.162,3.994 75.059,4.265 75.025,4.582 L77.207,4.582 L77.207,4.582 Z' })
          )
        )
      );
    }
  }]);

  return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/arrow-down.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-arrow-down'].join(' '), 'data-tn': 'arrow-down', viewBox: '0 -8.5 32 32' },
                React.createElement('path', { d: 'M32,1c0,0.3-0.1,0.6-0.3,0.8l-15,13c-0.4,0.3-0.9,0.3-1.3,0l-15-13c-0.4-0.4-0.5-1-0.1-1.4 c0.4-0.4,1-0.5,1.4-0.1L16,12.6L30.3,0.2c0.4-0.4,1-0.3,1.4,0.1C31.9,0.5,32,0.8,32,1z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/checkmark.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-checkmark'].join(' '), 'data-tn': 'checkmark', viewBox: '0 0 250 250' },
                React.createElement('polygon', { points: '86.1,218.4 2.2,140.1 28.8,112 86.1,165.5 222.7,37.9 248.8,65.4 ' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/facebook.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-facebook'].join(' '), 'data-tn': 'facebook', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M141.7,250V135.8H180l5.7-44.3h-44.2V63.2c0-13,3.6-21.5,21.9-21.5H187v-40C183,1.1,169.1,0,152.8,0c-34,0-57.2,20.8-57.2,58.7v32.8H57.6v44.3h38.3V250H141.7L141.7,250z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/instagram.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-instagram'].join(' '), 'data-tn': 'instagram', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M32.2,0h186c17.6,0,32.1,14.5,32.1,32.2v186c0,17.7-14.5,32.1-32.1,32.1h-186C14.5,250.2,0,235.7,0,218.1v-186C0,14.5,14.5,0,32.2,0 M182.3,27.9c-6.2,0-11.3,5.1-11.3,11.3v27c0,6.2,5.1,11.3,11.3,11.3h28.3c6.2,0,11.3-5.1,11.3-11.3v-27c0-6.2-5.1-11.3-11.3-11.3H182.3z M221.9,105.8h-22c2.1,6.8,3.2,14,3.2,21.5c0,41.7-34.8,75.3-77.8,75.3s-77.8-33.7-77.8-75.3c0-7.5,1.1-14.7,3.2-21.5H27.7v105.7c0,5.5,4.5,10,10,10h174.2c5.5,0,10-4.5,10-10V105.8z M125.3,75.9c-27.8,0-50.2,21.8-50.2,48.6s22.4,48.7,50.2,48.7s50.2-21.8,50.2-48.7S153.1,75.9,125.3,75.9' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/pinterest.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-pinterest'].join(' '), 'data-tn': 'pinterest', viewBox: '0 0 250 250' },
                React.createElement('path', { d: 'M130.7,2C63.6,2,29.9,50,29.9,90c0,24.3,9.2,45.8,28.9,53.7c3.3,1.3,6.2,0,7.1-3.5c0.8-2.5,2.1-8.9,2.9-11.4c1-3.5,0.8-4.8-2.1-7.7c-5.6-6.7-9.4-15.4-9.4-27.7c0-35.6,26.6-67.6,69.5-67.6c37.9,0,58.7,23.1,58.7,53.9c0,40.8-17.9,74.9-44.9,74.9c-14.6,0-25.8-12.1-22.1-27c4.2-17.9,12.5-37,12.5-50.1c0-11.7-6.2-21.2-19.1-21.2c-15,0-27.2,15.8-27.2,36.6c0,13.3,4.6,22.3,4.6,22.3s-15.6,65.5-18.1,76.8c-5.2,22.7-0.8,50.7-0.6,53.5c0.2,1.7,2.3,2.1,3.3,0.8c1.3-1.9,19.5-24.1,25.6-46.2c1.7-6.2,9.8-38.9,9.8-38.9c4.8,9.4,19.3,17.5,34.5,17.5c45.3,0,76.1-41.2,76.1-96.7C220,40.7,184.6,2,130.7,2z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-vg/dist/react/twitter.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            return React.createElement(
                'svg',
                { className: [this.props.className, 'dibsvg-svg dibsvg-twitter'].join(' '), 'data-tn': 'twitter', viewBox: '0 -40 613 613' },
                React.createElement('path', { d: 'M0,441.8h29.9c60.4,0,113.8-16.8,160.1-50c-53.7-1.2-99.2-39-120.2-91.2c5.8,3.3,13.7,5.2,23.2,5.2c3.9,0,10.4-1,18.9-2.7 c8.2-1.5,14-2.5,17.4-2.5c-60.1-10.1-105-60.7-105-123c17.4,7,22.3,9.4,36.9,12.1c7.3,1.5,15,2.1,22.9,2.1 c-35.1-22-59.8-61.9-59.8-101.3c0-30.2,5.2-48.2,19.9-68.7c60.7,78.5,154.6,127.9,255,134.9c0-3.9-0.4-9.2-0.6-15.6 c-0.4-6.4-0.6-11-0.6-14.3c0-45.5,25.4-87.5,63.5-110.1C380.7,5.5,400.8,0,422.3,0c34.8,0,67.1,13.5,97,40.6 c17-2.1,33-8.2,55.2-18.3c11-5.2,18.9-8.6,23.5-10.4c-9.4,27.1-28.1,46.7-60.1,68.9c29.6-3.1,54.6-10.1,75-20.7 c-13.1,22.9-32.6,45.1-58.6,66.8v15c0,54.9-15.2,112.3-42.4,165.6c-27.1,53.3-71.1,101-122.6,136.1S268.5,500,194.3,500 C123.8,500,58.9,480.5,0,441.8z' })
            );
        }
    }]);

    return Component;
}(React.Component);

module.exports = Component;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackPreRegistrationPageVisit = exports.clearSourceAttribution = exports.getSourceAttribution = exports.VisitorTracking = exports.VisitCountModel = undefined;

var _visitCountModel = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountModel.js");

var _visitCountModel2 = _interopRequireDefault(_visitCountModel);

var _visitorTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitorTracking.js");

var _visitorTracking2 = _interopRequireDefault(_visitorTracking);

var _sourceAttribution = __webpack_require__("./node_modules/dibs-visit-tracking/dist/sourceAttribution.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.VisitCountModel = _visitCountModel2.default;
exports.VisitorTracking = _visitorTracking2.default;
exports.getSourceAttribution = _sourceAttribution.getSourceAttribution;
exports.clearSourceAttribution = _sourceAttribution.clearSourceAttribution;
exports.trackPreRegistrationPageVisit = _sourceAttribution.trackPreRegistrationPageVisit;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/sourceAttribution.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSourceAttribution = getSourceAttribution;
exports.clearSourceAttribution = clearSourceAttribution;
exports.trackPreRegistrationPageVisit = trackPreRegistrationPageVisit;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _visitCountConstants = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER;


function prepareTimeNr(number) {
    var num = Math.abs(Math.floor(number));
    return (num < 10 ? '0' : '') + num;
};

function getDateTime() {
    var now = new Date();
    var timezoneOffset = -now.getTimezoneOffset();
    var dif = timezoneOffset >= 0 ? '+' : '-';

    var date = now.getFullYear() + '-' + prepareTimeNr(now.getMonth() + 1) + '-' + prepareTimeNr(now.getDate()) + 'T' + prepareTimeNr(now.getHours()) + ':' + prepareTimeNr(now.getMinutes()) + ':' + prepareTimeNr(now.getSeconds()) + '.' + now.getMilliseconds() + dif + prepareTimeNr(timezoneOffset / 60) + ':' + prepareTimeNr(timezoneOffset % 60);

    return {
        date: date,
        time: now.getTime()
    };
};

function getSourceAttributionFromStorage() {
    return _dibsBrowserStorage2.default.localStorage.getItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT) || [];
};

function prepareSourceAttributionToSave(element) {
    delete element.time;
    return element;
};

function getSourceAttribution() {
    var sourceAttribution = getSourceAttributionFromStorage();
    return sourceAttribution.map(prepareSourceAttributionToSave);
};

function clearSourceAttribution() {
    _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT);
}

function trackPreRegistrationPageVisit(page) {
    if ((0, _dibsCookieJar.getUserId)(document.cookie, MASQUERADE_BUYER)) {
        return;
    }

    page = page || window.location.pathname;
    var sourceAttribution = getSourceAttributionFromStorage();
    var attributionElement = sourceAttribution.filter(function (_ref) {
        var landingPage = _ref.utmParams.landingPage;
        return landingPage === page;
    })[0];

    if (attributionElement) {
        attributionElement.utmParams.visitCount++;

        Object.assign(attributionElement, getDateTime());
    } else {
        var atribution = Object.assign(getDateTime(), {
            type: _visitCountConstants.TYPE_PRE_REGISTRATION_PAGE_VISIT,
            utmParams: {
                landingPage: page,
                visitCount: 1
            }
        });
        sourceAttribution.push(atribution);
    }

    sourceAttribution = sourceAttribution.sort(function (a, b) {
        if (a.time < b.time) {
            return 1;
        } else if (a.time > b.time) {
            return -1;
        }
        return 0;
    }).slice(0, _visitCountConstants.CAP_PRE_REGISTRATION_PAGE_VISIT);

    _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PRE_REGISTRATION_PAGE_VISIT, sourceAttribution);
};

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitCountConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * number of (non iframe) page views per session before login/registration auto prompt
 */
var VISITS_PER_SESSION_LOGIN_PROMPT = exports.VISITS_PER_SESSION_LOGIN_PROMPT = 3;

/**
 * length of time before local storage values "expire" as session values
 * 4 hrs: (4 * 60 minutes x 60 seconds * 1000 milliseconds)
 */
var PSEUDO_SESSION_EXPIRES_AT = exports.PSEUDO_SESSION_EXPIRES_AT = 14400000;

var KEY_STORAGE = exports.KEY_STORAGE = 'visitCount';
var KEY_PSEUDO_SESSION_STORAGE = exports.KEY_PSEUDO_SESSION_STORAGE = 'pseudoSessionVisitCount';
var KEY_PRE_REGISTRATION_PAGE_VISIT = exports.KEY_PRE_REGISTRATION_PAGE_VISIT = '_dibsPreRegistrationPageVisit';
var TYPE_PRE_REGISTRATION_PAGE_VISIT = exports.TYPE_PRE_REGISTRATION_PAGE_VISIT = 'PRE_REGISTRATION_PAGE_VISIT';
var CAP_PRE_REGISTRATION_PAGE_VISIT = exports.CAP_PRE_REGISTRATION_PAGE_VISIT = 100;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitCountModel.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsBrowserStorage2 = _interopRequireDefault(_dibsBrowserStorage);

var _visitCountConstants = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitCountModel = function () {
    function VisitCountModel() {
        _classCallCheck(this, VisitCountModel);

        this.data = {
            totalVisitCount: 0,
            session: 0,
            sinceRegPrompt: 0,
            regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
            pseudoSessionExpiration: _visitCountConstants.PSEUDO_SESSION_EXPIRES_AT,
            gaSessionPageCount: 0,
            priorPagePdp: 0,
            gaTrackerEventFired: 0
        };

        if (_dibsBrowserStorage2.default.localStorage) {
            this.parseIntStorageData(_visitCountConstants.KEY_STORAGE);
            this.parseIntStorageData(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);

            if (this.isPseudoSessionExpired()) {
                this.data = {
                    session: 0,
                    regPromptLimit: _visitCountConstants.VISITS_PER_SESSION_LOGIN_PROMPT,
                    gaSessionPageCount: 0,
                    priorPagePdp: 0,
                    gaTrackerEventFired: 0
                };
            }
        }
    }

    /**
     * checks to see if time stamp on "session" storage has expired
     * @returns {boolean}
     */


    _createClass(VisitCountModel, [{
        key: 'isPseudoSessionExpired',
        value: function isPseudoSessionExpired() {
            var limit = this.data.pseudoSessionExpiration;
            var now = new Date().getTime();
            // if no timestamp assume it's brand new
            return now - (this.data.pseudoTimeStamp || now) >= limit;
        }

        /**
         * fetches an object from local storage and parses its fields to integers
         * @param key {string} the key in local storage
         */

    }, {
        key: 'parseIntStorageData',
        value: function parseIntStorageData(key) {
            var _this = this;

            var source = _dibsBrowserStorage2.default.localStorage;

            var data = source.getItem(key) || {};

            // parseInt over all fields
            Object.keys(data).forEach(function (field) {
                var values = parseInt(data[field], 10) || 0;
                _this.set(field, values);
            });
        }

        /**
         * gets value from class object
         *  @param field {string} - class object property
         *  @returns object property
         */

    }, {
        key: 'get',
        value: function get(field) {
            return this.data[field];
        }

        /**
         * sets value to class object
         * @params field {string}
         * @params value {number}
         */

    }, {
        key: 'set',
        value: function set(field, value) {
            this.data[field] = value;
        }

        /**
        * increments tracking related visitor model values
        */

    }, {
        key: 'incrementTracking',
        value: function incrementTracking() {
            var _this2 = this;

            var incrementValues = ['session', 'totalVisitCount', 'sinceRegPrompt', 'gaSessionPageCount'];
            incrementValues.forEach(function (value) {
                _this2.increment(value);
            });
        }

        /**
         * increments a field by 1
         * @param field {string}
         */

    }, {
        key: 'increment',
        value: function increment(field) {
            var val = this.get(field) || 0;
            this.set(field, val + 1);
        }

        /**
         * saves visit counts to local and session storage
         */

    }, {
        key: 'save',
        value: function save() {
            var localData = {
                totalVisitCount: this.get('totalVisitCount'),
                sinceRegPrompt: this.get('sinceRegPrompt'),
                regPromptLimit: this.get('regPromptLimit')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_STORAGE, localData);

            var pseudoSessionData = {
                session: this.get('session'),
                pseudoTimeStamp: new Date().getTime(),
                gaSessionPageCount: this.get('gaSessionPageCount'),
                priorPagePdp: this.get('priorPagePdp'),
                gaTrackerEventFired: this.get('gaTrackerEventFired')
            };

            _dibsBrowserStorage2.default.localStorage.setItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE, pseudoSessionData);
        }

        /**
         * removes visit counts from session and local storage
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_STORAGE);
            _dibsBrowserStorage2.default.localStorage.deleteItem(_visitCountConstants.KEY_PSEUDO_SESSION_STORAGE);
        }
    }]);

    return VisitCountModel;
}();

exports.default = VisitCountModel;

/***/ }),

/***/ "./node_modules/dibs-visit-tracking/dist/visitorTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _visitCountModel = __webpack_require__("./node_modules/dibs-visit-tracking/dist/visitCountModel.js");

var _visitCountModel2 = _interopRequireDefault(_visitCountModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VisitorTracking = function () {
    function VisitorTracking() {
        _classCallCheck(this, VisitorTracking);

        this.model = new _visitCountModel2.default();

        this.model.incrementTracking();
        this.checkPdpEngaged(document);
        this.trackNonBouncePdp(_dibsTracking2.default);
        this.model.save();
    }

    /**
     * Was the prior page pdp?
     *
     * @param document
     * @property {number} priorPagePdp - is prior page PDP
     */


    _createClass(VisitorTracking, [{
        key: 'checkPdpEngaged',
        value: function checkPdpEngaged(document) {
            var value = 0;
            if (this.wasInPreviousUrl(document, '1stdibs.com') && this.wasInPreviousUrl(document, 'id-') || document.location.href.indexOf('id-') > -1) {
                value = 1;
            }
            this.model.set('priorPagePdp', value);
        }

        /**
         * check if nonBound Pdp Tracking event can be fired
         * @returns {boolean}
         */

    }, {
        key: 'canFireNonBoundPdpTracking',
        value: function canFireNonBoundPdpTracking() {
            return !this.model.get('gaTrackerEventFired') && this.model.get('priorPagePdp') && this.model.get('gaSessionPageCount') >= 2;
        }

        /**
         * @param  {Object} gaTracker [dibs-tracking wrapper around google analytics that fires events]
         * @return {None}
         */

    }, {
        key: 'trackNonBouncePdp',
        value: function trackNonBouncePdp(gaTracker) {
            if (this.canFireNonBoundPdpTracking()) {
                gaTracker.trackEvent({
                    'category': 'adwords',
                    'action': 'session type',
                    'label': 'nbpdp'
                });
                this.model.set('gaTrackerEventFired', 1);
            }
        }

        /**
         * Is the text in the url?
         * @returns {boolean}
         */

    }, {
        key: 'wasInPreviousUrl',
        value: function wasInPreviousUrl(document, linkText) {
            return document.referrer.indexOf(linkText) > -1;
        }
    }]);

    return VisitorTracking;
}();

exports.default = VisitorTracking;

/***/ }),

/***/ "./node_modules/element-class/index.js":
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),

/***/ "./node_modules/fbjs/lib/areEqual.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(38);

/***/ }),

/***/ "./node_modules/is-buffer/index.js":
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),

/***/ "./node_modules/isomorphic-fetch/fetch-npm-browserify.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(409);

/***/ }),

/***/ "./node_modules/js-cookie/src/js.cookie.js":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ "./node_modules/lodash.get/index.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/md5/md5.js":
/***/ (function(module, exports, __webpack_require__) {

(function(){
  var crypt = __webpack_require__("./node_modules/crypt/crypt.js"),
      utf8 = __webpack_require__("./node_modules/charenc/charenc.js").utf8,
      isBuffer = __webpack_require__("./node_modules/is-buffer/index.js"),
      bin = __webpack_require__("./node_modules/charenc/charenc.js").bin,

  // The core
  md5 = function (message, options) {
    // Convert to byte array
    if (message.constructor == String)
      if (options && options.encoding === 'binary')
        message = bin.stringToBytes(message);
      else
        message = utf8.stringToBytes(message);
    else if (isBuffer(message))
      message = Array.prototype.slice.call(message, 0);
    else if (!Array.isArray(message))
      message = message.toString();
    // else, assume byte array already

    var m = crypt.bytesToWords(message),
        l = message.length * 8,
        a =  1732584193,
        b = -271733879,
        c = -1732584194,
        d =  271733878;

    // Swap endian
    for (var i = 0; i < m.length; i++) {
      m[i] = ((m[i] <<  8) | (m[i] >>> 24)) & 0x00FF00FF |
             ((m[i] << 24) | (m[i] >>>  8)) & 0xFF00FF00;
    }

    // Padding
    m[l >>> 5] |= 0x80 << (l % 32);
    m[(((l + 64) >>> 9) << 4) + 14] = l;

    // Method shortcuts
    var FF = md5._ff,
        GG = md5._gg,
        HH = md5._hh,
        II = md5._ii;

    for (var i = 0; i < m.length; i += 16) {

      var aa = a,
          bb = b,
          cc = c,
          dd = d;

      a = FF(a, b, c, d, m[i+ 0],  7, -680876936);
      d = FF(d, a, b, c, m[i+ 1], 12, -389564586);
      c = FF(c, d, a, b, m[i+ 2], 17,  606105819);
      b = FF(b, c, d, a, m[i+ 3], 22, -1044525330);
      a = FF(a, b, c, d, m[i+ 4],  7, -176418897);
      d = FF(d, a, b, c, m[i+ 5], 12,  1200080426);
      c = FF(c, d, a, b, m[i+ 6], 17, -1473231341);
      b = FF(b, c, d, a, m[i+ 7], 22, -45705983);
      a = FF(a, b, c, d, m[i+ 8],  7,  1770035416);
      d = FF(d, a, b, c, m[i+ 9], 12, -1958414417);
      c = FF(c, d, a, b, m[i+10], 17, -42063);
      b = FF(b, c, d, a, m[i+11], 22, -1990404162);
      a = FF(a, b, c, d, m[i+12],  7,  1804603682);
      d = FF(d, a, b, c, m[i+13], 12, -40341101);
      c = FF(c, d, a, b, m[i+14], 17, -1502002290);
      b = FF(b, c, d, a, m[i+15], 22,  1236535329);

      a = GG(a, b, c, d, m[i+ 1],  5, -165796510);
      d = GG(d, a, b, c, m[i+ 6],  9, -1069501632);
      c = GG(c, d, a, b, m[i+11], 14,  643717713);
      b = GG(b, c, d, a, m[i+ 0], 20, -373897302);
      a = GG(a, b, c, d, m[i+ 5],  5, -701558691);
      d = GG(d, a, b, c, m[i+10],  9,  38016083);
      c = GG(c, d, a, b, m[i+15], 14, -660478335);
      b = GG(b, c, d, a, m[i+ 4], 20, -405537848);
      a = GG(a, b, c, d, m[i+ 9],  5,  568446438);
      d = GG(d, a, b, c, m[i+14],  9, -1019803690);
      c = GG(c, d, a, b, m[i+ 3], 14, -187363961);
      b = GG(b, c, d, a, m[i+ 8], 20,  1163531501);
      a = GG(a, b, c, d, m[i+13],  5, -1444681467);
      d = GG(d, a, b, c, m[i+ 2],  9, -51403784);
      c = GG(c, d, a, b, m[i+ 7], 14,  1735328473);
      b = GG(b, c, d, a, m[i+12], 20, -1926607734);

      a = HH(a, b, c, d, m[i+ 5],  4, -378558);
      d = HH(d, a, b, c, m[i+ 8], 11, -2022574463);
      c = HH(c, d, a, b, m[i+11], 16,  1839030562);
      b = HH(b, c, d, a, m[i+14], 23, -35309556);
      a = HH(a, b, c, d, m[i+ 1],  4, -1530992060);
      d = HH(d, a, b, c, m[i+ 4], 11,  1272893353);
      c = HH(c, d, a, b, m[i+ 7], 16, -155497632);
      b = HH(b, c, d, a, m[i+10], 23, -1094730640);
      a = HH(a, b, c, d, m[i+13],  4,  681279174);
      d = HH(d, a, b, c, m[i+ 0], 11, -358537222);
      c = HH(c, d, a, b, m[i+ 3], 16, -722521979);
      b = HH(b, c, d, a, m[i+ 6], 23,  76029189);
      a = HH(a, b, c, d, m[i+ 9],  4, -640364487);
      d = HH(d, a, b, c, m[i+12], 11, -421815835);
      c = HH(c, d, a, b, m[i+15], 16,  530742520);
      b = HH(b, c, d, a, m[i+ 2], 23, -995338651);

      a = II(a, b, c, d, m[i+ 0],  6, -198630844);
      d = II(d, a, b, c, m[i+ 7], 10,  1126891415);
      c = II(c, d, a, b, m[i+14], 15, -1416354905);
      b = II(b, c, d, a, m[i+ 5], 21, -57434055);
      a = II(a, b, c, d, m[i+12],  6,  1700485571);
      d = II(d, a, b, c, m[i+ 3], 10, -1894986606);
      c = II(c, d, a, b, m[i+10], 15, -1051523);
      b = II(b, c, d, a, m[i+ 1], 21, -2054922799);
      a = II(a, b, c, d, m[i+ 8],  6,  1873313359);
      d = II(d, a, b, c, m[i+15], 10, -30611744);
      c = II(c, d, a, b, m[i+ 6], 15, -1560198380);
      b = II(b, c, d, a, m[i+13], 21,  1309151649);
      a = II(a, b, c, d, m[i+ 4],  6, -145523070);
      d = II(d, a, b, c, m[i+11], 10, -1120210379);
      c = II(c, d, a, b, m[i+ 2], 15,  718787259);
      b = II(b, c, d, a, m[i+ 9], 21, -343485551);

      a = (a + aa) >>> 0;
      b = (b + bb) >>> 0;
      c = (c + cc) >>> 0;
      d = (d + dd) >>> 0;
    }

    return crypt.endian([a, b, c, d]);
  };

  // Auxiliary functions
  md5._ff  = function (a, b, c, d, x, s, t) {
    var n = a + (b & c | ~b & d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._gg  = function (a, b, c, d, x, s, t) {
    var n = a + (b & d | c & ~d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._hh  = function (a, b, c, d, x, s, t) {
    var n = a + (b ^ c ^ d) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };
  md5._ii  = function (a, b, c, d, x, s, t) {
    var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
    return ((n << s) | (n >>> (32 - s))) + b;
  };

  // Package private blocksize
  md5._blocksize = 16;
  md5._digestsize = 16;

  module.exports = function (message, options) {
    if (message === undefined || message === null)
      throw new Error('Illegal argument ' + message);

    var digestbytes = crypt.wordsToBytes(md5(message, options));
    return options && options.asBytes ? digestbytes :
        options && options.asString ? bin.bytesToString(digestbytes) :
        crypt.bytesToHex(digestbytes);
  };

})();


/***/ }),

/***/ "./node_modules/merge-theme-hoc/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _withProps = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/withProps.js");

var _withProps2 = _interopRequireDefault(_withProps);

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _classnames = __webpack_require__("./node_modules/classnames/index.js");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function mergeTheme(injectedTheme) {
    return function (BaseComponent) {
        var Themed = (0, _withProps2.default)(function (ownProps) {
            var theme = injectedTheme;
            if (ownProps && ownProps.theme) {
                var ownTheme = ownProps.theme;
                theme = Object.keys(ownTheme).filter(function (key) {
                    return !!injectedTheme[key];
                }).reduce(function (accum, key) {
                    accum[key] = (0, _classnames2.default)(ownTheme[key], injectedTheme[key]);
                    return accum;
                }, _extends({}, ownTheme, injectedTheme));
            }
            return { theme: theme };
        })(BaseComponent);
        (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'themed'))(Themed);
        return Themed;
    };
}

exports.default = mergeTheme;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/createEagerFactory.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createEagerElementUtil = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/utils/createEagerElementUtil.js");

var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);

var _isReferentiallyTransparentFunctionComponent = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/isReferentiallyTransparentFunctionComponent.js");

var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createFactory = function createFactory(type) {
  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
  return function (p, c) {
    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
  };
};

exports.default = createFactory;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/getDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

exports.default = getDisplayName;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/isClassComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

exports.default = isClassComponent;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/isReferentiallyTransparentFunctionComponent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isClassComponent = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/isClassComponent.js");

var _isClassComponent2 = _interopRequireDefault(_isClassComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && ("production" === 'production' || !Component.propTypes));
};

exports.default = isReferentiallyTransparentFunctionComponent;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/mapProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _createEagerFactory = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/createEagerFactory.js");

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = (0, _createEagerFactory2.default)(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

exports.default = mapProps;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setStatic = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setStatic.js");

var _setStatic2 = _interopRequireDefault(_setStatic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic2.default)('displayName', displayName);
};

exports.default = setDisplayName;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/setStatic.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

exports.default = setStatic;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/utils/createEagerElementUtil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
  if (!hasKey && isReferentiallyTransparent) {
    if (children) {
      return type(_extends({}, props, { children: children }));
    }
    return type(props);
  }

  var Component = type;

  if (children) {
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  }

  return _react2.default.createElement(Component, props);
};

exports.default = createEagerElementUtil;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/withProps.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _wrapDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js");

var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);

var _setDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/setDisplayName.js");

var _setDisplayName2 = _interopRequireDefault(_setDisplayName);

var _mapProps = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/mapProps.js");

var _mapProps2 = _interopRequireDefault(_mapProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withProps = function withProps(input) {
  var hoc = (0, _mapProps2.default)(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

exports.default = withProps;

/***/ }),

/***/ "./node_modules/merge-theme-hoc/node_modules/recompose/wrapDisplayName.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getDisplayName = __webpack_require__("./node_modules/merge-theme-hoc/node_modules/recompose/getDisplayName.js");

var _getDisplayName2 = _interopRequireDefault(_getDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
};

exports.default = wrapDisplayName;

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/punycode/punycode.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/module.js")(module), __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/url/url.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__("./node_modules/node-libs-browser/node_modules/punycode/punycode.js");
var util = __webpack_require__("./node_modules/node-libs-browser/node_modules/url/util.js");

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/url/util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),

/***/ "./node_modules/parseurl/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * parseurl
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2014-2017 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var url = __webpack_require__("./node_modules/node-libs-browser/node_modules/url/url.js")
var parse = url.parse
var Url = url.Url

/**
 * Module exports.
 * @public
 */

module.exports = parseurl
module.exports.original = originalurl

/**
 * Parse the `req` url with memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function parseurl (req) {
  var url = req.url

  if (url === undefined) {
    // URL is undefined
    return undefined
  }

  var parsed = req._parsedUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedUrl = parsed)
};

/**
 * Parse the `req` original url with fallback and memoization.
 *
 * @param {ServerRequest} req
 * @return {Object}
 * @public
 */

function originalurl (req) {
  var url = req.originalUrl

  if (typeof url !== 'string') {
    // Fallback
    return parseurl(req)
  }

  var parsed = req._parsedOriginalUrl

  if (fresh(url, parsed)) {
    // Return cached URL parse
    return parsed
  }

  // Parse the URL
  parsed = fastparse(url)
  parsed._raw = url

  return (req._parsedOriginalUrl = parsed)
};

/**
 * Parse the `str` url with fast-path short-cut.
 *
 * @param {string} str
 * @return {Object}
 * @private
 */

function fastparse (str) {
  if (typeof str !== 'string' || str.charCodeAt(0) !== 0x2f /* / */) {
    return parse(str)
  }

  var pathname = str
  var query = null
  var search = null

  // This takes the regexp from https://github.com/joyent/node/pull/7878
  // Which is /^(\/[^?#\s]*)(\?[^#\s]*)?$/
  // And unrolls it into a for loop
  for (var i = 1; i < str.length; i++) {
    switch (str.charCodeAt(i)) {
      case 0x3f: /* ?  */
        if (search === null) {
          pathname = str.substring(0, i)
          query = str.substring(i + 1)
          search = str.substring(i)
        }
        break
      case 0x09: /* \t */
      case 0x0a: /* \n */
      case 0x0c: /* \f */
      case 0x0d: /* \r */
      case 0x20: /*    */
      case 0x23: /* #  */
      case 0xa0:
      case 0xfeff:
        return parse(str)
    }
  }

  var url = Url !== undefined
    ? new Url()
    : {}
  url.path = str
  url.href = str
  url.pathname = pathname
  url.query = query
  url.search = search

  return url
}

/**
 * Determine if parsed is still fresh for url.
 *
 * @param {string} url
 * @param {object} parsedUrl
 * @return {boolean}
 * @private
 */

function fresh (url, parsedUrl) {
  return typeof parsedUrl === 'object' &&
    parsedUrl !== null &&
    (Url === undefined || parsedUrl instanceof Url) &&
    parsedUrl._raw === url
}


/***/ }),

/***/ "./node_modules/prop-types/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(48);

/***/ }),

/***/ "./node_modules/querystring-es3/decode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),

/***/ "./node_modules/querystring-es3/encode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),

/***/ "./node_modules/querystring-es3/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__("./node_modules/querystring-es3/decode.js");
exports.encode = exports.stringify = __webpack_require__("./node_modules/querystring-es3/encode.js");


/***/ }),

/***/ "./node_modules/react-dom/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(428);

/***/ }),

/***/ "./node_modules/react-intl/lib/index.es.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(429);

/***/ }),

/***/ "./node_modules/react-portal/build/portal.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27
};

var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleKeydown = _this.handleKeydown.bind(_this);
    _this.portal = null;
    _this.node = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleKeydown);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.state.active) {
        return;
      }
      this.openPortal();
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true });
      this.renderPortal(props);
      this.props.onOpen(this.node);
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this2 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var resetPortalState = function resetPortalState(overrideIsUnmounted) {
        if (_this2.node) {
          _reactDom2.default.unmountComponentAtNode(_this2.node);
          document.body.removeChild(_this2.node);
        }
        _this2.portal = null;
        _this2.node = null;

        var finalIsUnmounted = overrideIsUnmounted === undefined ? isUnmounted : overrideIsUnmounted;

        if (finalIsUnmounted !== true) {
          _this2.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleKeydown',
    value: function handleKeydown(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, { closePortal: this.closePortal });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, { onClick: this.handleWrapperClick });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

exports.default = Portal;


Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};
module.exports = exports['default'];


/***/ }),

/***/ "./node_modules/react-redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(437);

/***/ }),

/***/ "./node_modules/react-relay/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(440);

/***/ }),

/***/ "./node_modules/react/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(13);

/***/ }),

/***/ "./node_modules/redux-thunk/lib/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),

/***/ "./node_modules/redux/es/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(198);

/***/ }),

/***/ "./node_modules/relay-query-lookup-renderer/dist/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__("./node_modules/react/index.js");
var PropTypes = __webpack_require__("./node_modules/prop-types/index.js");
var areEqual = __webpack_require__("./node_modules/fbjs/lib/areEqual.js");
var deepFreeze = __webpack_require__("./node_modules/deep-freeze/index.js");

/**
 * @public
 *
 * Orchestrates fetching and rendering data for a single view or view hierarchy:
 * - Fetches the query/variables using the given network implementation.
 * - Normalizes the response(s) to that query, publishing them to the given
 *   store.
 * - Renders the pending/fail/success states with the provided render function.
 * - Subscribes for updates to the root data and re-renders with any changes.
 */
var ReactRelayQueryRenderer = function (_React$Component) {
    _inherits(ReactRelayQueryRenderer, _React$Component);

    function ReactRelayQueryRenderer(props, context) {
        _classCallCheck(this, ReactRelayQueryRenderer);

        var _this = _possibleConstructorReturn(this, (ReactRelayQueryRenderer.__proto__ || Object.getPrototypeOf(ReactRelayQueryRenderer)).call(this, props, context));

        _this._onChange = function (snapshot) {
            _this.setState({
                readyState: _extends({}, _this.state.readyState, {
                    props: snapshot.data
                })
            });
        };

        _this._pendingFetch = null;
        _this._rootSubscription = null;
        _this._selectionReference = null;

        _this.state = {
            readyState: _this._fetchForProps(props)
        };
        return _this;
    }

    _createClass(ReactRelayQueryRenderer, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.query !== this.props.query || nextProps.environment !== this.props.environment || !areEqual(nextProps.variables, this.props.variables)) {
                this.setState({
                    readyState: this._fetchForProps(nextProps)
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._release();
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextProps.render !== this.props.render || nextState.readyState !== this.state.readyState;
        }
    }, {
        key: '_release',
        value: function _release() {
            if (this._pendingFetch) {
                this._pendingFetch.dispose();
                this._pendingFetch = null;
            }
            if (!this.props.retain && this._rootSubscription) {
                this._rootSubscription.dispose();
                this._rootSubscription = null;
            }
            if (!this.props.retain && this._selectionReference) {
                this._selectionReference.dispose();
                this._selectionReference = null;
            }
        }
    }, {
        key: '_fetchForProps',
        value: function _fetchForProps(props) {
            var _this2 = this;

            // TODO (#16225453) QueryRenderer works with old and new environment, but
            // the flow typing doesn't quite work abstracted.
            var environment = props.environment;

            var query = props.query,
                variables = props.variables;

            if (query) {
                var _environment$unstable = environment.unstable_internal,
                    createOperationSelector = _environment$unstable.createOperationSelector,
                    getOperation = _environment$unstable.getOperation;

                var operation = createOperationSelector(getOperation(query), variables);
                this._relayContext = {
                    environment: environment,
                    variables: operation.variables
                };
                if (props.lookup && environment.check(operation.root)) {
                    this._selectionReference = environment.retain(operation.root);

                    // data is available in the store, render without making any requests
                    var snapshot = environment.lookup(operation.fragment);
                    return {
                        error: null,
                        props: snapshot.data,
                        retry: function retry() {
                            _this2._fetch(operation, props.cacheConfig);
                        }
                    };
                } else {
                    return this._fetch(operation, props.cacheConfig) || getDefaultState();
                }
            } else {
                this._relayContext = {
                    environment: environment,
                    variables: variables
                };
                this._release();
                return {
                    error: null,
                    props: {},
                    retry: null
                };
            }
        }
    }, {
        key: '_fetch',
        value: function _fetch(operation, cacheConfig) {
            var _this3 = this;

            var environment = this._relayContext.environment;

            // Immediately retain the results of the new query to prevent relevant data
            // from being freed. This is not strictly required if all new data is
            // fetched in a single step, but is necessary if the network could attempt
            // to incrementally load data (ex: multiple query entries or incrementally
            // loading records from disk cache).

            var nextReference = environment.retain(operation.root);

            var readyState = getDefaultState();
            var snapshot = void 0; // results of the root fragment
            var hasSyncResult = false;
            var hasFunctionReturned = false;

            if (this._pendingFetch) {
                this._pendingFetch.dispose();
            }
            if (this._rootSubscription) {
                this._rootSubscription.dispose();
            }

            var request = environment.execute({ operation: operation, cacheConfig: cacheConfig }).finally(function () {
                _this3._pendingFetch = null;
            }).subscribe({
                next: function next() {
                    // `next` can be called multiple times by network layers that support
                    // data subscriptions. Wait until the first payload to render `props`
                    // and subscribe for data updates.
                    if (snapshot) {
                        return;
                    }
                    snapshot = environment.lookup(operation.fragment);
                    readyState = {
                        error: null,
                        props: snapshot.data,
                        retry: function retry() {
                            // Do not reset the default state if refetching after success,
                            // handling the case where _fetch may return syncronously instead
                            // of calling setState.
                            var syncReadyState = _this3._fetch(operation, cacheConfig);
                            if (syncReadyState) {
                                _this3.setState({ readyState: syncReadyState });
                            }
                        }
                    };

                    if (_this3._selectionReference) {
                        _this3._selectionReference.dispose();
                    }
                    _this3._rootSubscription = environment.subscribe(snapshot, _this3._onChange);
                    _this3._selectionReference = nextReference;
                    // This line should be called only once.
                    hasSyncResult = true;
                    if (hasFunctionReturned) {
                        _this3.setState({ readyState: readyState });
                    }
                },
                error: function (_error) {
                    function error(_x) {
                        return _error.apply(this, arguments);
                    }

                    error.toString = function () {
                        return _error.toString();
                    };

                    return error;
                }(function (error) {
                    readyState = {
                        error: error,
                        props: null,
                        retry: function retry() {
                            // Return to the default state when retrying after an error,
                            // handling the case where _fetch may return syncronously instead
                            // of calling setState.
                            var syncReadyState = _this3._fetch(operation, cacheConfig);
                            _this3.setState({ readyState: syncReadyState || getDefaultState() });
                        }
                    };
                    if (_this3._selectionReference) {
                        _this3._selectionReference.dispose();
                    }
                    _this3._selectionReference = nextReference;
                    hasSyncResult = true;
                    if (hasFunctionReturned) {
                        _this3.setState({ readyState: readyState });
                    }
                })
            });

            this._pendingFetch = {
                dispose: function dispose() {
                    request.unsubscribe();
                    nextReference.dispose();
                }
            };
            hasFunctionReturned = true;
            return hasSyncResult ? readyState : null;
        }
    }, {
        key: 'getChildContext',
        value: function getChildContext() {
            return {
                relay: this._relayContext
            };
        }
    }, {
        key: 'render',
        value: function render() {
            // Note that the root fragment results in `readyState.props` is already
            // frozen by the store; this call is to freeze the readyState object and
            // error property if set.
            // if (__DEV__) {
            //     deepFreeze(this.state.readyState);
            // }
            return this.props.render(this.state.readyState);
        }
    }]);

    return ReactRelayQueryRenderer;
}(React.Component);

ReactRelayQueryRenderer.childContextTypes = {
    relay: PropTypes.object.isRequired
};

function getDefaultState() {
    return {
        error: null,
        props: null,
        retry: null
    };
}

module.exports = ReactRelayQueryRenderer;

/***/ }),

/***/ "./node_modules/relay-runtime/index.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(88);

/***/ }),

/***/ "./node_modules/server-vars/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var get = __webpack_require__("./node_modules/lodash.get/index.js");

var serverVarsFactory = function () {
    return Object.create({
        store: {},
        add: function (key, val) {
            if (typeof key === 'object') {
                // copy all properties into the store
                Object.assign(this.store, key);
            } else {
                // set on the store (copy if an object)
                this.store[key] = (!Array.isArray(val) && typeof val === 'object') ? Object.assign({}, val) : val;
            }
        },
        get: function(key) {
            if (!key) {
                // return a copy of the entire store
                return Object.create({}, this.store);
            }
            return get(this.store, key);
        },
        inject: function () {
            return '<script type="text/javascript">' +
                'window.__SERVER_VARS__ = ' +
                    // safely embed JSON within HTML
                    // see http://stackoverflow.com/a/4180424/266795
                JSON.stringify(this.store)
                    .replace(/</g, '\\u003c')
                    .replace(/-->/g, '--\\>')
                    .replace(/\u2028/g, '\\u2028')
                    .replace(/\u2029/g, '\\u2029') +
                ';</script>';
        }
    });
};

var serverVars = serverVarsFactory();

serverVars.middleware = function (req, res, next) {
    if (res.serverVars === undefined) {
        res.serverVars = res.locals.serverVars = serverVarsFactory();
        res.serverVars.add(Object.assign({}, serverVars.store)); // get a copy of app-wide serverVars
    }
    next();
};

// on the client, this module exports the bootstrapped serverVars
if (typeof window !== 'undefined' && window.__SERVER_VARS__) {
    serverVars = window.__SERVER_VARS__;
    serverVars.get = function (key) {
        return get(serverVars, key);
    };
}

module.exports = serverVars;


/***/ }),

/***/ "./node_modules/simply-deferred/deferred.js":
/***/ (function(module, exports, __webpack_require__) {

// Generated by CoffeeScript 1.6.3
(function() {
  var Deferred, PENDING, REJECTED, RESOLVED, VERSION, after, execute, flatten, has, installInto, isArguments, isPromise, wrap, _when,
    __slice = [].slice;

  VERSION = '3.0.0';

  PENDING = "pending";

  RESOLVED = "resolved";

  REJECTED = "rejected";

  has = function(obj, prop) {
    return obj != null ? obj.hasOwnProperty(prop) : void 0;
  };

  isArguments = function(obj) {
    return has(obj, 'length') && has(obj, 'callee');
  };

  isPromise = function(obj) {
    return has(obj, 'promise') && typeof (obj != null ? obj.promise : void 0) === 'function';
  };

  flatten = function(array) {
    if (isArguments(array)) {
      return flatten(Array.prototype.slice.call(array));
    }
    if (!Array.isArray(array)) {
      return [array];
    }
    return array.reduce(function(memo, value) {
      if (Array.isArray(value)) {
        return memo.concat(flatten(value));
      }
      memo.push(value);
      return memo;
    }, []);
  };

  after = function(times, func) {
    if (times <= 0) {
      return func();
    }
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  wrap = function(func, wrapper) {
    return function() {
      var args;
      args = [func].concat(Array.prototype.slice.call(arguments, 0));
      return wrapper.apply(this, args);
    };
  };

  execute = function(callbacks, args, context) {
    var callback, _i, _len, _ref, _results;
    _ref = flatten(callbacks);
    _results = [];
    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
      callback = _ref[_i];
      _results.push(callback.call.apply(callback, [context].concat(__slice.call(args))));
    }
    return _results;
  };

  Deferred = function() {
    var candidate, close, closingArguments, doneCallbacks, failCallbacks, progressCallbacks, state;
    state = PENDING;
    doneCallbacks = [];
    failCallbacks = [];
    progressCallbacks = [];
    closingArguments = {
      'resolved': {},
      'rejected': {},
      'pending': {}
    };
    this.promise = function(candidate) {
      var pipe, storeCallbacks;
      candidate = candidate || {};
      candidate.state = function() {
        return state;
      };
      storeCallbacks = function(shouldExecuteImmediately, holder, holderState) {
        return function() {
          if (state === PENDING) {
            holder.push.apply(holder, flatten(arguments));
          }
          if (shouldExecuteImmediately()) {
            execute(arguments, closingArguments[holderState]);
          }
          return candidate;
        };
      };
      candidate.done = storeCallbacks((function() {
        return state === RESOLVED;
      }), doneCallbacks, RESOLVED);
      candidate.fail = storeCallbacks((function() {
        return state === REJECTED;
      }), failCallbacks, REJECTED);
      candidate.progress = storeCallbacks((function() {
        return state !== PENDING;
      }), progressCallbacks, PENDING);
      candidate.always = function() {
        var _ref;
        return (_ref = candidate.done.apply(candidate, arguments)).fail.apply(_ref, arguments);
      };
      pipe = function(doneFilter, failFilter, progressFilter) {
        var filter, master;
        master = new Deferred();
        filter = function(source, funnel, callback) {
          if (!callback) {
            return candidate[source](master[funnel]);
          }
          return candidate[source](function() {
            var args, value;
            args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
            value = callback.apply(null, args);
            if (isPromise(value)) {
              return value.done(master.resolve).fail(master.reject).progress(master.notify);
            } else {
              return master[funnel](value);
            }
          });
        };
        filter('done', 'resolve', doneFilter);
        filter('fail', 'reject', failFilter);
        filter('progress', 'notify', progressFilter);
        return master;
      };
      candidate.pipe = pipe;
      candidate.then = pipe;
      if (candidate.promise == null) {
        candidate.promise = function() {
          return candidate;
        };
      }
      return candidate;
    };
    this.promise(this);
    candidate = this;
    close = function(finalState, callbacks, context) {
      return function() {
        if (state === PENDING) {
          state = finalState;
          closingArguments[finalState] = arguments;
          execute(callbacks, closingArguments[finalState], context);
          return candidate;
        }
        return this;
      };
    };
    this.resolve = close(RESOLVED, doneCallbacks);
    this.reject = close(REJECTED, failCallbacks);
    this.notify = close(PENDING, progressCallbacks);
    this.resolveWith = function(context, args) {
      return close(RESOLVED, doneCallbacks, context).apply(null, args);
    };
    this.rejectWith = function(context, args) {
      return close(REJECTED, failCallbacks, context).apply(null, args);
    };
    this.notifyWith = function(context, args) {
      return close(PENDING, progressCallbacks, context).apply(null, args);
    };
    return this;
  };

  _when = function() {
    var def, defs, finish, resolutionArgs, trigger, _i, _len;
    defs = flatten(arguments);
    if (defs.length === 1) {
      if (isPromise(defs[0])) {
        return defs[0];
      } else {
        return (new Deferred()).resolve(defs[0]).promise();
      }
    }
    trigger = new Deferred();
    if (!defs.length) {
      return trigger.resolve().promise();
    }
    resolutionArgs = [];
    finish = after(defs.length, function() {
      return trigger.resolve.apply(trigger, resolutionArgs);
    });
    defs.forEach(function(def, index) {
      if (isPromise(def)) {
        return def.done(function() {
          var args;
          args = 1 <= arguments.length ? __slice.call(arguments, 0) : [];
          resolutionArgs[index] = args.length > 1 ? args : args[0];
          return finish();
        });
      } else {
        resolutionArgs[index] = def;
        return finish();
      }
    });
    for (_i = 0, _len = defs.length; _i < _len; _i++) {
      def = defs[_i];
      isPromise(def) && def.fail(trigger.reject);
    }
    return trigger.promise();
  };

  installInto = function(fw) {
    fw.Deferred = function() {
      return new Deferred();
    };
    fw.ajax = wrap(fw.ajax, function(ajax, options) {
      var createWrapper, def, promise, xhr;
      if (options == null) {
        options = {};
      }
      def = new Deferred();
      createWrapper = function(wrapped, finisher) {
        return wrap(wrapped, function() {
          var args, func;
          func = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
          if (func) {
            func.apply(null, args);
          }
          return finisher.apply(null, args);
        });
      };
      options.success = createWrapper(options.success, def.resolve);
      options.error = createWrapper(options.error, def.reject);
      xhr = ajax(options);
      promise = def.promise();
      promise.abort = function() {
        return xhr.abort();
      };
      return promise;
    });
    return fw.when = _when;
  };

  if (true) {
    exports.Deferred = function() {
      return new Deferred();
    };
    exports.when = _when;
    exports.installInto = installInto;
  } else if (typeof define === 'function' && define.amd) {
    define(function() {
      if (typeof Zepto !== 'undefined') {
        return installInto(Zepto);
      } else {
        Deferred.when = _when;
        Deferred.installInto = installInto;
        return Deferred;
      }
    });
  } else if (typeof Zepto !== 'undefined') {
    installInto(Zepto);
  } else {
    this.Deferred = function() {
      return new Deferred();
    };
    this.Deferred.when = _when;
    this.Deferred.installInto = installInto;
  }

}).call(this);


/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(92);

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__("dll-reference dibs_vendor"))(481);

/***/ }),

/***/ "./node_modules/yaDeferred/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {

    var resolveRef;
    var rejectRef;

    var promise = new Promise(function (resolve, reject) {
        resolveRef = resolve;
        rejectRef = reject;
    });

    return {
        resolve: function () {
            resolveRef.apply(this, arguments);
            return promise;
        },
        reject: function () {
            rejectRef.apply(this, arguments);
            return promise;
        },
        then: promise.then.bind(promise),
        catch: promise.catch.bind(promise)
    };
};


/***/ }),

/***/ "./src/abandonedCheckout/autoModalHelper.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wasModalShown = exports.setModalShown = exports.loadAutoModal = undefined;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars
var AUTO_MODAL_SHOWN = 'autoModalShown';
var MODAL_SHOW_DELAY = 2000;

var loadAutoModal = exports.loadAutoModal = function loadAutoModal(_ref) {
    var AutoModal = _ref.AutoModal,
        modalProps = _ref.modalProps;

    if (AutoModal) {
        setTimeout(function () {
            var div = document.createElement('div');
            document.body.appendChild(div);
            _reactDom2.default.render(_react2.default.createElement(AutoModal, modalProps), div);
        }, MODAL_SHOW_DELAY);
    }
};

var setModalShown = exports.setModalShown = function setModalShown() {
    _dibsBrowserStorage.sessionStorage.setItem(AUTO_MODAL_SHOWN, true);
};

var wasModalShown = exports.wasModalShown = function wasModalShown() {
    return _dibsBrowserStorage.sessionStorage.getItem(AUTO_MODAL_SHOWN) || _dibsBrowserStorage.sessionStorage.getItem('authModalShown');
};

/***/ }),

/***/ "./src/abandonedCheckout/components/AutoModal.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _BarHeader = __webpack_require__("./node_modules/dibs-elements/dist/BarHeader/index.js");

var _BarHeader2 = _interopRequireDefault(_BarHeader);

var _ModalBody = __webpack_require__("./node_modules/dibs-elements/dist/ModalBody/index.js");

var _ModalBody2 = _interopRequireDefault(_ModalBody);

var _ModalContainer = __webpack_require__("./node_modules/dibs-elements/dist/ModalContainer/index.js");

var _ModalContainer2 = _interopRequireDefault(_ModalContainer);

var _Primary = __webpack_require__("./node_modules/dibs-elements/dist/Button/Primary.js");

var _Primary2 = _interopRequireDefault(_Primary);

__webpack_require__("./node_modules/dibs-elements/dist/Button/buyer/Primary.css");

var _AutoModal = __webpack_require__("./src/abandonedCheckout/components/AutoModal.scss");

var _AutoModal2 = _interopRequireDefault(_AutoModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoModal = function (_Component) {
    _inherits(AutoModal, _Component);

    function AutoModal() {
        _classCallCheck(this, AutoModal);

        var _this = _possibleConstructorReturn(this, (AutoModal.__proto__ || Object.getPrototypeOf(AutoModal)).call(this));

        _this.state = {
            modalOpened: true
        };

        _this.closeModal = _this.closeModal.bind(_this);
        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(AutoModal, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.trackModalEvents({
                modalAction: 'displayed'
            });
        }
    }, {
        key: 'closeModal',
        value: function closeModal() {
            this.setState({
                modalOpened: false
            });
        }
    }, {
        key: 'trackModalEvents',
        value: function trackModalEvents(_ref) {
            var modalAction = _ref.modalAction;
            var tracking = this.props.tracking;

            if (tracking) {
                var category = tracking.category,
                    action = tracking.action,
                    label = tracking.label;

                (0, _dibsTracking.trackEvent)({
                    category: category,
                    action: action + ' ' + modalAction,
                    label: label
                });
            }
        }
    }, {
        key: 'onClick',
        value: function onClick() {
            this.trackModalEvents({
                modalAction: 'clicked'
            });
            this.closeModal();
            this.props.onCtaClick();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                item = _props.item,
                copy = _props.copy,
                children = _props.children;

            var _ref2 = item || {},
                title = _ref2.title,
                image = _ref2.image;

            return _react2.default.createElement(
                _ModalContainer2.default,
                {
                    isOpen: this.state.modalOpened,
                    modalPosition: 'center',
                    onClose: this.closeModal
                },
                _react2.default.createElement(_BarHeader2.default, { title: copy.title, subtitle: copy.subtitle }),
                _react2.default.createElement(
                    _ModalBody2.default,
                    { className: _AutoModal2.default.modalBody },
                    item && _react2.default.createElement(
                        'div',
                        { className: _AutoModal2.default.infoContainer },
                        _react2.default.createElement('img', { className: _AutoModal2.default.image, src: image }),
                        title
                    ),
                    children,
                    _react2.default.createElement(
                        _Primary2.default,
                        { size: 'large', className: _AutoModal2.default.button, onClick: this.onClick },
                        copy.cta
                    ),
                    _react2.default.createElement(
                        'a',
                        { className: _AutoModal2.default.link, onClick: this.closeModal },
                        copy.closeCta
                    )
                )
            );
        }
    }]);

    return AutoModal;
}(_react.Component);

exports.default = AutoModal;

/***/ }),

/***/ "./src/abandonedCheckout/components/AutoModal.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"modalBody":"AutoModal__modalBody__ba3e073e","infoContainer":"AutoModal__infoContainer__ba3e073e","image":"AutoModal__image__ba3e073e","button":"AutoModal__button__ba3e073e","link":"AutoModal__link__ba3e073e"};

/***/ }),

/***/ "./src/actions/cartActions.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadLocalCart = loadLocalCart;
exports.consolidateCart = consolidateCart;
exports.setCartItems = setCartItems;

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _constants = __webpack_require__("./src/actions/constants.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CART_ID = 'cart';

function getLocalStorageItems() {
    return _dibsBrowserStorage.localStorage.getItem(CART_ID) || [];
}

/**
 * MW-541 - Bug caused local storage item IDs to be wrapped in an array.
 * This causes an error so fix any bad local storage items
 */
function fixLocalStorageItems(items) {
    return items.map(function (item) {
        if (Array.isArray(item.id)) {
            item.id = item.id[0];
        }

        return item;
    });
}

/**
 * The desktop stores each cart item as an object, with an id key containing the item id.
 */
function buildLocalStorageItems(current, next) {
    return current.map(function (_ref) {
        var id = _ref.id;
        return id;
    }).filter(function (id) {
        return !next.includes(id);
    }).concat(next).map(function (id) {
        return { id: id };
    });
}

function loadLocalCart() {
    var currentCart = fixLocalStorageItems(getLocalStorageItems());
    // will be ignored if componentShouldUpdate is on
    // if we remove that, then the type needs to change to be handled by reducer appropriately
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: currentCart } };
}

function consolidateCart(payload) {
    var items = (0, _lodash2.default)(payload, 'res.addCartItem.portfolioItems');
    var cart = (0, _lodash2.default)(payload, 'cartItems');
    // once the request to save new cart items is successful,
    // theres no need to keep the local cart anymore
    _dibsBrowserStorage.localStorage.deleteItem(CART_ID);
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: cart.concat(items) } };
}

function setCartItems(itemId) {
    var currentCart = getLocalStorageItems();
    var cartItems = buildLocalStorageItems(currentCart, itemId);
    _dibsBrowserStorage.localStorage.setItem(CART_ID, cartItems);
    return { type: _constants.actionTypes.SET_CART_ITEMS, payload: { items: cartItems } };
}

/***/ }),

/***/ "./src/actions/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Action Types
 */
var headerActionTypes = {
    SET_BANNER_MESSAGES: 'SET_BANNER_MESSAGES',
    SET_UPDATE_USER_STATE: 'SET_UPDATE_USER_STATE',
    SET_USER_TYPE_TRADE: 'SET_USER_TYPE_TRADE',
    SET_USER_TYPE_VIP: 'SET_USER_TYPE_VIP',
    SET_CART_ITEMS: 'SET_CART_ITEMS',
    SET_DEVICE_TYPE: 'SET_DEVICE_TYPE',
    TOGGLE_MOBILE_MENU: 'TOGGLE_MOBILE_MENU',
    INITIAL_TRACKING_FIRED: 'INITIAL_TRACKING_FIRED'
};

var footerActionTypes = {
    SET_CURRENCY: 'SET_CURRENCY',
    SET_CURRENCY_UPDATED: 'SET_CURRENCY_UPDATED'
};

var actionTypes = _extends({}, headerActionTypes, footerActionTypes);

var actionValues = {};

exports.actionTypes = actionTypes;
exports.actionValues = actionValues;
exports.default = { actionTypes: actionTypes, actionValues: actionValues };

/***/ }),

/***/ "./src/actions/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.actionCreators = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _constants = __webpack_require__("./src/actions/constants.js");

var _cartActions = __webpack_require__("./src/actions/cartActions.js");

var headerActionCreators = {
    setUpdateUserState: function setUpdateUserState(updateUserState) {
        return { type: _constants.actionTypes.SET_UPDATE_USER_STATE, updateUserState: updateUserState };
    },
    setUserTypeTrade: function setUserTypeTrade(isUserTypeTrade) {
        return { type: _constants.actionTypes.SET_USER_TYPE_TRADE, isUserTypeTrade: isUserTypeTrade };
    },
    setUserTypeVip: function setUserTypeVip(isUserTypeVip) {
        return { type: _constants.actionTypes.SET_USER_TYPE_VIP, isUserTypeVip: isUserTypeVip };
    },
    setInitialTrackingFired: function setInitialTrackingFired() {
        return { type: _constants.actionTypes.INITIAL_TRACKING_FIRED };
    },
    setBannerMessages: function setBannerMessages(bannerMessages) {
        return { type: _constants.actionTypes.SET_BANNER_MESSAGES, bannerMessages: bannerMessages };
    }
};

var footerActionCreators = {
    setCurrency: function setCurrency(currency) {
        return { type: _constants.actionTypes.SET_CURRENCY, currency: currency };
    },
    setCurrencyUpdated: function setCurrencyUpdated(currencyUpdated) {
        return { type: _constants.actionTypes.SET_CURRENCY_UPDATED, currencyUpdated: currencyUpdated };
    },
    toggleMobileMenu: function toggleMobileMenu(isMobileMenuOpen) {
        return { type: _constants.actionTypes.TOGGLE_MOBILE_MENU, isMobileMenuOpen: isMobileMenuOpen };
    },
    setCartItems: _cartActions.setCartItems
};

var actionCreators = _extends({}, headerActionCreators, footerActionCreators);

exports.actionCreators = actionCreators;
exports.default = { actionCreators: actionCreators };

/***/ }),

/***/ "./src/authModal/async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = authModal;
function authModal() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "./src/authModal/index.js")).then(function (mod) {
        return mod;
    });
}

/***/ }),

/***/ "./src/authModal/authentication/authFlowConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REGISTER = exports.REGISTER = 'register';
var REGISTRATION = exports.REGISTRATION = 'registration';
var LOGIN = exports.LOGIN = 'login';
var FORGOT_PASSWORD = exports.FORGOT_PASSWORD = 'forgot-password';
var RESET_PASSWORD = exports.RESET_PASSWORD = 'reset-password';
var UPDATE_PASSWORD = exports.UPDATE_PASSWORD = 'update-password';
var RESET_INVALID = exports.RESET_INVALID = 'reset-invalid';
var SOCIAL_ACCOUNT_LINKED = exports.SOCIAL_ACCOUNT_LINKED = 'social-account-linked';
var AUTO_PROMPT_REGISTER = exports.AUTO_PROMPT_REGISTER = 'AUTO_PROMPT_REGISTER';
var SOCIAL_CASE_CONNECTION_LINKED = exports.SOCIAL_CASE_CONNECTION_LINKED = 'LINKED_SOCIAL_CONNECTION';
var SOCIAL_CASE_ACCOUNT_CREATED = exports.SOCIAL_CASE_ACCOUNT_CREATED = 'Created';
var SOCIAL_CASE_NO_EMAIL_RETURNED = exports.SOCIAL_CASE_NO_EMAIL_RETURNED = 'NO_EMAIL_RETURNED';

var DEFAULT_FLOW = exports.DEFAULT_FLOW = 'DEFAULT';
var PAGEVIEW_LIMIT_FLOW = exports.PAGEVIEW_LIMIT_FLOW = 'PAGEVIEW_LIMIT';
var CONTACT_DEALER_FLOW = exports.CONTACT_DEALER_FLOW = 'CONTACT_DEALER_FLOW';
var CONTACT_DEALER_FORM_FLOW = exports.CONTACT_DEALER_FORM_FLOW = 'CONTACT_DEALER_FORM';
var CONTACT_DEALER_CALL_FLOW = exports.CONTACT_DEALER_CALL_FLOW = 'CONTACT_DEALER_CALL';
var EMBEDDED_CHECKOUT_FLOW = exports.EMBEDDED_CHECKOUT_FLOW = 'EMBEDDED_CHECKOUT_FLOW';
var FOLLOW_DEALER_FLOW = exports.FOLLOW_DEALER_FLOW = 'FOLLOW_DEALER';
var MAKE_OFFER_FLOW = exports.MAKE_OFFER_FLOW = 'MAKE_OFFER';
var SAVE_ITEM_FLOW = exports.SAVE_ITEM_FLOW = 'SAVE_ITEM';
var SAVE_ITEM_TO_FOLDER_FLOW = exports.SAVE_ITEM_TO_FOLDER_FLOW = 'SAVE_ITEM_TO_FOLDER';
var STALE_LOGIN_FLOW = exports.STALE_LOGIN_FLOW = 'STALE_LOGIN_FLOW';
var TRADE_APPLICATION_FLOW = exports.TRADE_APPLICATION_FLOW = 'TRADE_APPLICATION';
var ALT_REGISTRATION_TRADE_FLOW = exports.ALT_REGISTRATION_TRADE_FLOW = 'ALT_REGISTRATION_TRADE';
var ALT_REGISTRATION_CONSUMER_FLOW = exports.ALT_REGISTRATION_CONSUMER_FLOW = 'ALT_REGISTRATION_CONSUMER';
var SAVE_ITEM_PDP_FLOW = exports.SAVE_ITEM_PDP_FLOW = 'SAVE_ITEM_PDP';
var REQUEST_SHIPPING_FLOW = exports.REQUEST_SHIPPING_FLOW = 'REQUEST_SHIPPING';
var BENEFITS_MODAL_FLOW = exports.BENEFITS_MODAL_FLOW = 'BENEFITS_MODAL_FLOW';

var CLOSE = exports.CLOSE = 'closed';

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/ChangeCurrencyMutation.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var mutation = function mutation() {
    return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/ChangeCurrencyMutation.graphql.js");
};

var getOptimisticResponse = function getOptimisticResponse(id, currency) {
    return {
        editPersonalProfile: {
            user: {
                id: id,
                profile: {
                    currency: currency
                }
            }
        }
    };
};

var changeCurrency = function changeCurrency(_ref) {
    var environment = _ref.environment,
        user = _ref.user,
        currency = _ref.currency,
        onCompleted = _ref.onCompleted;
    var id = user.id,
        serviceId = user.serviceId;


    return (0, _reactRelay.commitMutation)(environment, {
        mutation: mutation,
        variables: {
            input: {
                userServiceId: serviceId,
                currency: currency
            }
        },
        optimisticResponse: function optimisticResponse() {
            return getOptimisticResponse(id, currency);
        },
        onCompleted: onCompleted
    });
};

exports.default = { commit: changeCurrency };

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"selector":"CurrencyDropdown-style__selector__e3020f64","label":"CurrencyDropdown-style__label__e3020f64","value":"CurrencyDropdown-style__value__e3020f64","arrow":"CurrencyDropdown-style__arrow__e3020f64","dropdown":"CurrencyDropdown-style__dropdown__e3020f64","option":"CurrencyDropdown-style__option__e3020f64","optionLabel":"CurrencyDropdown-style__optionLabel__e3020f64","checkmark":"CurrencyDropdown-style__checkmark__e3020f64"};

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencyDropdown.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _getCurrencySymbol = __webpack_require__("./node_modules/dibs-currency-helpers/getCurrencySymbol.js");

var _getCurrencySymbol2 = _interopRequireDefault(_getCurrencySymbol);

var _arrowDown = __webpack_require__("./node_modules/dibs-vg/dist/react/arrow-down.js");

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _checkmark = __webpack_require__("./node_modules/dibs-vg/dist/react/checkmark.js");

var _checkmark2 = _interopRequireDefault(_checkmark);

var _CurrencyDropdownStyle = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencyDropdown-style.scss");

var _CurrencyDropdownStyle2 = _interopRequireDefault(_CurrencyDropdownStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencyDropdown = function (_React$Component) {
    _inherits(CurrencyDropdown, _React$Component);

    function CurrencyDropdown(props) {
        _classCallCheck(this, CurrencyDropdown);

        var _this = _possibleConstructorReturn(this, (CurrencyDropdown.__proto__ || Object.getPrototypeOf(CurrencyDropdown)).call(this, props));

        _this.state = {
            isExpanded: false
        };

        _this.handleSelectorClick = _this.handleSelectorClick.bind(_this);
        _this.handleOptionClick = _this.handleOptionClick.bind(_this);
        _this.closeDropdown = _this.closeDropdown.bind(_this);
        return _this;
    }

    _createClass(CurrencyDropdown, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.closeDropdown);
        }
    }, {
        key: 'openDropdown',
        value: function openDropdown() {
            this.setState({ isExpanded: true });
        }
    }, {
        key: 'closeDropdown',
        value: function closeDropdown() {
            this.setState({ isExpanded: false });
        }
    }, {
        key: 'handleSelectorClick',
        value: function handleSelectorClick(event) {
            event.stopPropagation();
            this.openDropdown();
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(event) {
            event.preventDefault();
            event.stopPropagation();

            var selectedCurrency = event.currentTarget.getAttribute('data-currency');

            this.props.onChange(selectedCurrency);
            this.closeDropdown();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: _CurrencyDropdownStyle2.default.selector },
                _react2.default.createElement(
                    'div',
                    { className: _CurrencyDropdownStyle2.default.label },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'dbl.Footer.CurrencyDropdown.label',
                        defaultMessage: 'Currency'
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _CurrencyDropdownStyle2.default.value, onClick: this.handleSelectorClick },
                    (0, _getCurrencySymbol2.default)(this.props.currency),
                    ' ',
                    this.props.currency,
                    _react2.default.createElement(_arrowDown2.default, { className: _CurrencyDropdownStyle2.default.arrow }),
                    this.state.isExpanded ? _react2.default.createElement(
                        'ul',
                        { className: _CurrencyDropdownStyle2.default.dropdown },
                        this.props.currencies.map(function (currency) {
                            return _react2.default.createElement(
                                'li',
                                { key: currency },
                                _react2.default.createElement(
                                    'span',
                                    {
                                        onClick: _this2.handleOptionClick,
                                        className: _CurrencyDropdownStyle2.default.option,
                                        'data-currency': currency
                                    },
                                    _this2.props.currency === currency ? _react2.default.createElement(_checkmark2.default, { className: _CurrencyDropdownStyle2.default.checkmark }) : null,
                                    _react2.default.createElement(
                                        'span',
                                        { className: _CurrencyDropdownStyle2.default.optionLabel },
                                        (0, _getCurrencySymbol2.default)(currency),
                                        ' ',
                                        currency
                                    )
                                )
                            );
                        })
                    ) : null
                )
            );
        }
    }]);

    return CurrencyDropdown;
}(_react2.default.Component);

CurrencyDropdown.defaultProps = {
    onChange: function onChange() {}
};

exports.default = CurrencyDropdown;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/CurrencySelector.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _actions = __webpack_require__("./src/actions/index.js");

var _CurrencyDropdown = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencyDropdown.jsx");

var _CurrencyDropdown2 = _interopRequireDefault(_CurrencyDropdown);

var _ChangeCurrencyMutation = __webpack_require__("./src/components/Footer/CurrencySelector/ChangeCurrencyMutation.js");

var _ChangeCurrencyMutation2 = _interopRequireDefault(_ChangeCurrencyMutation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencySelector = function (_React$Component) {
    _inherits(CurrencySelector, _React$Component);

    function CurrencySelector(props) {
        _classCallCheck(this, CurrencySelector);

        var _this = _possibleConstructorReturn(this, (CurrencySelector.__proto__ || Object.getPrototypeOf(CurrencySelector)).call(this, props));

        _this.handleCurrencyChange = _this.handleCurrencyChange.bind(_this);
        return _this;
    }

    _createClass(CurrencySelector, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var currency = _dibsBrowserStorage.localStorage.getItem('userCurrency');
            this.props.setCurrencyUpdated(false);
            this.props.setCurrency(currency);
        }
    }, {
        key: 'updateCurrency',
        value: function updateCurrency(currency) {
            var _this2 = this;

            if (this.props.user) {
                _ChangeCurrencyMutation2.default.commit({
                    environment: this.props.relay.environment,
                    user: this.props.user,
                    currency: currency,
                    onCompleted: function onCompleted() {
                        _this2.props.setCurrency(currency);
                        _this2.props.setCurrencyUpdated(true);
                        _dibsBrowserStorage.localStorage.setItem('userCurrency', currency);
                        window.location.reload();
                    }
                });
            } else {
                this.props.setCurrency(currency);
                this.props.setCurrencyUpdated(true);
                _dibsBrowserStorage.localStorage.setItem('userCurrency', currency);
                window.location.reload();
            }
        }
    }, {
        key: 'handleCurrencyChange',
        value: function handleCurrencyChange(currency) {
            var category = 'navigation';
            var action = 'footer navigation click';
            var label = 'change currency|' + currency.toLowerCase();
            var value = 0;
            var additional = { defaultCurrency: currency + ' Selected' };

            (0, _dibsTracking.trackEvent)({ category: category, action: action, label: label, value: value, additional: additional });

            this.updateCurrency(currency);
        }
    }, {
        key: 'render',
        value: function render() {
            var currencies = (0, _lodash2.default)(this.props, 'viewer.currencies', []);
            var currency = (0, _lodash2.default)(this.props, 'user.profile.currency') || this.props.userCurrency;

            return _react2.default.createElement(_CurrencyDropdown2.default, {
                onChange: this.handleCurrencyChange,
                currencies: currencies,
                currency: currency
            });
        }
    }]);

    return CurrencySelector;
}(_react2.default.Component);

CurrencySelector.defaultProps = {
    userCurrency: 'USD'
};

var mapStateToProps = function mapStateToProps(state) {
    var userCurrency = (0, _lodash2.default)(state, 'footer.userCurrency');

    return { userCurrency: userCurrency };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        setCurrency: function setCurrency(currency) {
            dispatch(_actions.actionCreators.setCurrency(currency));
        },
        setCurrencyUpdated: function setCurrencyUpdated(currencyUpdated) {
            dispatch(_actions.actionCreators.setCurrencyUpdated(currencyUpdated));
        }
    };
};

exports.default = (0, _reactRelay.createFragmentContainer)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CurrencySelector), {
    viewer: function viewer() {
        return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_viewer.graphql.js");
    },
    user: function user() {
        return __webpack_require__("./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_user.graphql.js");
    }
});

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/ChangeCurrencyMutation.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 911b6f7c963d4b4ee7e7ee3fbfc77f97
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ChangeCurrencyMutationVariables = {|
  input: {
    userServiceId: string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    currency?: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
    measurementUnit?: ?"CM" | "IN";
    zipCode?: ?string;
    clientMutationId?: ?string;
  };
|};
export type ChangeCurrencyMutationResponse = {|
  +editPersonalProfile: ?{|
    +user: ?{|
      +profile: ?{|
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
    |};
  |};
|};
*/

/*
mutation ChangeCurrencyMutation(
  $input: EditPersonalProfileInput!
) {
  editPersonalProfile(input: $input) {
    user {
      profile {
        currency
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditPersonalProfileInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangeCurrencyMutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditPersonalProfileInput!"
      }],
      "concreteType": "EditPersonalProfilePayload",
      "name": "editPersonalProfile",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ChangeCurrencyMutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditPersonalProfileInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ChangeCurrencyMutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditPersonalProfileInput!"
      }],
      "concreteType": "EditPersonalProfilePayload",
      "name": "editPersonalProfile",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ChangeCurrencyMutation(\n  $input: EditPersonalProfileInput!\n) {\n  editPersonalProfile(input: $input) {\n    user {\n      profile {\n        currency\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CurrencySelector_user = {|
  +id: string;
  +serviceId: ?string;
  +profile: ?{|
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "id",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/CurrencySelector/__generated__/CurrencySelector_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type CurrencySelector_viewer = {|
  +currencies: ?$ReadOnlyArray<?string>;
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CurrencySelector_viewer",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "currencies",
    "storageKey": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/Footer-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer-style__footer__2cb42400","divider":"Footer-style__divider__2cb42400","row":"Footer-style__row__2cb42400","cell":"Footer-style__cell__2cb42400","appStoreLink":"Footer-style__appStoreLink__2cb42400"};

/***/ }),

/***/ "./src/components/Footer/Footer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _appStore = __webpack_require__("./node_modules/dibs-vg/dist/react/app-store.js");

var _appStore2 = _interopRequireDefault(_appStore);

var _LinkRow = __webpack_require__("./src/components/Footer/LinkRow/LinkRow.jsx");

var _LinkRow2 = _interopRequireDefault(_LinkRow);

var _SocialLinkRow = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow.jsx");

var _SocialLinkRow2 = _interopRequireDefault(_SocialLinkRow);

var _CurrencySelector = __webpack_require__("./src/components/Footer/CurrencySelector/CurrencySelector.jsx");

var _CurrencySelector2 = _interopRequireDefault(_CurrencySelector);

var _links = __webpack_require__("./src/components/Footer/links.js");

var _FooterStyle = __webpack_require__("./src/components/Footer/Footer-style.scss");

var _FooterStyle2 = _interopRequireDefault(_FooterStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
    }

    _createClass(Footer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateUserState();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.updateUserState && !prevProps.updateUserState) {
                this.updateUserState();
            }
        }
    }, {
        key: 'updateUserState',
        value: function updateUserState() {
            var userId = (0, _dibsCookieJar.getBuyerId)(document.cookie);
            var hasUserId = !!userId;

            if (hasUserId) {
                var refetchVariables = function refetchVariables() {
                    return {
                        userId: userId,
                        hasUserId: hasUserId
                    };
                };

                this.props.relay.refetch(refetchVariables, null);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'footer',
                { className: _FooterStyle2.default.footer },
                _react2.default.createElement(_LinkRow2.default, { type: 'primary', items: _links.primaryLinks }),
                _react2.default.createElement('div', { className: _FooterStyle2.default.divider }),
                _react2.default.createElement(_LinkRow2.default, { type: 'site', items: _links.siteLinks }),
                _react2.default.createElement(_SocialLinkRow2.default, { items: _links.socialLinks }),
                _react2.default.createElement(_LinkRow2.default, { type: 'legal', items: _links.legalLinks }),
                _react2.default.createElement(
                    'div',
                    { className: _FooterStyle2.default.row },
                    _react2.default.createElement(
                        'div',
                        { className: _FooterStyle2.default.cell },
                        _react2.default.createElement(_CurrencySelector2.default, {
                            viewer: this.props.viewer,
                            user: this.props.viewer.user || null
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _FooterStyle2.default.cell },
                        _react2.default.createElement(
                            'a',
                            {
                                className: _FooterStyle2.default.appStoreLink,
                                href: _links.appLink.href,
                                'data-tn': _links.appLink.dataTn
                            },
                            _react2.default.createElement(_appStore2.default, null)
                        )
                    )
                ),
                _react2.default.createElement(_LinkRow2.default, { type: 'sitemap', items: _links.sitemapLinks })
            );
        }
    }]);

    return Footer;
}(_react2.default.Component);

var mapStateToProps = function mapStateToProps(state) {
    var updateUserState = (0, _lodash2.default)(state, 'header.updateUserState');

    return { updateUserState: updateUserState };
};

Footer = (0, _reactRelay.createRefetchContainer)((0, _reactRedux.connect)(mapStateToProps)(Footer), {
    viewer: function viewer() {
        return __webpack_require__("./src/components/Footer/__generated__/Footer_viewer.graphql.js");
    }
}, function () {
    return __webpack_require__("./src/components/Footer/__generated__/FooterRefetchQuery.graphql.js");
});

exports.default = Footer;

/***/ }),

/***/ "./src/components/Footer/LinkRow/LegalLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"LegalLinks-style__row__1a5e4630","item":"LegalLinks-style__item__1a5e4630","link":"LegalLinks-style__link__1a5e4630"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/LinkRow.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _LinkRowItem = __webpack_require__("./src/components/Footer/LinkRow/LinkRowItem.jsx");

var _LinkRowItem2 = _interopRequireDefault(_LinkRowItem);

var _PrimaryLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/PrimaryLinks-style.scss");

var _PrimaryLinksStyle2 = _interopRequireDefault(_PrimaryLinksStyle);

var _SiteLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/SiteLinks-style.scss");

var _SiteLinksStyle2 = _interopRequireDefault(_SiteLinksStyle);

var _LegalLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/LegalLinks-style.scss");

var _LegalLinksStyle2 = _interopRequireDefault(_LegalLinksStyle);

var _SitemapLinksStyle = __webpack_require__("./src/components/Footer/LinkRow/SitemapLinks-style.scss");

var _SitemapLinksStyle2 = _interopRequireDefault(_SitemapLinksStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleMap = {
    primary: _PrimaryLinksStyle2.default,
    site: _SiteLinksStyle2.default,
    legal: _LegalLinksStyle2.default,
    sitemap: _SitemapLinksStyle2.default
};

var LinkRow = function LinkRow(props) {
    var type = props.type,
        items = props.items;

    var style = styleMap[type] || {};

    return _react2.default.createElement(
        'nav',
        null,
        _react2.default.createElement(
            'div',
            { className: style.row },
            items.map(function (item) {
                return _react2.default.createElement(_LinkRowItem2.default, _extends({ key: item.dataTn }, item, { styles: style }));
            })
        )
    );
};

exports.default = LinkRow;

/***/ }),

/***/ "./src/components/Footer/LinkRow/LinkRowItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkRowItem = function (_Component) {
    _inherits(LinkRowItem, _Component);

    function LinkRowItem(props) {
        _classCallCheck(this, LinkRowItem);

        var _this = _possibleConstructorReturn(this, (LinkRowItem.__proto__ || Object.getPrototypeOf(LinkRowItem)).call(this, props));

        _this.trackClick = _this.trackClick.bind(_this);
        return _this;
    }

    _createClass(LinkRowItem, [{
        key: 'trackClick',
        value: function trackClick() {
            var trackingLabel = this.props.trackingLabel;


            var category = 'navigation';
            var action = 'footer navigation click';
            var label = trackingLabel.trim().toLowerCase();

            (0, _dibsTracking.trackEvent)({ category: category, action: action, label: label });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                _props$styles = _props.styles,
                styles = _props$styles === undefined ? {} : _props$styles,
                target = _props.target,
                href = _props.href,
                dataTn = _props.dataTn,
                formattedMessage = _props.formattedMessage;


            return _react2.default.createElement(
                'div',
                { className: styles.item },
                href ? _react2.default.createElement(
                    'a',
                    {
                        className: styles.link,
                        target: target,
                        href: href,
                        onClick: this.trackClick,
                        'data-tn': dataTn
                    },
                    formattedMessage
                ) : formattedMessage
            );
        }
    }]);

    return LinkRowItem;
}(_react.Component);

exports.default = LinkRowItem;

/***/ }),

/***/ "./src/components/Footer/LinkRow/PrimaryLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"PrimaryLinks-style__row__e1bd129f","item":"PrimaryLinks-style__item__e1bd129f","link":"PrimaryLinks-style__link__e1bd129f"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/SiteLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SiteLinks-style__row__53d960d8","item":"SiteLinks-style__item__53d960d8","link":"SiteLinks-style__link__53d960d8"};

/***/ }),

/***/ "./src/components/Footer/LinkRow/SitemapLinks-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SitemapLinks-style__row__9332e0c4","item":"SitemapLinks-style__item__9332e0c4","link":"SitemapLinks-style__link__9332e0c4"};

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"row":"SocialLinkRow-style__row__c40521aa","item":"SocialLinkRow-style__item__c40521aa","link":"SocialLinkRow-style__link__c40521aa","twitter":"SocialLinkRow-style__twitter__c40521aa","facebook":"SocialLinkRow-style__facebook__c40521aa","pinterest":"SocialLinkRow-style__pinterest__c40521aa","instagram":"SocialLinkRow-style__instagram__c40521aa"};

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRow.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _SocialLinkRowItem = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRowItem.jsx");

var _SocialLinkRowItem2 = _interopRequireDefault(_SocialLinkRowItem);

var _SocialLinkRowStyle = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss");

var _SocialLinkRowStyle2 = _interopRequireDefault(_SocialLinkRowStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SocialLinkRow = function SocialLinkRow(props) {
    var items = props.items;


    return _react2.default.createElement(
        'nav',
        null,
        _react2.default.createElement(
            'ul',
            { className: _SocialLinkRowStyle2.default.row },
            items.map(function (item) {
                return _react2.default.createElement(_SocialLinkRowItem2.default, _extends({ key: item.name }, item));
            })
        )
    );
};

exports.default = SocialLinkRow;

/***/ }),

/***/ "./src/components/Footer/SocialLinkRow/SocialLinkRowItem.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _twitter = __webpack_require__("./node_modules/dibs-vg/dist/react/twitter.js");

var _twitter2 = _interopRequireDefault(_twitter);

var _facebook = __webpack_require__("./node_modules/dibs-vg/dist/react/facebook.js");

var _facebook2 = _interopRequireDefault(_facebook);

var _pinterest = __webpack_require__("./node_modules/dibs-vg/dist/react/pinterest.js");

var _pinterest2 = _interopRequireDefault(_pinterest);

var _instagram = __webpack_require__("./node_modules/dibs-vg/dist/react/instagram.js");

var _instagram2 = _interopRequireDefault(_instagram);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _SocialLinkRowStyle = __webpack_require__("./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss");

var _SocialLinkRowStyle2 = _interopRequireDefault(_SocialLinkRowStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var iconMap = {
    twitter: _twitter2.default,
    facebook: _facebook2.default,
    pinterest: _pinterest2.default,
    instagram: _instagram2.default
};

var SocialLinkRowItem = function (_Component) {
    _inherits(SocialLinkRowItem, _Component);

    function SocialLinkRowItem(props) {
        _classCallCheck(this, SocialLinkRowItem);

        var _this = _possibleConstructorReturn(this, (SocialLinkRowItem.__proto__ || Object.getPrototypeOf(SocialLinkRowItem)).call(this, props));

        _this.trackClick = _this.trackClick.bind(_this);
        return _this;
    }

    _createClass(SocialLinkRowItem, [{
        key: 'trackClick',
        value: function trackClick() {
            var _props = this.props,
                trackingLabel = _props.trackingLabel,
                href = _props.href;

            var eventName = 'fan page';

            (0, _dibsTracking.trackSocial)({
                name: trackingLabel,
                event: eventName,
                opt_target: href,
                opt_pagePath: href
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                name = _props2.name,
                href = _props2.href,
                dataTn = _props2.dataTn;


            if (!iconMap[name]) {
                return null;
            }

            var SocialIcon = iconMap[name];

            return _react2.default.createElement(
                'div',
                { className: _SocialLinkRowStyle2.default.item },
                _react2.default.createElement(
                    'a',
                    {
                        className: _SocialLinkRowStyle2.default.link + ' ' + _SocialLinkRowStyle2.default[name],
                        title: name,
                        href: href,
                        onClick: this.trackClick,
                        'data-tn': dataTn
                    },
                    _react2.default.createElement(SocialIcon, { type: name })
                )
            );
        }
    }]);

    return SocialLinkRowItem;
}(_react.Component);

exports.default = SocialLinkRowItem;

/***/ }),

/***/ "./src/components/Footer/__generated__/FooterRefetchQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5252b963d68e9a57b96090ca27b54cc9
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type FooterRefetchQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query FooterRefetchQuery(
  $userId: String!
  $hasUserId: Boolean!
) {
  viewer {
    ...Footer_viewer
    id
  }
}

fragment Footer_viewer on Viewer {
  user(userId: $userId) @include(if: $hasUserId) {
    serviceId
    ...CurrencySelector_user
    id
  }
  ...CurrencySelector_viewer
}

fragment CurrencySelector_user on User {
  id
  serviceId
  profile {
    currency
  }
}

fragment CurrencySelector_viewer on Viewer {
  currencies
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "FooterRefetchQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Footer_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "FooterRefetchQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "FooterRefetchQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currencies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query FooterRefetchQuery(\n  $userId: String!\n  $hasUserId: Boolean!\n) {\n  viewer {\n    ...Footer_viewer\n    id\n  }\n}\n\nfragment Footer_viewer on Viewer {\n  user(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    ...CurrencySelector_user\n    id\n  }\n  ...CurrencySelector_viewer\n}\n\nfragment CurrencySelector_user on User {\n  id\n  serviceId\n  profile {\n    currency\n  }\n}\n\nfragment CurrencySelector_viewer on Viewer {\n  currencies\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/components/Footer/__generated__/Footer_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Footer_viewer = {|
  +user?: ?{|
    +serviceId: ?string;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userId",
    "type": "String!"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "Footer_viewer",
  "selections": [{
    "kind": "FragmentSpread",
    "name": "CurrencySelector_viewer",
    "args": null
  }, {
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId",
        "type": "String!"
      }],
      "concreteType": "User",
      "name": "user",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "serviceId",
        "storageKey": null
      }, {
        "kind": "FragmentSpread",
        "name": "CurrencySelector_user",
        "args": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/components/Footer/links.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.legalLinks = exports.appLink = exports.sitemapLinks = exports.socialLinks = exports.siteLinks = exports.primaryLinks = undefined;

var _primaryLinks = __webpack_require__("./src/components/Footer/messages/primaryLinks.jsx");

var _primaryLinks2 = _interopRequireDefault(_primaryLinks);

var _siteLinks = __webpack_require__("./src/components/Footer/messages/siteLinks.jsx");

var _siteLinks2 = _interopRequireDefault(_siteLinks);

var _socialLinks = __webpack_require__("./src/components/Footer/messages/socialLinks.js");

var _socialLinks2 = _interopRequireDefault(_socialLinks);

var _legalLinks = __webpack_require__("./src/components/Footer/messages/legalLinks.jsx");

var _legalLinks2 = _interopRequireDefault(_legalLinks);

var _sitemapLinks = __webpack_require__("./src/components/Footer/messages/sitemapLinks.jsx");

var _sitemapLinks2 = _interopRequireDefault(_sitemapLinks);

var _appLink = __webpack_require__("./src/components/Footer/messages/appLink.jsx");

var _appLink2 = _interopRequireDefault(_appLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.primaryLinks = _primaryLinks2.default;
exports.siteLinks = _siteLinks2.default;
exports.socialLinks = _socialLinks2.default;
exports.sitemapLinks = _sitemapLinks2.default;
exports.appLink = _appLink2.default;
exports.legalLinks = _legalLinks2.default;

/***/ }),

/***/ "./src/components/Footer/messages/appLink.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    trackingLabel: 'Download on the App Store',
    icon: 'appStore',
    href: 'https://142876.measurementapi.com/serve?action=click&publisher_id=142876&site_id=90624&destination_id=171508&my_campaign=1stdibs-website&my_adgroup=sitewide-footer&my_ad=download-on-app-store-logo',
    dataTn: 'footer-download',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.app_link_download',
        defaultMessage: 'Download on the App Store'
    })
};

/***/ }),

/***/ "./src/components/Footer/messages/legalLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Copyright',
    dataTn: 'footer-copyright',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.legal_links_copyright',
        defaultMessage: '\xA9 1stdibs, Inc. {year}',
        values: { year: new Date().getFullYear() }
    })
}, {
    trackingLabel: 'User Agreement',
    href: '/about/user-agreement/',
    target: '_blank',
    dataTn: 'footer-agreement',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.legal_links_agreement',
        defaultMessage: 'User Agreement'
    })
}, {
    trackingLabel: 'Privacy Policy',
    href: '/about/privacy-policy/',
    target: '_blank',
    dataTn: 'footer-privacy',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.legal_links_privacy', defaultMessage: 'Privacy Policy' })
}];

/***/ }),

/***/ "./src/components/Footer/messages/primaryLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Trade Program',
    href: '/trade/apply/',
    dataTn: 'footer-designer-program',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_trade_program',
        defaultMessage: 'Trade Program'
    })
}, {
    trackingLabel: 'Dealer Application',
    href: '/dealer/application-form/',
    dataTn: 'footer-dealer-application',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links.dealer_application',
        defaultMessage: 'Seller Application'
    })
}, {
    trackingLabel: 'Dealer Login',
    href: 'https://adminv2.1stdibs.com/login/dealer',
    dataTn: 'footer-dealer-login',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_dealer_login',
        defaultMessage: 'Seller Login'
    })
}, {
    trackingLabel: 'Seller Directory',
    href: '/seller-directory/',
    dataTn: 'footer-seller-directory',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.primary_links_seller_directory',
        defaultMessage: 'Seller Directory'
    })
}];

/***/ }),

/***/ "./src/components/Footer/messages/siteLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'About Us',
    href: '/about/',
    dataTn: 'footer-about-us',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_about_us', defaultMessage: 'About Us' })
}, {
    trackingLabel: 'Support Center',
    href: 'https://support.1stdibs.com/',
    target: '_blank',
    dataTn: 'footer-support',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_support', defaultMessage: 'Support Center' })
}, {
    trackingLabel: 'Blog',
    href: 'https://www.1stdibs.com/blogs/the-study/',
    dataTn: 'footer-blog',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_blog', defaultMessage: 'Blog' })
}, {
    trackingLabel: 'Magazine',
    href: 'https://www.1stdibs.com/introspective-magazine/',
    dataTn: 'footer-magazine',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_magazine', defaultMessage: 'Magazine' })
}, {
    trackingLabel: 'Careers',
    href: '/about/careers/',
    dataTn: 'footer-jobs',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_jobs', defaultMessage: 'Careers' })
}, {
    trackingLabel: 'Press',
    href: '/about/press/',
    dataTn: 'footer-press',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_press', defaultMessage: 'Press' })
}, {
    trackingLabel: 'Contact Us',
    href: '/about/contact/',
    dataTn: 'footer-contact',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.site_links_contact', defaultMessage: 'Contact Us' })
}];

/***/ }),

/***/ "./src/components/Footer/messages/sitemapLinks.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [{
    trackingLabel: 'Site Map',
    href: '/sitemap/',
    classname: 'sitemapMainLink',
    dataTn: 'sitemap-main',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.sitemap_links_main', defaultMessage: 'Site Map' })
}, {
    trackingLabel: 'Furniture',
    href: '/sitemap/furniture/',
    dataTn: 'sitemap-furniture',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.sitemap_links_furniture', defaultMessage: 'Furniture' })
}, {
    trackingLabel: 'Jewelry & Watches',
    href: '/sitemap/jewelry/',
    dataTn: 'sitemap-jewelry',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'dbl.Footer.sitemap_links_jewelry',
        defaultMessage: 'Jewelry & Watches'
    })
}, {
    trackingLabel: 'Art',
    href: '/sitemap/art/',
    dataTn: 'sitemap-art',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.sitemap_links_art', defaultMessage: 'Art' })
}, {
    trackingLabel: 'Fashion',
    href: '/sitemap/fashion/',
    dataTn: 'sitemap-fashion',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.sitemap_links_fashion', defaultMessage: 'Fashion' })
}, {
    trackingLabel: 'Creators',
    href: '/creators/',
    dataTn: 'creators',
    formattedMessage: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dbl.Footer.sitemap_links_creators', defaultMessage: 'Creators' })
}];

/***/ }),

/***/ "./src/components/Footer/messages/socialLinks.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    trackingLabel: 'twitter',
    name: 'twitter',
    href: 'https://twitter.com/1stdibs',
    icon: 'twitter',
    dataTn: 'social-twitter'
}, {
    trackingLabel: 'facebook',
    name: 'facebook',
    href: 'https://www.facebook.com/1stdibs',
    icon: 'facebook',
    dataTn: 'social-facebook'
}, {
    trackingLabel: 'pinterest',
    name: 'pinterest',
    href: 'https://www.pinterest.com/1stdibs/',
    icon: 'pinterest',
    dataTn: 'social-pinterest'
}, {
    trackingLabel: 'instagram',
    name: 'instagram',
    href: 'https://instagram.com/1stdibs/',
    icon: 'instagram',
    dataTn: 'social-instagram'
}];

/***/ }),

/***/ "./src/components/FooterRenderer/FooterRenderer.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");

var _relayQueryLookupRenderer = __webpack_require__("./node_modules/relay-query-lookup-renderer/dist/index.js");

var _relayQueryLookupRenderer2 = _interopRequireDefault(_relayQueryLookupRenderer);

var _Footer = __webpack_require__("./src/components/Footer/Footer.jsx");

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterRenderer = function FooterRenderer(props) {
    var environment = props.environment,
        initialVariables = props.initialVariables,
        query = props.query;


    return _react2.default.createElement(_relayQueryLookupRenderer2.default, {
        lookup: true,
        environment: environment,
        query: query,
        variables: initialVariables,
        render: function render(_ref) {
            var error = _ref.error,
                rendererProps = _ref.props;

            // eslint-disable-line react/display-name, react/prop-types
            if (error) {
                return null;
            } else if (rendererProps) {
                return _react2.default.createElement(_Footer2.default, rendererProps);
            } else {
                return null;
            }
        }
    });
};

exports.default = FooterRenderer;

/***/ }),

/***/ "./src/components/footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.footerInitialVariables = exports.footerRootQuery = exports.FooterRenderer = undefined;

var _FooterRenderer = __webpack_require__("./src/components/FooterRenderer/FooterRenderer.jsx");

var _FooterRenderer2 = _interopRequireDefault(_FooterRenderer);

var _footerRootQuery = __webpack_require__("./src/queries/footerRootQuery.js");

var _footerRootQuery2 = _interopRequireDefault(_footerRootQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FooterRenderer = _FooterRenderer2.default;
exports.footerRootQuery = _footerRootQuery2.default;
exports.footerInitialVariables = _footerRootQuery.initialVariables;

/***/ }),

/***/ "./src/contactModal/async.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = contactModal;
function contactModal() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "./src/contactModal/index.js")).then(function (mod) {
        return mod.default;
    });
}

/***/ }),

/***/ "./src/contactModal/json/modalStepTypes.json":
/***/ (function(module, exports) {

module.exports = {"CONFIRMATION":"confirmation","MAKE_OFFER":"makeOffer","CONTACT_DEALER":"contactDealer","ABANDON_MAKE_OFFER":"abandonMakeOffer","MAKE_PRE_AUTH_OFFER":"makePreAuthOffer","LOW_BALL":"lowBall","PRE_CONTACT_DEALER":"preContactDealer","SUCCESS_GENERIC":"successGeneric","CONTACT_DEALER_GUIDED_COPY":"contactDealerGuidedCopy","NONE":""}

/***/ }),

/***/ "./src/entries/footer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBuyerFooterClient = undefined;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _actions = __webpack_require__("./src/actions/index.js");

var _footer = __webpack_require__("./src/components/footer.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBuyerFooterClient = function getBuyerFooterClient(_ref) {
    var node = _ref.node,
        store = _ref.store,
        relayEnv = _ref.relayEnv;

    var localeDataKey = _serverVars2.default.get('localeDataKey');
    var messages = _serverVars2.default.get('messages');

    if (window.ReactIntlLocaleData) {
        (0, _reactIntl.addLocaleData)(window.ReactIntlLocaleData[localeDataKey]);
    }

    (0, _reactDom.render)(_react2.default.createElement(
        _reactIntl.IntlProvider,
        { locale: localeDataKey, messages: messages },
        _react2.default.createElement(
            _reactRedux.Provider,
            { store: store },
            _react2.default.createElement(_footer.FooterRenderer, {
                environment: relayEnv,
                initialVariables: _footer.footerInitialVariables,
                query: _footer.footerRootQuery
            })
        )
    ), node);

    return {
        updateUserState: store.dispatch.bind(null, _actions.actionCreators.setUpdateUserState(true))
    };
};

exports.getBuyerFooterClient = getBuyerFooterClient;

/***/ }),

/***/ "./src/entries/header.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBuyerHeaderClient = undefined;

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__("./node_modules/react-redux/es/index.js");

var _reactIntl = __webpack_require__("./node_modules/react-intl/lib/index.es.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _loginHandlers = __webpack_require__("./src/utils/loginHandlers.js");

var _actions = __webpack_require__("./src/actions/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBuyerHeaderClient = function getBuyerHeaderClient(_ref) {
    var node = _ref.node,
        store = _ref.store,
        relayEnv = _ref.relayEnv;

    var isMobile = _serverVars2.default.get('settings.isMobile');

    var navPromise = void 0;

    if (isMobile) {
        navPromise = __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "./src/components/mobileHeader.js"));
    } else {
        navPromise = __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "./src/components/responsiveHeader.js"));
    }

    navPromise.then(function (_ref2) {
        var HeaderRenderer = _ref2.HeaderRenderer,
            headerRootQuery = _ref2.headerRootQuery,
            headerInitialVariables = _ref2.headerInitialVariables;

        var localeDataKey = _serverVars2.default.get('localeDataKey');
        var messages = _serverVars2.default.get('messages');

        if (window.ReactIntlLocaleData) {
            (0, _reactIntl.addLocaleData)(window.ReactIntlLocaleData[localeDataKey]);
        }

        var props = {
            initialVariables: headerInitialVariables,
            environment: relayEnv,
            query: headerRootQuery
        };

        (0, _loginHandlers.addLoginHandlers)(function () {
            store.dispatch(_actions.actionCreators.setUpdateUserState(true));
        });

        _reactDom2.default.render(_react2.default.createElement(
            _reactIntl.IntlProvider,
            { locale: localeDataKey, messages: messages },
            _react2.default.createElement(
                _reactRedux.Provider,
                { store: store },
                _react2.default.createElement(HeaderRenderer, props)
            )
        ), node);

        return {
            store: store,
            getBuyerHeaderUiState: store.getState
        };
    });
};

exports.getBuyerHeaderClient = getBuyerHeaderClient;

/***/ }),

/***/ "./src/entries/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.runNotificationQueue = exports._getNotificationQueue = exports.scriptInjector = exports.pageTypes = exports.isPageType = exports.initialize = exports.initializeTracking = exports.contactModal = exports.autoModalHelpers = exports.AutoModal = exports.addLoginHandlers = exports.abExperiments = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _header = __webpack_require__("./src/entries/header.js");

var _footer = __webpack_require__("./src/entries/footer.js");

var _initializeTracking = __webpack_require__("./src/utils/initializeTracking.js");

var _initializeTracking2 = _interopRequireDefault(_initializeTracking);

var _loginHandlers = __webpack_require__("./src/utils/loginHandlers.js");

var _reduxThunk = __webpack_require__("./node_modules/redux-thunk/lib/index.js");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _redux = __webpack_require__("./node_modules/redux/es/index.js");

var _reducers = __webpack_require__("./src/reducers/index.js");

var _reducers2 = _interopRequireDefault(_reducers);

var _Queue = __webpack_require__("./src/notificationQueue/Queue.js");

var _Queue2 = _interopRequireDefault(_Queue);

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _AuthModalCheck = __webpack_require__("./src/utils/AuthModalCheck.js");

var _AuthModalCheck2 = _interopRequireDefault(_AuthModalCheck);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _abExperiments = __webpack_require__("./src/utils/abExperiments.js");

var _abExperiments2 = _interopRequireDefault(_abExperiments);

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _pageConstants2 = _interopRequireDefault(_pageConstants);

var _scriptInjector = __webpack_require__("./src/utils/scriptInjector.js");

var _scriptInjector2 = _interopRequireDefault(_scriptInjector);

var _AutoModal = __webpack_require__("./src/abandonedCheckout/components/AutoModal.jsx");

var _AutoModal2 = _interopRequireDefault(_AutoModal);

var _chat = __webpack_require__("./src/utils/chat.js");

var _chat2 = _interopRequireDefault(_chat);

var _autoModalHelper = __webpack_require__("./src/abandonedCheckout/autoModalHelper.jsx");

var autoModalHelpers = _interopRequireWildcard(_autoModalHelper);

var _async = __webpack_require__("./src/contactModal/async.js");

var _async2 = _interopRequireDefault(_async);

__webpack_require__("./src/scss/dibs.scss");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var USER = _dibsCookieJar.cookieJarConstants.USER,
    MASQUERADE_BUYER = _dibsCookieJar.cookieJarConstants.MASQUERADE_BUYER,
    USER_EMAIL = _dibsCookieJar.cookieJarConstants.USER_EMAIL,
    USER_TYPE = _dibsCookieJar.cookieJarConstants.USER_TYPE;


var dblMiddleware = [_reduxThunk2.default];

// will be used to store the queue so that functions exported from dbl can interact with it
var queue = void 0;

function createGlobalStore(reducers, middlewares, state) {
    var reducer = (0, _redux.combineReducers)(_extends({}, reducers, _reducers2.default));
    var middleware = middlewares.concat(dblMiddleware).filter(function (value, index, self) {
        return self.indexOf(value) === index;
    });

    var enhancer = void 0;
    if (false) {
        var _require = require('redux-devtools-extension'),
            composeWithDevTools = _require.composeWithDevTools;

        enhancer = composeWithDevTools;
    } else {
        enhancer = _redux.compose;
    }

    return (0, _redux.createStore)(reducer, state, enhancer(_redux.applyMiddleware.apply(undefined, _toConsumableArray(middleware))));
}

_jsCookie2.default.defaults = {
    domain: _serverVars2.default.get('cookieDomain'),
    expires: 182,
    path: '/'
};

function logoutFunc() {
    if ((0, _dibsCookieJar.isMasqueradingAsBuyer)(document.cookie)) {
        _jsCookie2.default.remove(MASQUERADE_BUYER);
    } else {
        _jsCookie2.default.remove(USER);
        _jsCookie2.default.remove(USER_EMAIL);
        _jsCookie2.default.remove(USER_TYPE);
    }
    location.reload();
}

function initialize() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$reducers = _ref.reducers,
        reducers = _ref$reducers === undefined ? {} : _ref$reducers,
        _ref$middleware = _ref.middleware,
        middleware = _ref$middleware === undefined ? [] : _ref$middleware,
        _ref$logoutUser = _ref.logoutUser,
        logoutUser = _ref$logoutUser === undefined ? logoutFunc : _ref$logoutUser,
        _ref$notifications = _ref.notifications,
        notifications = _ref$notifications === undefined ? [] : _ref$notifications,
        _ref$state = _ref.state,
        state = _ref$state === undefined ? {} : _ref$state;

    if (state.hasOwnProperty('cart') || state.hasOwnProperty('header') || state.hasOwnProperty('footer')) {
        throw new Error('state cannot include cart, header, footer');
    }
    var data = JSON.parse(_serverVars2.default.get('headerRelayPreloadedData'));
    var relayEnv = (0, _relayClientEnvironment2.default)(data);

    var _ref2 = _serverVars2.default.get('header') || {},
        header = _ref2.header,
        cart = _ref2.cart;

    var _ref3 = _serverVars2.default.get('footer') || {},
        footer = _ref3.footer;

    header.logoutUser = logoutUser;

    var store = createGlobalStore(reducers, middleware, _extends({ header: header, footer: footer, cart: cart }, state));
    (0, _header.getBuyerHeaderClient)({
        node: document.getElementById('js-header'),
        store: store,
        relayEnv: relayEnv
    });
    (0, _footer.getBuyerFooterClient)({
        node: document.getElementById('js-footer'),
        store: store,
        relayEnv: relayEnv
    });
    _AuthModalCheck2.default.init();
    queue = new _Queue2.default(notifications, store, relayEnv);
    _chat2.default.start();
    return store;
}

function _getNotificationQueue() {
    return queue._getNotificationQueue();
}

function runNotificationQueue() {
    queue.runQueue();
}

// used only for testing notification order
exports.abExperiments = _abExperiments2.default;
exports.addLoginHandlers = _loginHandlers.addLoginHandlers;
exports.AutoModal = _AutoModal2.default;
exports.autoModalHelpers = autoModalHelpers;
exports.contactModal = _async2.default;
exports.initializeTracking = _initializeTracking2.default;
exports.initialize = initialize;
exports.isPageType = _isPageType2.default;
exports.pageTypes = _pageConstants2.default;
exports.scriptInjector = _scriptInjector2.default;
exports._getNotificationQueue = _getNotificationQueue;
exports.runNotificationQueue = runNotificationQueue;

/***/ }),

/***/ "./src/mobileAds/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    NOTIFICATION_TYPE: 'mobileInterstitial',
    ITUNES_LINK: 'https://itunes.apple.com/us/app/1stdibs/id938157117',
    FULLSCREEN_NAME: 'fullscreen',
    MC_APP_BANNER: 'messageCenterAppBanner',
    FULLSCREEN_GA_ACTION: 'app interstitial - full screen on second page'
};

/***/ }),

/***/ "./src/mobileAds/helpers/deeplink.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.deepLinkSupported = exports.deepLinkQueries = exports.deepLinkRegexes = undefined;
exports.createDeepLink = createDeepLink;

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEEP_LINK_BASE = 'dibs://www.1stdibs.com';
var DEEP_LINK_BASE_MC = 'dibsmc://www.1stdibs.com';

var deepLinkRegexes = exports.deepLinkRegexes = [/\/(?:furniture|art|jewelry|fashion)\/section\//, /\/sale\/saturday-sale/, /\/(?:collections|dealers|locations|creators|shopping-with)/, /(?:metal|stone|style|origin|period|material|technique)/, /\/(?:furniture|art|jewelry|fashion)/, /\/search\//, /^\/my\/conversations/, /^\/checkout\/id/];

var deepLinkQueries = exports.deepLinkQueries = {
    collection: true,
    creator: true,
    dealer: true,
    gender: true,
    height: true,
    latest: true,
    material: true,
    metal: true,
    origin: true,
    per: true,
    price: true,
    section: true,
    shipping: true,
    sort: true,
    stone: true,
    style: true,
    width: true,
    technique: true,
    utm_medium: true, // eslint-disable-line camelcase
    utm_source: true, // eslint-disable-line camelcase
    utm_campaign: true, // eslint-disable-line camelcase
    utm_content: true, // eslint-disable-line camelcase
    q: true,
    display_title: true, // eslint-disable-line camelcase
    launch: true
};

var deepLinkSupported = exports.deepLinkSupported = function deepLinkSupported(path) {
    path = path || window.location.pathname;

    var supported = deepLinkRegexes.reduce(function (acc, item) {
        if (acc || item.test(path)) {
            return true;
        }
        return false;
    }, false);

    if (path === '/') {
        // home page
        supported = true;
    }

    return supported;
};

function getDeepLinkBase(path) {
    return (/^\/my\/conversations/.test(path) ? DEEP_LINK_BASE_MC : DEEP_LINK_BASE
    );
}

function createDeepLinkPath(path, query) {
    var params = _querystring2.default.parse(query);
    var supported = Object.keys(params).reduce(function (acc, item) {
        if (deepLinkQueries[item]) {
            acc[item] = params[item];
        }
        return acc;
    }, {});
    return path + '?' + _querystring2.default.stringify(supported);
}

function createDeepLink() {
    var path = window.location.pathname;
    var query = window.location.search.substr(1);
    return '' + getDeepLinkBase(path) + createDeepLinkPath(path, query);
}

/***/ }),

/***/ "./src/notificationQueue/Queue.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports._testReset = exports.KEY_ISOLATE_NOTIFICATION = exports.KEY_DISABLE_NOTIFICATIONS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _globalNotifications = __webpack_require__("./src/notificationQueue/globalNotifications/index.js");

var _globalNotifications2 = _interopRequireDefault(_globalNotifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var KEY_DISABLE_NOTIFICATIONS = exports.KEY_DISABLE_NOTIFICATIONS = 'no-notif';
var KEY_ISOLATE_NOTIFICATION = exports.KEY_ISOLATE_NOTIFICATION = 'isolate-notification';

var hasBeenInitialized = false;
var queue = void 0;

var Queue = function () {
    function Queue(notifications, store, relayEnvironment) {
        _classCallCheck(this, Queue);

        this.store = store;
        this.relayEnvironment = relayEnvironment;

        if (!hasBeenInitialized) {
            queue = this.buildQueue(notifications);
            hasBeenInitialized = true;
            this.runQueue();
        } else {
            throw new Error('Only one notification queue may be initialized');
        }
    }

    _createClass(Queue, [{
        key: 'buildQueue',
        value: function buildQueue(notifications) {
            var query = _querystring2.default.parse(window.location.search.substr(1));
            var isolatedNotification = query[KEY_ISOLATE_NOTIFICATION];
            var fullQueue = [].concat(_globalNotifications2.default, notifications).sort(function (a, b) {
                return b.priority - a.priority;
            });
            if (isolatedNotification) {
                return [fullQueue.find(function (item) {
                    return item.name === isolatedNotification;
                })];
            }
            if (this.noNotifications(query)) {
                return [];
            }
            return fullQueue;
        }
    }, {
        key: 'noNotifications',
        value: function noNotifications(query) {
            if (_dibsBrowserStorage.sessionStorage.getItem(KEY_DISABLE_NOTIFICATIONS) === true) {
                return true;
            }
            if (query[KEY_DISABLE_NOTIFICATIONS] === 'true') {
                _dibsBrowserStorage.sessionStorage.setItem(KEY_DISABLE_NOTIFICATIONS, true);
                return true;
            }

            return false;
        }
    }, {
        key: '_getNotificationQueue',
        value: function _getNotificationQueue() {
            if (true) {
                console.error('this method is for development purposes only');
            }
            return queue;
        }
    }, {
        key: 'runQueue',
        value: function runQueue() {
            var _this = this;

            var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            if (index < queue.length) {
                return queue[index].rule({ relayEnvironment: this.relayEnvironment }).then(function (bool) {
                    if (bool) {
                        return _this.store.dispatch(queue[index].action());
                    } else {
                        return _this.runQueue(++index);
                    }
                });
            } else {
                return Promise.resolve();
            }
        }
    }]);

    return Queue;
}();

exports.default = Queue;
var _testReset = exports._testReset = function _testReset() {
    hasBeenInitialized = false;
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/abandonCheckout/checkoutSurveyLauncher.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = checkoutSurveyLauncher;

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function checkoutSurveyLauncher() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "./src/abandonedCheckout/components/CheckoutSurvey.jsx")).then(function (_ref) {
        var CheckoutSurvey = _ref.default;

        var el = window.document.createElement('div');
        window.document.body.appendChild(el);
        _reactDom2.default.render(_react2.default.createElement(CheckoutSurvey, {}), el);
    });
}

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/abandonCheckout/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _checkoutStorageConstants = __webpack_require__("./src/utils/checkoutStorageConstants.js");

var _checkoutSurveyLauncher = __webpack_require__("./src/notificationQueue/globalNotifications/abandonCheckout/checkoutSurveyLauncher.js");

var _checkoutSurveyLauncher2 = _interopRequireDefault(_checkoutSurveyLauncher);

var _makeOfferLauncher = __webpack_require__("./exports/makeOfferLauncher.jsx");

var _makeOfferLauncher2 = _interopRequireDefault(_makeOfferLauncher);

var _modalStepTypes = __webpack_require__("./src/contactModal/json/modalStepTypes.json");

var _modalStepTypes2 = _interopRequireDefault(_modalStepTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var thirtyMinutesPassed = function thirtyMinutesPassed(time) {
    var date = new Date(time);
    return (Date.now() - date.getTime()) / (1000 * 60) >= 0.01;
};

var isBlacklistedPage = (0, _isPageType2.default)([_pageConstants.PAGE_TYPE.CHECKOUT, _pageConstants.PAGE_TYPE.ABOUT]);

var preAuthOfferModal = function preAuthOfferModal() {
    return function (dispatch) {
        var preAuthOfferModalInfo = _dibsBrowserStorage.localStorage.getItem('checkoutPreAuthOfferModalInfo');
        var surveyInfo = _dibsBrowserStorage.localStorage.getItem(_checkoutStorageConstants.STORAGE.SURVEY_INFO);
        if (preAuthOfferModalInfo) {
            var itemId = preAuthOfferModalInfo.itemId,
                offerAmount = preAuthOfferModalInfo.offerAmount,
                offerCurrency = preAuthOfferModalInfo.offerCurrency,
                offerMessage = preAuthOfferModalInfo.offerMessage,
                sellerId = preAuthOfferModalInfo.sellerId,
                quantity = preAuthOfferModalInfo.quantity,
                name = preAuthOfferModalInfo.name;

            (0, _makeOfferLauncher2.default)({
                item: {
                    id: itemId,
                    seller: {
                        id: sellerId
                    }
                },
                currency: offerCurrency,
                currentStep: _modalStepTypes2.default.ABANDON_MAKE_OFFER,
                preloadedState: {
                    fields: {
                        offerFieldValue: offerAmount,
                        messageFieldValue: offerMessage,
                        nameFieldValue: name,
                        quantityFieldValue: quantity
                    }
                }
            });
            _dibsBrowserStorage.localStorage.setItem('hasSeenPreAuthOfferModal', { itemId: itemId });
            dispatch({ type: 'noop' });
        }
        if (surveyInfo) {
            (0, _checkoutSurveyLauncher2.default)();
            dispatch({ type: 'noop' });
        }
    };
};

var preAuthOfferModalAndSurveyRule = function preAuthOfferModalAndSurveyRule() {
    if (isBlacklistedPage) {
        return Promise.resolve(false);
    }

    var isAfterTimer = void 0;

    // checkoutPreAuthOfferModal display logic
    // if checkoutPreAuthOfferModalInfo is present, it overrides checkoutSurveyInfo
    var preAuthOfferModalInfo = _dibsBrowserStorage.localStorage.getItem('checkoutPreAuthOfferModalInfo');
    if (preAuthOfferModalInfo) {
        var itemId = preAuthOfferModalInfo.itemId;

        var hasSeenPreAuthOfferModal = itemId === (0, _lodash2.default)(_dibsBrowserStorage.localStorage.getItem('hasSeenPreAuthOfferModal'), 'itemId');

        isAfterTimer = thirtyMinutesPassed(preAuthOfferModalInfo.checkoutTime);

        if (!isAfterTimer && !hasSeenPreAuthOfferModal) {
            return Promise.resolve(true);
        }
    }

    // Old checkout survey
    var surveyInfo = _dibsBrowserStorage.localStorage.getItem(_checkoutStorageConstants.STORAGE.SURVEY_INFO);
    var hasSeenSurvey = !!_dibsBrowserStorage.localStorage.getItem('hasSeenCheckoutSurvey');
    if (surveyInfo && !hasSeenSurvey) {
        isAfterTimer = thirtyMinutesPassed(surveyInfo.checkoutTime);
        if (!isAfterTimer) {
            return Promise.resolve(true);
        }
    }

    return Promise.resolve(false);
};

var autoModalRule = function autoModalRule() {
    var autoModalInfo = _dibsBrowserStorage.localStorage.getItem(_checkoutStorageConstants.STORAGE.AUTO_MODAL_INFO);
    return Promise.resolve(!isBlacklistedPage && autoModalInfo);
};

exports.default = [{
    name: 'preAuthOfferModal',
    rule: preAuthOfferModalAndSurveyRule,
    action: preAuthOfferModal,
    priority: 100
}, {
    name: 'autoModal',
    rule: autoModalRule,
    action: function action() {
        return function (dispatch) {
            __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "./src/notificationQueue/globalNotifications/abandonCheckout/autoModalAction.js")).then(function (_ref) {
                var autoModal = _ref.default;
                return autoModal(dispatch);
            });
        };
    },
    priority: 350
}];

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/collaborativePurchasing/collabPurchaseRule.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = collaborativePurchasingRule;

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _constants = __webpack_require__("./src/notificationQueue/globalNotifications/collaborativePurchasing/constants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Handles checking Local Storage to see if the criteria for the user
 * having seen the modal has been met.
 * @return {boolean}
 */
function hasSeenModal() {
    if (_dibsBrowserStorage.localStorage) {
        var modalStorage = _dibsBrowserStorage.localStorage.getItem(_constants.MODAL_ID);
        if (modalStorage) {
            var viewedThisSession = modalStorage.viewedThisSession,
                totalViewCount = modalStorage.totalViewCount;

            return viewedThisSession || totalViewCount >= _constants.NUM_TIMES_TO_SHOW;
        }
    }
    return false;
}

/**
 * The Notification Queue Rule. Returns Promise(true) if the Collaborative
 * Purchasing Modal should be shown. Returns Promise(false) otherwise.
 * @return {Promise<boolean>}
 */
function collaborativePurchasingRule() {
    var isUserTypeTrade = _serverVars2.default.get('settings.isUserTypeTrade') || false;
    var isBlacklistedPage = (0, _isPageType2.default)([_pageConstants.PAGE_TYPE.CHECKOUT, _pageConstants.PAGE_TYPE.CHECKOUT_CONFIRMATION, _pageConstants.PAGE_TYPE.ORDER_MANAGER]);

    if (!isUserTypeTrade || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    var visitTracking = new _dibsVisitTracking.VisitCountModel();
    return Promise.resolve(visitTracking.get('session') >= _constants.NUM_VISITS_TO_SHOW);
}

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/collaborativePurchasing/constants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Local Storage key. Returns undefined or an object with shape:
 *      version: String,
 *      viewedThisSession: Boolean,
 *      totalViewCount: Number,
 */
var MODAL_ID = exports.MODAL_ID = 'collabPurchaseModal';

/**
 * Track version of storage data. This way when functionality changes, we can
 * bump version to throw away old storage data.
 */
var CURRENT_VERSION = exports.CURRENT_VERSION = '1';

/**
 * Class name used to "tag" the html element used to mount the collaborative
 * purchase modal
 */
var CONTAINER_CLASSNAME = exports.CONTAINER_CLASSNAME = 'collaborativePurchasingModalContainer';

/**
 * The total number of times the user should be shown the modal
 */
var NUM_TIMES_TO_SHOW = exports.NUM_TIMES_TO_SHOW = 2;

/**
 * The total number of pages to visit in a given session to open the modal
 */
var NUM_VISITS_TO_SHOW = exports.NUM_VISITS_TO_SHOW = 3;

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/collaborativePurchasing/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _constants = __webpack_require__("./src/notificationQueue/globalNotifications/collaborativePurchasing/constants.js");

var _collabPurchaseRule = __webpack_require__("./src/notificationQueue/globalNotifications/collaborativePurchasing/collabPurchaseRule.js");

var _collabPurchaseRule2 = _interopRequireDefault(_collabPurchaseRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Resets the entire storage object if the version has changed, otherwise it handles
 * reseting the `viewedThisSession` field if necessary. It gets called right
 * away just below here because we can't guarantee that the rule for this will
 * get called by the queue at the beginning of a session.
 */
function init() {
    var modalStorage = _dibsBrowserStorage.localStorage.getItem(_constants.MODAL_ID);
    var visitTracking = new _dibsVisitTracking.VisitCountModel();

    if (modalStorage) {
        if (modalStorage.version !== _constants.CURRENT_VERSION) {
            _dibsBrowserStorage.localStorage.setItem(_constants.MODAL_ID, {
                version: _constants.CURRENT_VERSION,
                viewedThisSession: false,
                totalViewCount: 0
            });
        } else if (modalStorage.viewedThisSession && visitTracking.get('session') <= 1) {
            modalStorage.viewedThisSession = false;
            _dibsBrowserStorage.localStorage.setItem(_constants.MODAL_ID, modalStorage);
        }
    }
}

init(); // See docs for this above

exports.default = {
    name: 'collaborativePurchasing',
    priority: 400,
    rule: _collabPurchaseRule2.default,
    action: function action() {
        return function () {
            __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "./src/notificationQueue/globalNotifications/collaborativePurchasing/collabPurchaseAction.js")).then(function (_ref) {
                var action = _ref.default;
                return action();
            });
        };
    }
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/mobileAdsHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.shouldShowAd = undefined;

var _mobileCheck = __webpack_require__("./node_modules/dibs-client-check/dist/mobileCheck.js");

var _mobileCheck2 = _interopRequireDefault(_mobileCheck);

var _jsCookie = __webpack_require__("./node_modules/js-cookie/src/js.cookie.js");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _deeplink = __webpack_require__("./src/mobileAds/helpers/deeplink.js");

var _referrerHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/referrerHelper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasInterstitualCookie = function hasInterstitualCookie() {
    return _jsCookie2.default.getJSON().dibsMobileInterstitial || undefined;
};

var shouldShowAd = exports.shouldShowAd = function shouldShowAd() {
    var isAppPage = _mobileCheck2.default.iPhone() && !hasInterstitualCookie() && (0, _deeplink.deepLinkSupported)();
    return isAppPage && !(0, _referrerHelper.isPlaReferrer)();
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/postAuthLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.autoPromptRegistration = autoPromptRegistration;

var _actions = __webpack_require__("./src/actions/index.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _authFlowConstants = __webpack_require__("./src/authModal/authentication/authFlowConstants.js");

var _async = __webpack_require__("./src/authModal/async.js");

var _async2 = _interopRequireDefault(_async);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onTradeApplicationPage = function onTradeApplicationPage() {
    var path = location.pathname;
    return path.split('/trade/apply').length > 1;
};

var deferred = function deferred() {
    var resolveRef = void 0;

    var promise = new Promise(function (resolve) {
        resolveRef = resolve;
    });

    promise.resolve = resolveRef;
    return promise;
};

var postAuthDeferred = deferred();
var moduleLoaded = false;

var loadPostAuthModule = function loadPostAuthModule() {
    var relayEnv = (0, _relayClientEnvironment2.default)();
    if (!moduleLoaded) {
        (0, _async2.default)().then(function (mod) {
            var postAuth = mod;
            postAuth.init(relayEnv);
            postAuthDeferred.resolve(postAuth);
        }, 'authModal');
        moduleLoaded = true;
    }

    return postAuthDeferred;
};

function autoPromptRegistration() {
    var setUpdateUserState = _actions.actionCreators.setUpdateUserState;


    return new Promise(function (res) {
        if (onTradeApplicationPage()) {
            res(setUpdateUserState(false));
        }
        loadPostAuthModule().then(function (postAuth) {
            var relayEnv = (0, _relayClientEnvironment2.default)();
            postAuth.init(relayEnv);
            postAuth.run(_authFlowConstants.AUTO_PROMPT_REGISTER).onUserChanged(function () {
                res(setUpdateUserState(true));
            });
        });
    });
}

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/helpers/referrerHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isPlaReferrer = exports.isEmailReferrer = exports.isAmpReferrer = undefined;

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReferringMedium = function getReferringMedium(query) {
    query = query || _querystring2.default.parse(window.location.search.substr(1));
    return query.utm_medium ? query.utm_medium.toLowerCase() : '';
};

var isAmpReferrer = exports.isAmpReferrer = function isAmpReferrer() {
    return document.referrer.match(/\/amp\//g) !== null;
};

var isEmailReferrer = exports.isEmailReferrer = function isEmailReferrer(query) {
    return getReferringMedium(query) === 'email';
};

var isPlaReferrer = exports.isPlaReferrer = function isPlaReferrer() {
    var query = _querystring2.default.parse(window.location.search.substr(1));
    return getReferringMedium() === 'pla' || typeof query.product !== 'undefined' && typeof query.gclid !== 'undefined';
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _loginPrompt = __webpack_require__("./src/notificationQueue/globalNotifications/loginPrompt.js");

var _loginPrompt2 = _interopRequireDefault(_loginPrompt);

var _tradeOnboarding = __webpack_require__("./src/notificationQueue/globalNotifications/tradeOnboarding.js");

var _mobileAds = __webpack_require__("./src/notificationQueue/globalNotifications/mobileAds.js");

var _mobileAds2 = _interopRequireDefault(_mobileAds);

var _index = __webpack_require__("./src/notificationQueue/globalNotifications/abandonCheckout/index.js");

var _index2 = _interopRequireDefault(_index);

var _collaborativePurchasing = __webpack_require__("./src/notificationQueue/globalNotifications/collaborativePurchasing/index.js");

var _collaborativePurchasing2 = _interopRequireDefault(_collaborativePurchasing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = [_loginPrompt2.default, _tradeOnboarding.ruleConfigTradeOnboarding, _mobileAds2.default, _collaborativePurchasing2.default].concat(_toConsumableArray(_index2.default));

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/loginPrompt.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _AuthModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js");

var _AuthModalLoader2 = _interopRequireDefault(_AuthModalLoader);

var _postAuthLoader = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/postAuthLoader.js");

var postAuthLoader = _interopRequireWildcard(_postAuthLoader);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isPlaReferrer = function isPlaReferrer() {
    var query = _querystring2.default.parse(location.search);
    var utmMedium = query.utm_medium ? query.utm_medium.toLowerCase() : '';
    return utmMedium === 'pla' || typeof query.product !== 'undefined' && typeof query.gclid !== 'undefined';
};

var isAllowedPageType = function isAllowedPageType() {
    var isPdpPrintPage = _serverVars2.default.get('settings.isPrintPDP');
    var allowedPageTypes = [_pageConstants.PAGE_TYPE.HOME, _pageConstants.PAGE_TYPE.CREATOR, _pageConstants.PAGE_TYPE.DEALER, _pageConstants.PAGE_TYPE.PDP];

    var isAllowedPage = (0, _isPageType2.default)([].concat(allowedPageTypes, _toConsumableArray(_pageConstants.BROWSE_TYPES)));

    return isAllowedPage && !isPdpPrintPage;
};

/**
 * should visitor be prompted to login?
 * @returns {boolean}
 */
var isBlocked = function isBlocked() {
    var query = _querystring2.default.parse(location.search);
    var loggedIn = (0, _dibsCookieJar.getBuyerId)(document.cookie);
    if (loggedIn || query.modal || !isAllowedPageType() || isPlaReferrer()) {
        return true;
    }
    return false;
};

var shouldPromptLoginRegistration = function shouldPromptLoginRegistration(visitCountModel) {
    return visitCountModel.get('session') === visitCountModel.get('regPromptLimit');
};

var canAutoPromptUser = function canAutoPromptUser() {
    var visitCountModel = new _dibsVisitTracking.VisitCountModel();
    var isModalBlocked = isBlocked();
    var shouldOpenModal = shouldPromptLoginRegistration(visitCountModel);
    if (shouldOpenModal && !isModalBlocked) {
        return true;
    } else if (shouldOpenModal && isModalBlocked) {
        visitCountModel.increment('regPromptLimit');
        visitCountModel.save();
        return false;
    } else {
        return false;
    }
};

var getActionAndFlow = function getActionAndFlow() {
    var action = _AuthModalLoader2.default.constants.REGISTER;
    var flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
    var ga = {};
    var everLoggedIn = (0, _dibsCookieJar.getEverLoggedIn)(document.cookie);
    if (everLoggedIn) {
        action = _AuthModalLoader2.default.constants.LOGIN;
        flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
        if (everLoggedIn.toLowerCase() === 'trade') {
            flow = _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW;
            ga.label = 'pageview limit reached - trade';
        }
    }

    return { action: action, flow: flow, ga: ga };
};

/**
 * prompts visitor to register if it's due
 * @return {boolean} true if login prompted
 */
var openLoginModal = function openLoginModal() {
    return function (dispatch) {
        var _getActionAndFlow = getActionAndFlow(),
            action = _getActionAndFlow.action,
            flow = _getActionAndFlow.flow,
            ga = _getActionAndFlow.ga;

        _dibsBrowserStorage.sessionStorage.setItem('authModalShown', true);

        if (action === _AuthModalLoader2.default.constants.REGISTER && flow === _AuthModalLoader2.default.constants.PAGEVIEW_LIMIT_FLOW) {
            postAuthLoader.autoPromptRegistration({ flow: flow });
        } else {
            _AuthModalLoader2.default.show({
                action: action,
                flow: flow,
                ga: Object.assign({
                    label: 'pageview limit reached'
                }, ga)
            });
        }
        dispatch({ type: 'noop' });
    };
};

/**
 * Checks condition for auto prompt user.
 * Opens modal if condition is satisfied.
 * Condition:
 * page view >= 3,
 * home / browse / creator / pdp (not print) page type,
 * User is not logged in and AuthModal is not opened.
 *
 * @return {Promise}
 */
var loginPromptRule = function loginPromptRule() {
    if (canAutoPromptUser()) {
        return Promise.resolve(true);
    }
    return Promise.resolve(false);
};

exports.default = {
    name: 'loginPrompt',
    rule: loginPromptRule,
    action: openLoginModal,
    priority: 250
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/mobileAds.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _querystring = __webpack_require__("./node_modules/querystring-es3/index.js");

var _querystring2 = _interopRequireDefault(_querystring);

var _referrerHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/referrerHelper.js");

var _mobileAdsHelper = __webpack_require__("./src/notificationQueue/globalNotifications/helpers/mobileAdsHelper.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _dibsVisitTracking = __webpack_require__("./node_modules/dibs-visit-tracking/dist/index.js");

var _constants = __webpack_require__("./src/mobileAds/constants.js");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAllowedPageType = function isAllowedPageType() {
    return !(0, _isPageType2.default)(_pageConstants.PAGE_TYPE.CHECKOUT);
};

var checkPageViewCount = function checkPageViewCount() {
    var visitCountModel = new _dibsVisitTracking.VisitCountModel();
    return visitCountModel.get('session') >= 2;
};

var shouldSeeInterstitial = function shouldSeeInterstitial() {
    var _qs$parse = _querystring2.default.parse(location.search),
        emailToken = _qs$parse.emailToken;

    var emailReferrer = _dibsBrowserStorage.sessionStorage.getItem('emailReferrer');

    if ((0, _referrerHelper.isEmailReferrer)() || emailToken) {
        _dibsBrowserStorage.sessionStorage.setItem('emailReferrer', true);
        emailReferrer = true;
    }

    return !!(0, _dibsCookieJar.getBuyerId)(document.cookie) && (0, _mobileAdsHelper.shouldShowAd)() && !emailReferrer && isAllowedPageType() && !(0, _referrerHelper.isAmpReferrer)() && checkPageViewCount();
};

/**
 * Condition:
 * second page view,
 * logged in user,
 * no cookie "dibsMobileInterstitial",
 * not PlaReferrer, not email referrer,
 * not checkout
 * iphone
 *
 * @return {Promise}
 */
var mobileAdsAction = function mobileAdsAction() {
    return function (dispatch) {
        var NOTIFICATION_TYPE = _constants2.default.NOTIFICATION_TYPE;

        __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "./src/mobileAds/index.jsx")).then(function (_ref) {
            var initMobileModal = _ref.initMobileModal;

            initMobileModal();
            dispatch({ type: NOTIFICATION_TYPE });
        });
    };
};

exports.default = {
    name: 'mobileAd',
    rule: function rule() {
        return Promise.resolve(shouldSeeInterstitial());
    },
    action: mobileAdsAction,
    priority: 150
};

/***/ }),

/***/ "./src/notificationQueue/globalNotifications/tradeOnboarding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ruleConfigTradeOnboarding = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _abExperiments = __webpack_require__("./src/utils/abExperiments.js");

var _abExperiments2 = _interopRequireDefault(_abExperiments);

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

__webpack_require__("./src/scss/tradeOnboarding.scss");

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

var _tradeOnboardingHelper = __webpack_require__("./src/utils/tradeOnboardingHelper.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showNewOnboardingFlow = function showNewOnboardingFlow() {
    if (_abExperiments2.default.tradeOnboardingFlow) {
        setTimeout(function () {
            return _abExperiments2.default.tradeOnboardingFlow.resolve(false);
        }, 1500);
        return _abExperiments2.default.tradeOnboardingFlow;
    } else {
        return Promise.resolve(false);
    }
};

function tradeOnboardingRule() {
    var isBlacklistedPage = (0, _isPageType2.default)([_pageConstants.PAGE_TYPE.CHECKOUT, _pageConstants.PAGE_TYPE.SOURCING]);
    if (!(0, _dibsCookieJar.getBuyerId)(document.cookie) || isBlacklistedPage || (0, _tradeOnboardingHelper.hasSeenModal)()) {
        return Promise.resolve(false);
    }

    return (0, _tradeOnboardingHelper.fetchTradeUserData)().then(function (_ref) {
        var isVerifiedTrade = _ref.isVerifiedTrade;

        if (!isVerifiedTrade) {
            return Promise.resolve(false);
        } else {
            return Promise.resolve(true);
        }
    }).catch(function (err) {
        console.error(err);
        return Promise.resolve(false);
    });
}

var tradeOnboardingShow = function tradeOnboardingShow() {
    return function (dispatch) {
        var label = (0, _isPageType2.default)(_pageConstants.PAGE_TYPE.PDP) ? _tradeOnboardingHelper.LABEL_PDP : _tradeOnboardingHelper.LABEL_SEARCH_BROWSE;
        return Promise.all([(0, _tradeOnboardingHelper.fetchTradeUserData)(), showNewOnboardingFlow()]).then(function (_ref2) {
            var _ref3 = _slicedToArray(_ref2, 2),
                email = _ref3[0].email,
                showNewFlow = _ref3[1];

            return (0, _tradeOnboardingHelper.loadOnboardingModal)({
                buyerEmail: email,
                showNewFlow: showNewFlow,
                trackingLabel: 'modal - ' + label
            }).then(function () {
                return dispatch({
                    success: true,
                    type: (0, _tradeOnboardingHelper.getModalType)()
                });
            });
        });
    };
};

var ruleConfigTradeOnboarding = exports.ruleConfigTradeOnboarding = {
    name: 'tradeOnboarding',
    priority: 450,
    rule: tradeOnboardingRule,
    action: tradeOnboardingShow
};

/***/ }),

/***/ "./src/queries/__generated__/footerRootQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 007e433a31eb4d002eb396b1d3c4a71e
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type footerRootQueryResponse = {|
  +viewer: ?{| |};
|};
*/

/*
query footerRootQuery(
  $hasUserId: Boolean!
  $userId: String!
) {
  viewer {
    ...Footer_viewer
    id
  }
}

fragment Footer_viewer on Viewer {
  user(userId: $userId) @include(if: $hasUserId) {
    serviceId
    ...CurrencySelector_user
    id
  }
  ...CurrencySelector_viewer
}

fragment CurrencySelector_user on User {
  id
  serviceId
  profile {
    currency
  }
}

fragment CurrencySelector_viewer on Viewer {
  currencies
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "footerRootQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "FragmentSpread",
        "name": "Footer_viewer",
        "args": null
      }],
      "storageKey": null
    }],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "footerRootQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "footerRootQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currencies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query footerRootQuery(\n  $hasUserId: Boolean!\n  $userId: String!\n) {\n  viewer {\n    ...Footer_viewer\n    id\n  }\n}\n\nfragment Footer_viewer on Viewer {\n  user(userId: $userId) @include(if: $hasUserId) {\n    serviceId\n    ...CurrencySelector_user\n    id\n  }\n  ...CurrencySelector_viewer\n}\n\nfragment CurrencySelector_user on User {\n  id\n  serviceId\n  profile {\n    currency\n  }\n}\n\nfragment CurrencySelector_viewer on Viewer {\n  currencies\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/queries/footerRootQuery.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initialVariables = undefined;

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

exports.default = function () {
    return __webpack_require__("./src/queries/__generated__/footerRootQuery.graphql.js");
};

var initialVariables = exports.initialVariables = {
    hasUserId: false,
    userId: ''
};

/***/ }),

/***/ "./src/reducers/cartReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__("./src/actions/constants.js");

var defaultState = {
    items: []
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
    var action = arguments[1];

    switch (action.type) {
        case _constants.actionTypes.SET_CART_ITEMS:
            return Object.assign({}, state, {
                items: action.payload.items
            });
        default:
            return state;
    }
};

/***/ }),

/***/ "./src/reducers/footerReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = footerReducer;

var _constants = __webpack_require__("./src/actions/constants.js");

function footerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _constants.actionTypes.SET_CURRENCY:
            return _extends({}, state, {
                userCurrency: action.currency
            });
        case _constants.actionTypes.SET_CURRENCY_UPDATED:
            return _extends({}, state, {
                currencyUpdated: action.currencyUpdated
            });
        default:
            return state;
    }
}

/***/ }),

/***/ "./src/reducers/headerReducer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = headerReducer;

var _constants = __webpack_require__("./src/actions/constants.js");

function headerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { initialTrackingFired: false };
    var action = arguments[1];

    switch (action.type) {
        case _constants.actionTypes.SET_UPDATE_USER_STATE:
            return _extends({}, state, {
                updateUserState: action.updateUserState,
                initialTrackingFired: false
            });
        case _constants.actionTypes.INITIAL_TRACKING_FIRED:
            return _extends({}, state, {
                initialTrackingFired: true
            });
        case _constants.actionTypes.SET_USER_TYPE_TRADE:
            return _extends({}, state, {
                isUserTypeTrade: action.isUserTypeTrade
            });
        case _constants.actionTypes.SET_USER_TYPE_VIP:
            return _extends({}, state, {
                isUserTypeVip: action.isUserTypeVip
            });
        case _constants.actionTypes.SET_BANNER_MESSAGES:
            return _extends({}, state, {
                bannerMessages: action.bannerMessages
            });
        case _constants.actionTypes.SET_DEVICE_TYPE:
            return _extends({}, state, {
                deviceType: action.deviceType
            });
        case _constants.actionTypes.TOGGLE_MOBILE_MENU:
            return _extends({}, state, {
                isMobileMenuOpen: action.isMobileMenuOpen
            });
        default:
            return state;
    }
}

/***/ }),

/***/ "./src/reducers/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _cartReducer = __webpack_require__("./src/reducers/cartReducer.js");

var _cartReducer2 = _interopRequireDefault(_cartReducer);

var _headerReducer = __webpack_require__("./src/reducers/headerReducer.js");

var _headerReducer2 = _interopRequireDefault(_headerReducer);

var _footerReducer = __webpack_require__("./src/reducers/footerReducer.js");

var _footerReducer2 = _interopRequireDefault(_footerReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    cart: _cartReducer2.default,
    header: _headerReducer2.default,
    footer: _footerReducer2.default
};

/***/ }),

/***/ "./src/relayClientEnvironment.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = getRelayEnvironment;

var _relayRuntime = __webpack_require__("./node_modules/relay-runtime/index.js");

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _serverVars = __webpack_require__("./node_modules/server-vars/index.js");

var _serverVars2 = _interopRequireDefault(_serverVars);

var _client = __webpack_require__("./node_modules/dibs-relay-network-layer/client.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var environment = void 0;

function getRelayEnvironment() {
    var records = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!environment) {
        var network = _relayRuntime.Network.create((0, _client.createFetcher)({
            getQueries: function getQueries() {
                return _extends({}, (0, _dibsCookieJar.getBuyerToken)(document.cookie), {
                    locale: _serverVars2.default.get('locale')
                });
            }
        }));
        var source = new _relayRuntime.RecordSource(records);
        var store = new _relayRuntime.Store(source);
        environment = new _relayRuntime.Environment({ network: network, store: store });
    }
    return environment;
}

/***/ }),

/***/ "./src/scss/chat.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/scss/dibs.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"headerPrimaryLarge":"_12g_EbVCCS-8VvIlOUVyGU","headerPrimaryMedium":"_3y27iiasoDuphZZ4VQBBj3","headerPrimarySmall":"_1Q0ag9I7c4C-pviW7O_cKO","headerSecondaryLarge":"nrWNR3thdRLtOX8XKly7a","headerSecondaryMedium":"_2JBaaLcXmx0k5VqQByARDW","headerSecondarySmall":"_1cQPwULQDLIh3Lo-nuNaBK","bodyHeaderPrimaryLarge":"EDgy12CdYb_zZ6JgVrAAm","bodyHeaderPrimaryMedium":"mupKZebWUyrhQB0NTYXE4","bodyHeaderPrimarySmall":"_1XAwFrGXDdDcrvh-x80jLX"};

/***/ }),

/***/ "./src/scss/tradeOnboarding.scss":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "./src/utils/AuthModalCheck.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Created by theodora on 6/12/14.
 */



var _require = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getBuyerId = _require.getBuyerId;

var authModalLoader = __webpack_require__("./src/utils/AuthModalLoader.js").default;
var qs = __webpack_require__("./node_modules/querystring-es3/index.js");

var authModals = [authModalLoader.constants.LOGIN, authModalLoader.constants.REGISTER, authModalLoader.constants.RESET_PASSWORD, authModalLoader.constants.RESET_INVALID];

/**
 *
 * @param uri
 * @returns {string}
 */
function getRedirectDestination() {
    var queryKey = qs.parse(window.location.search.substr(1));
    var dest = queryKey.ep ? decodeURIComponent(queryKey.ep) : null;
    if (dest && dest.indexOf('//') > -1) {
        // id ep contains '//' then redirect to current page
        // if phishing is happening, just redirect to the homepage (uri.path = '/')
        dest = window.location.href;
    }

    return dest;
}

module.exports = {
    /**
     * Changed window object to parameter for easier testing
     * @param {object} win Mock window object
     * @param {object} uri Mock object mainly for testing
     */
    init: function checkForAuthModal() {
        var destination = getRedirectDestination();
        var action = qs.parse(window.location.search.substr(1)).modal || '';
        var gaAction = action.replace('_', ' ');
        action = action.replace('_', '-');
        var authOptions = {
            action: action,
            ga: {
                label: gaAction + ' query param - address bar',
                value: window.scrollY ? 1 : 0
            }
        };

        if (action) {
            if (authModals.indexOf(action) > -1) {
                // Need to make sure we have fresh user state
                // and don't get into infinite redirect loops
                if (getBuyerId(document.cookie) && destination) {
                    window.location.href = destination;
                } else {
                    authModalLoader.show(authOptions).then(function authModalShowHandler(authResponse) {
                        if (destination && !authResponse.err) {
                            window.location.href = destination;
                        }
                    });
                }
            }
        }
    }
};

/***/ }),

/***/ "./src/utils/AuthModalLoader.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _yaDeferred = __webpack_require__("./node_modules/yaDeferred/index.js");

var _yaDeferred2 = _interopRequireDefault(_yaDeferred);

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _authFlowConstants = __webpack_require__("./src/authModal/authentication/authFlowConstants.js");

var constants = _interopRequireWildcard(_authFlowConstants);

var _async = __webpack_require__("./src/authModal/async.js");

var _async2 = _interopRequireDefault(_async);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Auth = void 0;

var authModalLoader = {
    _onLoaded: (0, _yaDeferred2.default)(),

    /**
     * Splits the AuthModal to a separate chunk during build time. Loads the authModal when called.
     * For now there's no way to handle errors. Should be possible when we switch to webpack 2.
     * This is mostly an espace hatch if you need direct access to the authModal instance.
     *
     * @example
     * authModalLoader.load().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    load: function load() {
        (0, _async2.default)().then(function (mod) {
            Auth = mod;
            authModalLoader._onLoaded.resolve(mod);
        });
        return authModalLoader._onLoaded;
    },


    /**
     * Usefull when you don't want to load the AuthModal but want to get the instance.
     *
     * @example
     * authModalLoader.getLoadPromise().then(AuthModal => DO STUFF)
     *
     * @returns {Promise} - A promise that resolves with the AuthModal module.
     */
    getLoadPromise: function getLoadPromise() {
        return authModalLoader._onLoaded;
    },


    /**
     * Shortcut to AuthModal.show.
     *
     * @example
     * authModalLoader.show(options).then((authResponse) => if (authResponse.err) FAILURE else SUCCESS);
     * authResponse.user will be an object containing user data: user.userId, user.userToken, user.profile {}.
     * authResponse.err will be an object with shape {err: 'closed'}.
     * it will contain the reason for authentication failure. which is most likely because the user closed the modal.
     * @returns {Promise}
     */
    show: function show() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var environment = options.relayEnvironment || (0, _relayClientEnvironment2.default)();
        return new Promise(function (resolve) {
            _this.load().then(function (AuthModal) {
                AuthModal.initAuth({ environment: environment });
                switch (options.action) {
                    case constants.LOGIN:
                        Auth.launchLogin(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_PASSWORD:
                        Auth.launchResetPassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.UPDATE_PASSWORD:
                        Auth.launchUpdatePassword(_extends({}, options, { resolve: resolve }));
                        break;
                    case constants.RESET_INVALID:
                        Auth.launchResetInvalid(_extends({}, options, { resolve: resolve }));
                        break;
                    default:
                        Auth.launchRegistration(_extends({}, options, { resolve: resolve }));
                        break;
                }
            });
        }).then(function (authResult) {
            var isRegister = authResult.modal === constants.REGISTER;
            authResult = _extends({}, authResult, { newUser: isRegister });
            return authResult;
        });
    },


    /**
     * Used for testing only.
     */
    _clearAuthModal: function _clearAuthModal() {
        Auth = undefined;
        authModalLoader._onLoaded = (0, _yaDeferred2.default)();
    },


    /**
     * Used for testing only.
     */
    _setAuthModal: function _setAuthModal(m) {
        Auth = m;
    }
};

authModalLoader = Object.assign(authModalLoader, { constants: constants });

exports.default = authModalLoader;

/***/ }),

/***/ "./src/utils/__generated__/chat_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_user = {|
  +createdDate: ?string;
  +isTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
  |};
  +roles: ?{|
    +roleList: ?$ReadOnlyArray<?{|
      +name: ?string;
      +createdDate: ?string;
      +userData: ?{|
        +userStatus: ?{|
          +name: ?string;
        |};
      |};
    |}>;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "createdDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": "isTrade",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_TRADE_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
  }, {
    "kind": "ScalarField",
    "alias": "hasVipPermission",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_VIP_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "email",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "UserRoles",
    "name": "roles",
    "plural": false,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Role",
      "name": "roleList",
      "plural": true,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "createdDate",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "UserRoleData",
        "name": "userData",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "UserRoleUserData",
          "name": "userStatus",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/chat_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_viewer = {|
  +tradeChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +vipChatEmail: ?$ReadOnlyArray<?{|
    +userDataB: ?$ReadOnlyArray<?{|
      +email?: ?string;
    |}>;
  |}>;
  +allTransactions: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactions: ?{|
    +totalResults: ?number;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]!"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_viewer",
  "selections": [{
    "kind": "LinkedField",
    "alias": "tradeChatEmail",
    "args": [{
      "kind": "Literal",
      "name": "relationshipType",
      "value": "VIP",
      "type": "relationshipType!"
    }, {
      "kind": "Variable",
      "name": "userIds",
      "variableName": "userIds",
      "type": "[String]!"
    }],
    "concreteType": "UserRelationship",
    "name": "userRelationships",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": null,
      "name": "userDataB",
      "plural": true,
      "selections": [{
        "kind": "InlineFragment",
        "type": "VipRepData",
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "vipChatEmail",
    "args": [{
      "kind": "Literal",
      "name": "relationshipType",
      "value": "TRADE",
      "type": "relationshipType!"
    }, {
      "kind": "Variable",
      "name": "userIds",
      "variableName": "userIds",
      "type": "[String]!"
    }],
    "concreteType": "UserRelationship",
    "name": "userRelationships",
    "plural": true,
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": null,
      "name": "userDataB",
      "plural": true,
      "selections": [{
        "kind": "InlineFragment",
        "type": "TradeRepData",
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "allTransactions",
    "args": [{
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userIds",
      "type": "[String]"
    }, {
      "kind": "Literal",
      "name": "first",
      "value": 0,
      "type": "Int"
    }],
    "concreteType": "TransactionConnection",
    "name": "transactions",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalResults",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "initiatedTransactions",
    "args": [{
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userIds",
      "type": "[String]"
    }, {
      "kind": "Literal",
      "name": "first",
      "value": 0,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "viewName",
      "value": "buyerTracking.initiated",
      "type": "String"
    }],
    "concreteType": "TransactionConnection",
    "name": "transactions",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalResults",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "submittedTransactions",
    "args": [{
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userIds",
      "type": "[String]"
    }, {
      "kind": "Literal",
      "name": "first",
      "value": 0,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "viewName",
      "value": "buyerTracking.submitted",
      "type": "String"
    }],
    "concreteType": "TransactionConnection",
    "name": "transactions",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalResults",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": "confirmedTransactions",
    "args": [{
      "kind": "Variable",
      "name": "buyerId",
      "variableName": "userIds",
      "type": "[String]"
    }, {
      "kind": "Literal",
      "name": "first",
      "value": 0,
      "type": "Int"
    }, {
      "kind": "Literal",
      "name": "sort",
      "value": "createdDate asc",
      "type": "String"
    }, {
      "kind": "Literal",
      "name": "viewName",
      "value": "buyerTracking.confirmed",
      "type": "String"
    }],
    "concreteType": "TransactionConnection",
    "name": "transactions",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "totalResults",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/initializeTrackingQuery.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 02548e866b37be4198b9da5f063e6386
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type initializeTrackingQueryResponse = {|
  +viewer: ?{|
    +allTransactions?: ?{|
      +totalResults: ?number;
    |};
    +initiatedTransactions?: ?{|
      +totalResults: ?number;
    |};
    +submittedTransactions?: ?{|
      +totalResults: ?number;
    |};
    +confirmedTransactionsMostRecent?: ?{|
      +totalResults: ?number;
    |};
    +user?: ?{|
      +firstSessionDate: ?string;
      +isTrade: ?boolean;
      +hasVipPermission: ?boolean;
      +profile: ?{|
        +email: ?string;
        +zipCode: ?string;
        +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
      |};
      +serviceId: ?string;
      +totalMessagesToDealers: ?number;
      +tradeFirm: ?{|
        +serviceId: ?string;
        +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
      |};
      +verifiedTradeStatus: ?string;
      +activePromotion: ?{|
        +serviceId: ?string;
      |};
    |};
  |};
|};
*/

/*
query initializeTrackingQuery(
  $hasUserId: Boolean!
  $userId: String!
  $userIds: [String!]
) {
  viewer {
    allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {
      totalResults
    }
  initiatedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.initiated", first: 0) @include(if: $hasUserId) {
      totalResults
    }
  submittedTransactions: transactions(buyerId: $userIds, viewName: "buyerTracking.submitted", first: 0) @include(if: $hasUserId) {
      totalResults
    }
  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, viewName: "buyerTracking.confirmed", first: 0) @include(if: $hasUserId) {
      totalResults
    }
  user(userId: $userId) @include(if: $hasUserId) {
      firstSessionDate
      isTrade: hasPermission(name: "B_TRADE_CHECKOUT")
      hasVipPermission: hasPermission(name: "B_VIP_CHECKOUT")
      profile {
        email
        zipCode
        currency
      }
      serviceId
      totalMessagesToDealers
      tradeFirm {
        serviceId
        tier
        id
      }
      verifiedTradeStatus
      activePromotion {
        serviceId
        id
      }
      id
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "initializeTrackingQuery",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Promotion",
            "name": "activePromotion",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "initializeTrackingQuery",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "hasUserId",
      "type": "Boolean!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }, {
      "kind": "LocalArgument",
      "name": "userIds",
      "type": "[String!]",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "initializeTrackingQuery",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "Condition",
        "passingValue": true,
        "condition": "hasUserId",
        "selections": [{
          "kind": "LinkedField",
          "alias": "allTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "initiatedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.initiated",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "submittedTransactions",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.submitted",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": "confirmedTransactionsMostRecent",
          "args": [{
            "kind": "Variable",
            "name": "buyerId",
            "variableName": "userIds",
            "type": "[String]"
          }, {
            "kind": "Literal",
            "name": "first",
            "value": 0,
            "type": "Int"
          }, {
            "kind": "Literal",
            "name": "viewName",
            "value": "buyerTracking.confirmed",
            "type": "String"
          }],
          "concreteType": "TransactionConnection",
          "name": "transactions",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalResults",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": [{
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId",
            "type": "String!"
          }],
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstSessionDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": "isTrade",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_TRADE_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
          }, {
            "kind": "ScalarField",
            "alias": "hasVipPermission",
            "args": [{
              "kind": "Literal",
              "name": "name",
              "value": "B_VIP_CHECKOUT",
              "type": "String!"
            }],
            "name": "hasPermission",
            "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Profile",
            "name": "profile",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "email",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "zipCode",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "currency",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "serviceId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "totalMessagesToDealers",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TradeFirmType",
            "name": "tradeFirm",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tier",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "verifiedTradeStatus",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Promotion",
            "name": "activePromotion",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "serviceId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }]
      }],
      "storageKey": null
    }]
  },
  "text": "query initializeTrackingQuery(\n  $hasUserId: Boolean!\n  $userId: String!\n  $userIds: [String!]\n) {\n  viewer {\n    allTransactions: transactions(buyerId: $userIds, first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  initiatedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.initiated\", first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  submittedTransactions: transactions(buyerId: $userIds, viewName: \"buyerTracking.submitted\", first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  confirmedTransactionsMostRecent: transactions(buyerId: $userIds, viewName: \"buyerTracking.confirmed\", first: 0) @include(if: $hasUserId) {\n      totalResults\n    }\n  user(userId: $userId) @include(if: $hasUserId) {\n      firstSessionDate\n      isTrade: hasPermission(name: \"B_TRADE_CHECKOUT\")\n      hasVipPermission: hasPermission(name: \"B_VIP_CHECKOUT\")\n      profile {\n        email\n        zipCode\n        currency\n      }\n      serviceId\n      totalMessagesToDealers\n      tradeFirm {\n        serviceId\n        tier\n        id\n      }\n      verifiedTradeStatus\n      activePromotion {\n        serviceId\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/utils/__generated__/tradeOnboardingHelper_Query.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5607285562713e356168cde02d96d9d7
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type tradeOnboardingHelper_QueryResponse = {|
  +viewer: ?{|
    +user: ?{|
      +isVerifiedTrade: ?boolean;
      +profile: ?{|
        +email: ?string;
      |};
    |};
  |};
|};
*/

/*
query tradeOnboardingHelper_Query(
  $userId: String!
) {
  viewer {
    user(userId: $userId) {
      isVerifiedTrade: hasPermission(name: "B_NET_PRICE")
      profile {
        email
      }
      id
    }
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "tradeOnboardingHelper_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId",
          "type": "String!"
        }],
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": "isVerifiedTrade",
          "args": [{
            "kind": "Literal",
            "name": "name",
            "value": "B_NET_PRICE",
            "type": "String!"
          }],
          "name": "hasPermission",
          "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "RootQueryType"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "tradeOnboardingHelper_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "userId",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "tradeOnboardingHelper_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Viewer",
      "name": "viewer",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId",
          "type": "String!"
        }],
        "concreteType": "User",
        "name": "user",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": "isVerifiedTrade",
          "args": [{
            "kind": "Literal",
            "name": "name",
            "value": "B_NET_PRICE",
            "type": "String!"
          }],
          "name": "hasPermission",
          "storageKey": "hasPermission{\"name\":\"B_NET_PRICE\"}"
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Profile",
          "name": "profile",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "email",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query tradeOnboardingHelper_Query(\n  $userId: String!\n) {\n  viewer {\n    user(userId: $userId) {\n      isVerifiedTrade: hasPermission(name: \"B_NET_PRICE\")\n      profile {\n        email\n      }\n      id\n    }\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "./src/utils/__generated__/userTracking_user.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_user = {|
  +firstSessionDate: ?string;
  +isTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
    +zipCode: ?string;
    +currency: ?"USD" | "GBP" | "EUR" | "CAD" | "AUD" | "CHF" | "MXN" | "JPY";
  |};
  +serviceId: ?string;
  +totalMessagesToDealers: ?number;
  +tradeFirm: ?{|
    +serviceId: ?string;
    +tier: ?"TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "P_AND_M" | "UNKNOWN";
  |};
  +verifiedTradeStatus: ?string;
  +activePromotion: ?{|
    +serviceId: ?string;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_user",
  "selections": [{
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "firstSessionDate",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": "isTrade",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_TRADE_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_TRADE_CHECKOUT\"}"
  }, {
    "kind": "ScalarField",
    "alias": "hasVipPermission",
    "args": [{
      "kind": "Literal",
      "name": "name",
      "value": "B_VIP_CHECKOUT",
      "type": "String!"
    }],
    "name": "hasPermission",
    "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Profile",
    "name": "profile",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "email",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "zipCode",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "currency",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "serviceId",
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "totalMessagesToDealers",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "TradeFirmType",
    "name": "tradeFirm",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }, {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "tier",
      "storageKey": null
    }],
    "storageKey": null
  }, {
    "kind": "ScalarField",
    "alias": null,
    "args": null,
    "name": "verifiedTradeStatus",
    "storageKey": null
  }, {
    "kind": "LinkedField",
    "alias": null,
    "args": null,
    "concreteType": "Promotion",
    "name": "activePromotion",
    "plural": false,
    "selections": [{
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }],
    "storageKey": null
  }],
  "type": "User"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/__generated__/userTracking_viewer.graphql.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable */



/*::
import type {ConcreteFragment} from 'relay-runtime';
export type userTracking_viewer = {|
  +allTransactions?: ?{|
    +totalResults: ?number;
  |};
  +initiatedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +submittedTransactions?: ?{|
    +totalResults: ?number;
  |};
  +confirmedTransactionsMostRecent?: ?{|
    +totalResults: ?number;
  |};
|};
*/

var fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [{
    "kind": "RootArgument",
    "name": "userIds",
    "type": "[String]"
  }, {
    "kind": "RootArgument",
    "name": "hasUserId",
    "type": "Boolean"
  }],
  "kind": "Fragment",
  "metadata": null,
  "name": "userTracking_viewer",
  "selections": [{
    "kind": "Condition",
    "passingValue": true,
    "condition": "hasUserId",
    "selections": [{
      "kind": "LinkedField",
      "alias": "allTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "initiatedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.initiated",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "submittedTransactions",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.submitted",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": "confirmedTransactionsMostRecent",
      "args": [{
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds",
        "type": "[String]"
      }, {
        "kind": "Literal",
        "name": "first",
        "value": 0,
        "type": "Int"
      }, {
        "kind": "Literal",
        "name": "viewName",
        "value": "buyerTracking.confirmed",
        "type": "String"
      }],
      "concreteType": "TransactionConnection",
      "name": "transactions",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "totalResults",
        "storageKey": null
      }],
      "storageKey": null
    }]
  }],
  "type": "Viewer"
};

module.exports = fragment;

/***/ }),

/***/ "./src/utils/abExperiments.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var root = typeof window === 'undefined' ? global : window;

root.abExperiments = root.abExperiments || {};

module.exports = root.abExperiments;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/utils/chat.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

__webpack_require__("./src/scss/chat.scss");

var SV = __webpack_require__("./node_modules/server-vars/index.js");
var get = __webpack_require__("./node_modules/lodash.get/index.js");
var root = typeof window === 'undefined' ? global : window;

var _require = __webpack_require__("./node_modules/dibs-browser-storage/index.js"),
    localStorage = _require.localStorage,
    sessionStorage = _require.sessionStorage;

var printRegex = /^\/print\//;
var isPrintPDP = root.location && printRegex.test(root.location.pathname);
var qs = __webpack_require__("./node_modules/querystring-es3/index.js");

var _require2 = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js"),
    getBuyerId = _require2.getBuyerId;

var _require3 = __webpack_require__("./node_modules/react-relay/index.js"),
    graphql = _require3.graphql;

var ScriptInjector = __webpack_require__("./src/utils/scriptInjector.js");

var isPageType = __webpack_require__("./src/utils/isPageType.js");

var _require4 = __webpack_require__("./src/utils/pageConstants.js"),
    PAGE_TYPE = _require4.PAGE_TYPE,
    BROWSE_TYPES = _require4.BROWSE_TYPES;

var _ref = root.location && qs.parse(root.location.search) || {},
    tradePromoDate = _ref.tradePromoDate;

var TYPE_SEARCH = 'SEARCH';
var TYPE_DEALER = 'SELLER';
var CHAT_STARTED_STORAGE_KEY = '__chatStarted';
var ARGUMENTS_STORAGE_KEY = '__chatArguments';
var CHECKOUT_UNLOAD_KEY = '__checkoutUnload';
var CHECKOUT_TYPE_KEY = '__checkoutTransactionType';
var CUSTOMER_TYPE_VIP = 'VIP';
var CUSTOMER_TYPE_TRADE = 'Trade';
var CUSTOMER_TYPE_CONSUMER = 'Consumer';

var ITEMS_ABOVE_PRICE_VIEWED_KEY = 'itemsAbovePriceViewed';
var ITEMS_ABOVE_PRICE_VIEWED_THRESHOLD = 3;

var PRICE_LIMIT_10K = 10000;
var PRICE_LIMIT_50K = 50000;

var TRADE_PROMO_DATE_FROM = tradePromoDate || '2017-01-16';

var intercomId = SV.get('intercomId');

var PAGE_TYPE_WHITELIST = [].concat(_toConsumableArray(BROWSE_TYPES), [PAGE_TYPE.FAVORITES, // Cart + Favorites has same pageType
PAGE_TYPE.HOME, PAGE_TYPE.INVOICE, PAGE_TYPE.PDP, PAGE_TYPE.SEARCH, PAGE_TYPE.SOURCING]);

var loadPromise = null;

function loadIntercom() {
    loadPromise = ScriptInjector.inject('https://widget.intercom.io/widget/' + intercomId).then(function () {
        var intercom = root.Intercom;
        intercom('boot', {
            app_id: intercomId // eslint-disable-line camelcase
        });

        return intercom;
    });
    return loadPromise;
}

function getIntercom() {
    if (root.intercom || loadPromise) {
        return loadPromise;
    }
    return loadIntercom();
}

function getDate() {
    var date = new Date();
    return date.toJSON();
}

function getIntercomDate(date) {
    date = new Date(date);
    return date.getTime() / 1000; // get UTC seconds
}

function applyArgumentQueue(intercom) {
    var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];

    if (argumentQueue.length) {
        argumentQueue.forEach(function (args) {
            intercom.apply(intercom, args);
        });
    }

    sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, []);
}

function load() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var chatStarted = sessionStorage.getItem(CHAT_STARTED_STORAGE_KEY);
    var pageTypeValid = isPageType(PAGE_TYPE_WHITELIST);

    if (chatStarted && !isPrintPDP && pageTypeValid) {
        return getIntercom().then(function (intercom) {
            applyArgumentQueue(intercom);
            if (args.length) {
                intercom.apply(intercom, args);
            }
        });
    } else if (!isPrintPDP) {
        var argumentQueue = sessionStorage.getItem(ARGUMENTS_STORAGE_KEY) || [];
        argumentQueue.push(args);
        sessionStorage.setItem(ARGUMENTS_STORAGE_KEY, argumentQueue);
    }

    // if `chat_intercom` is not enabled resolve
    return Promise.resolve();
}

function trackEvent() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return load.apply(undefined, ['trackEvent'].concat(args));
}

function update(data) {
    return load('update', data);
}

function getUserTestGroup(tradeUserCreateDate) {
    var userId = getBuyerId(root.document.cookie);
    var lastIdNumber = Number.parseInt(userId.slice(-1));
    var testGroupData = {};

    // User ids end up with 1 or 2, ~20% of users
    if ([1, 2].indexOf(lastIdNumber) > -1) {
        testGroupData.user_test_group = 'Holdout'; // eslint-disable-line camelcase
    }

    testGroupData.user_test_group = 'Test'; // eslint-disable-line camelcase

    if (tradeUserCreateDate) {
        var secontToLastIdNumber = Number.parseInt(userId.slice(-2, -1));
        if ([4, 5].indexOf(secontToLastIdNumber) > -1 && new Date(tradeUserCreateDate) > new Date(TRADE_PROMO_DATE_FROM)) {
            testGroupData.user_trade_promo_group = 'Test'; // eslint-disable-line camelcase
        } else {
            testGroupData.user_trade_promo_group = 'Control'; // eslint-disable-line camelcase
        }
    }

    return testGroupData;
}

function getCustomerType(user) {
    var customerType = [];

    if (user && user.isTrade) {
        customerType.push(CUSTOMER_TYPE_TRADE);
    }

    if (user && user.hasVipPermission) {
        customerType.push(CUSTOMER_TYPE_VIP);
    }

    if (!customerType.length) {
        return CUSTOMER_TYPE_CONSUMER;
    }

    return customerType.length ? customerType.join(' and ') : undefined;
}

var BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
var BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
var BUYER_STATUS_SUBMITTED = 'SUBMITTED';
var BUYER_STATUS_INITIATED = 'INITIATED';
var BUYER_STATUS_NONE = 'NONE';

var TRADE_STATUS_MAP = {
    VERIFIED_VETTED: 'verified - vetted',
    VERIFIED_PRE_APPROVED: 'verified - pre-approved',
    SUSPECTED: 'suspected',
    APPLIED_IN_REVIEW: 'applied - in review',
    APPLIED_NOT_ENOUGH_INFORMATION: 'applied - not enough information',
    APPLIED_REJECTED: 'applied - rejected'
};

function getBuyerStatusFromTransactions(viewer) {
    var initiatedTransactions = viewer.initiatedTransactions,
        submittedTransactions = viewer.submittedTransactions,
        confirmedTransactions = viewer.confirmedTransactions;


    if (confirmedTransactions && confirmedTransactions.totalResults > 1) {
        return BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        return BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        return BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        return BUYER_STATUS_INITIATED;
    }

    return BUYER_STATUS_NONE;
}

function getTradeStatus(viewer) {
    var roles = get(viewer, 'user.roles.roleList') || [];
    var role = roles.find(function (r) {
        return r.name === 'B_TRADE_BUYER';
    });
    var statusKey = get(role, 'userData.userStatus.name');
    return {
        status: TRADE_STATUS_MAP[statusKey],
        date: get(role, 'createdDate')
    };
}

var chat = {
    start: function start() {
        sessionStorage.setItem(CHAT_STARTED_STORAGE_KEY, true);
        return load();
    },
    show: function show() {
        return load('show');
    },
    fillUserData: function fillUserData(viewer, user) {
        var tradeChatEmail = viewer.tradeChatEmail,
            vipChatEmail = viewer.vipChatEmail;
        var tradeUserCreateDate = user.tradeUserCreateDate;

        var userId = getBuyerId(root.document.cookie);
        if (!userId) {
            return Promise.resolve();
        }

        var userType = getCustomerType(user);
        var createdDate = user.createdDate,
            _user$profile = user.profile,
            firstName = _user$profile.firstName,
            lastName = _user$profile.lastName,
            email = _user$profile.email;

        var tradeStatus = getTradeStatus(viewer);

        var userData = Object.assign({
            user_id: userId, // eslint-disable-line camelcase
            name: ((firstName || '') + ' ' + (lastName || '')).trim(),
            email: email,
            user_type: userType, // eslint-disable-line camelcase
            registered_at: getIntercomDate(createdDate), // eslint-disable-line camelcase
            trade_account_manager: get(tradeChatEmail, '0.userDataB.0.email'), // eslint-disable-line camelcase
            vip_account_manager: get(vipChatEmail, '0.userDataB.0.email'), // eslint-disable-line camelcase
            buyer_status: getBuyerStatusFromTransactions(viewer), // eslint-disable-line camelcase
            total_transactions: get(viewer, 'allTransactions.totalResults') || 0, // eslint-disable-line camelcase
            trade_status: tradeStatus.status, // eslint-disable-line camelcase
            verified_trade_at: getIntercomDate(tradeStatus.date) // eslint-disable-line camelcase
        }, getUserTestGroup(tradeUserCreateDate));

        return update(userData);
    },


    customAttribute: {
        itemsInCart: function itemsInCart(itemCount) {
            return update({ items_in_cart: itemCount }); // eslint-disable-line camelcase
        },


        // TODO: Remove, as never used?
        registeredOnPage: function registeredOnPage() {
            var pathname = root.location.pathname;

            return update({ registered_on_page: pathname }); // eslint-disable-line camelcase
        },


        // TODO: Remove, as never used?
        loyaltyStatus: function loyaltyStatus(status) {
            return update({ LoyaltyStatus: status });
        }
    },

    track: {
        abandonFavorite: function abandonFavorite(type) {
            switch (type) {
                case TYPE_SEARCH:
                    return trackEvent('abandon_follow_search');

                case TYPE_DEALER:
                    return trackEvent('abandon_follow_dealer');
            }

            return Promise.resolve();
        },
        abandonRequestNetPrice: function abandonRequestNetPrice() {
            return trackEvent('abandon_request_net_price', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        requestNetPrice: function requestNetPrice() {
            return trackEvent('success_request_net_price', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        abandonMakeOffer: function abandonMakeOffer() {
            return trackEvent('make_offer_abandon', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        makeOfferComplete: function makeOfferComplete() {
            return trackEvent('make_offer_complete', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        abandonContactDealer: function abandonContactDealer() {
            return trackEvent('abandon_contact_dealer', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        contactDealer: function contactDealer() {
            return trackEvent('contact_dealer', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        addToCart: function addToCart() {
            return trackEvent('item_added_to_cart', {
                fired_at: getDate() // eslint-disable-line camelcase
            });
        },
        itemSaved: function itemSaved() {
            return trackEvent('success_save_item');
        },
        shippingDetailsClick: function shippingDetailsClick() {
            return trackEvent('view_shipping_details');
        },
        buyerAssuranceClick: function buyerAssuranceClick() {
            return trackEvent('buyer_protection');
        },
        checkoutReached: function checkoutReached(data, isNegotiable) {
            sessionStorage.setItem(CHECKOUT_TYPE_KEY, { isNegotiable: isNegotiable });
            return trackEvent('checkout_reached', data);
        },
        checkoutComplete: function checkoutComplete() {
            return trackEvent('checkout_completed');
        },
        checkoutAbandon: function checkoutAbandon() {
            return trackEvent('checkout_abandon');
        },
        checkoutSurveySubmitted: function checkoutSurveySubmitted(data) {
            return trackEvent('checkout_survey_submitted', data);
        },
        tradeBasicInfoCompleted: function tradeBasicInfoCompleted(noWebsite) {
            var prefix = noWebsite ? 'no ' : '';
            return trackEvent('trade application step 1 - ' + prefix + 'website');
        },
        sourcingRequestSubmitted: function sourcingRequestSubmitted() {
            return trackEvent('SourcingRequest');
        }
    }
};

function checkAbandonCheckout() {
    if (!root.location) {
        return;
    }
    var pathname = root.location.pathname;

    var isCheckoutPage = pathname.indexOf('checkout') > -1;
    var isCheckoutConfirmationPage = pathname.indexOf('checkout/confirmation') > -1;
    var isMyOrdersPage = pathname.indexOf('my/orders') > -1;

    if (isCheckoutPage && !isCheckoutConfirmationPage) {
        root.onbeforeunload = function () {
            sessionStorage.setItem(CHECKOUT_UNLOAD_KEY, true);
        };
    } else if (!isCheckoutConfirmationPage && !isMyOrdersPage && sessionStorage.getItem(CHECKOUT_UNLOAD_KEY)) {
        var isNegotiable = get(sessionStorage.getItem(CHECKOUT_TYPE_KEY), 'isNegotiable');

        if (isNegotiable) {
            chat.track.abandonMakeOffer();
        } else {
            chat.track.checkoutAbandon();
        }
    }

    sessionStorage.deleteItem(CHECKOUT_UNLOAD_KEY);
}

function checkConductSearch() {
    if (!root.location) {
        return;
    }
    var _root$location = root.location,
        pathname = _root$location.pathname,
        search = _root$location.search;


    if (pathname.indexOf('/search') === 0 && search.indexOf('?q=') === 0) {
        update({ user_conduct_search: 'Yes' }); // eslint-disable-line camelcase
    }
}

function checkItemsAbovePrice(key, eventName) {
    var items = localStorage.getItem(ITEMS_ABOVE_PRICE_VIEWED_KEY) || {};
    var newValue = (items[key] || 0) + 1;

    if (newValue >= ITEMS_ABOVE_PRICE_VIEWED_THRESHOLD) {
        trackEvent(eventName);
        newValue = 0;
    }
    localStorage.setItem(ITEMS_ABOVE_PRICE_VIEWED_KEY, _extends({}, items, _defineProperty({}, key, newValue)));
}

function checkPdp() {
    if (isPageType([PAGE_TYPE.PDP])) {
        var pk = SV.get('item.pk');
        trackEvent('pdp_view', { pk: pk });

        var isUserTypeTrade = SV.get('settings.isUserTypeTrade');

        if (isUserTypeTrade) {
            var _ref2 = SV.get('data') || {},
                netPrice = _ref2.netPrice,
                price = _ref2.price;

            var tradePrice = netPrice || price;
            if (tradePrice > PRICE_LIMIT_50K) {
                checkItemsAbovePrice(PRICE_LIMIT_50K, 'ItemView50k');
            } else if (tradePrice > PRICE_LIMIT_10K) {
                checkItemsAbovePrice(PRICE_LIMIT_10K, 'ItemView10k');
            }
        }
    }
}

checkAbandonCheckout();
checkConductSearch();
checkPdp();

var userFragment = exports.userFragment = {
    user: function user() {
        return __webpack_require__("./src/utils/__generated__/chat_user.graphql.js");
    }
};

var viewerFrgament = exports.viewerFrgament = {
    viewer: function viewer() {
        return __webpack_require__("./src/utils/__generated__/chat_viewer.graphql.js");
    }
};

exports.default = chat;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/utils/checkoutStorageConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var STORAGE = exports.STORAGE = {
    AUTO_MODAL_INFO: 'checkoutAutoModalInfo',
    SURVEY_INFO: 'checkoutSurveyInfo'
};

/***/ }),

/***/ "./src/utils/initializeTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackingQuery = undefined;
exports.default = initializeTracking;

var _relayRuntime = __webpack_require__("./node_modules/relay-runtime/index.js");

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _userTracking = __webpack_require__("./src/utils/userTracking.js");

var _userTracking2 = _interopRequireDefault(_userTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars

var trackingQuery = exports.trackingQuery = function trackingQuery() {
    return __webpack_require__("./src/utils/__generated__/initializeTrackingQuery.graphql.js");
};
// relay needs this import
function initializeTracking(environment) {
    environment = environment || (0, _relayClientEnvironment2.default)();
    var userId = (0, _dibsCookieJar.getBuyerId)(document.cookie) || '';
    var hasUserId = !!userId;

    return (0, _relayRuntime.fetchQuery)(environment, trackingQuery, {
        userId: userId,
        hasUserId: hasUserId,
        userIds: [userId]
    }).then(function (_ref) {
        var viewer = _ref.viewer;

        (0, _userTracking.init)({ viewer: viewer, user: viewer.user });
    });
}

/***/ }),

/***/ "./src/utils/isPageType.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SV = __webpack_require__("./node_modules/server-vars/index.js");

module.exports = function isPageType(pageTypes) {
    var pageType = SV.get('settings.pageType');
    return pageTypes.indexOf(pageType) > -1;
};

/***/ }),

/***/ "./src/utils/loginHandlers.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var cbs = [];

var addLoginHandlers = exports.addLoginHandlers = function addLoginHandlers() {
    var args = Array.prototype.slice.call(arguments);
    cbs.push.apply(cbs, _toConsumableArray(args.reduce(function (acc, item) {
        if (Array.isArray(item)) {
            acc.push.apply(acc, _toConsumableArray(item));
        } else {
            acc.push(item);
        }
        return acc;
    }, [])));
};

var fireLoginHandlers = exports.fireLoginHandlers = function fireLoginHandlers(arg) {
    cbs.forEach(function (func) {
        return func(arg);
    });
};

var getLoginHandlers = exports.getLoginHandlers = function getLoginHandlers() {
    return [].concat(cbs);
};

var dumpHandlers = exports.dumpHandlers = function dumpHandlers() {
    cbs.length = 0;
};

/***/ }),

/***/ "./src/utils/pageConstants.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PAGE_TYPE = Object.freeze({
    ABOUT: 'about',
    ASSOCIATION: 'association',
    ATTRIBUTE: 'attribute',
    BROWSE: 'browse',
    CHECKOUT: 'checkout',
    CHECKOUT_CONFIRMATION: 'checkoutConfirmation',
    COLLECTION: 'collection',
    CREATOR: 'creator',
    DEALER: 'dealer',
    FAVORITES: 'favorites',
    HOME: 'home',
    INVOICE: 'invoice',
    LOCATION: 'location',
    MATERIAL: 'material',
    MESSAGE_CENTER: 'messageCenter',
    METAL: 'metal',
    ORDER_MANAGER: 'orderManager',
    ORIGIN: 'origin',
    PDP: 'pdp',
    PERIOD: 'period',
    RECOGNIZED_DEALERS: 'recognized_dealers',
    SEARCH: 'search',
    SECTION: 'section',
    SOURCING: 'sourcing',
    STONE: 'stone',
    STYLE: 'style',
    TECHNIQUE: 'technique',
    TRADE_PROFILE: 'trade'
});

var BROWSE_TYPES = Object.freeze([PAGE_TYPE.ASSOCIATION, PAGE_TYPE.ATTRIBUTE, PAGE_TYPE.BROWSE, PAGE_TYPE.COLLECTION, PAGE_TYPE.CREATOR, PAGE_TYPE.LOCATION, PAGE_TYPE.MATERIAL, PAGE_TYPE.METAL, PAGE_TYPE.ORIGIN, PAGE_TYPE.PERIOD, PAGE_TYPE.RECOGNIZED_DEALERS, PAGE_TYPE.SECTION, PAGE_TYPE.STONE, PAGE_TYPE.STYLE, PAGE_TYPE.TECHNIQUE]);

module.exports = Object.freeze({
    PAGE_TYPE: PAGE_TYPE,
    BROWSE_TYPES: BROWSE_TYPES
});

/***/ }),

/***/ "./src/utils/scriptInjector.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ScriptInjector = {
    /**
     * [inject description]
     * @param  {String} url     Url of the script
     * @param  {Object} params  Parameters passed to script loading url
     * @return {Promise}
     */
    inject: function inject(url) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { async: true };

        return new Promise(function (resolve) {
            var prop = void 0;

            var script = document.createElement('script');
            script.src = url;

            for (prop in params) {
                if (params.hasOwnProperty(prop)) {
                    script[prop] = params[prop];
                }
            }

            if (script.readyState) {
                // IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {
                // Others
                script.onload = function () {
                    resolve();
                };
            }

            var scriptTag = document.getElementsByTagName('script')[0];
            scriptTag.parentNode.insertBefore(script, scriptTag);
        });
    }
};

module.exports = ScriptInjector;

/***/ }),

/***/ "./src/utils/tradeOnboardingHelper.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.loadSourcingModal = exports.loadOnboardingModalWithOrigin = exports.loadOnboardingModal = exports.fetchTradeUserData = exports.getContainerElement = exports.markModalShown = exports.hasSeenModal = exports.getModalType = exports.LABEL_SEARCH_BROWSE = exports.LABEL_PDP = exports.ORIGIN_FOLDER = exports.ORIGIN_FAVORITE = exports.ORIGIN_HOLD = exports.ORIGIN_SOLD = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line no-unused-vars


var _react = __webpack_require__("./node_modules/react/index.js");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("./node_modules/react-dom/index.js");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _relayClientEnvironment = __webpack_require__("./src/relayClientEnvironment.js");

var _relayClientEnvironment2 = _interopRequireDefault(_relayClientEnvironment);

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

var _isPageType = __webpack_require__("./src/utils/isPageType.js");

var _isPageType2 = _interopRequireDefault(_isPageType);

var _pageConstants = __webpack_require__("./src/utils/pageConstants.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LAST_SHOWN_TOKEN = 'last_shown_trade_onboarding_modal';
var MODAL_TYPE = 'tradeOnboardingModal';
var CONTAINER_CLASSNAME = 'tradeSourcingCTAModalContainer';

var ORIGIN_SOLD = exports.ORIGIN_SOLD = 'Sold PDP';
var ORIGIN_HOLD = exports.ORIGIN_HOLD = 'Hold PDP';
var ORIGIN_FAVORITE = exports.ORIGIN_FAVORITE = 'Post Favorite';
var ORIGIN_FOLDER = exports.ORIGIN_FOLDER = 'Post Folder';
var LABEL_PDP = exports.LABEL_PDP = 'pdp';
var LABEL_SEARCH_BROWSE = exports.LABEL_SEARCH_BROWSE = 'search/browse';

var getModalType = exports.getModalType = function getModalType() {
    return MODAL_TYPE;
};
var hasSeenModal = exports.hasSeenModal = function hasSeenModal() {
    return !!_dibsBrowserStorage.localStorage.getItem(LAST_SHOWN_TOKEN);
};
var markModalShown = exports.markModalShown = function markModalShown() {
    return _dibsBrowserStorage.localStorage.setItem(LAST_SHOWN_TOKEN, Date.now());
};

var getContainerElement = exports.getContainerElement = function getContainerElement() {
    var containerElement = document.querySelector('.' + CONTAINER_CLASSNAME);
    if (!containerElement) {
        containerElement = document.createElement('div');
        containerElement.classList.add(CONTAINER_CLASSNAME);
        document.body.appendChild(containerElement);
    }
    return containerElement;
};

var query = function query() {
    return __webpack_require__("./src/utils/__generated__/tradeOnboardingHelper_Query.graphql.js");
};

var fetchTradeUserData = exports.fetchTradeUserData = function fetchTradeUserData() {
    var userId = (0, _dibsCookieJar.getBuyerId)(document.cookie);

    if (!userId) {
        return Promise.resolve(false);
    }

    return new Promise(function (resolve, reject) {
        (0, _reactRelay.fetchQuery)((0, _relayClientEnvironment2.default)(), query, {
            userId: userId
        }).then(function (data) {
            var userData = (0, _lodash2.default)(data, 'viewer.user') || {};
            resolve({
                isVerifiedTrade: (0, _lodash2.default)(userData, 'isVerifiedTrade'),
                email: (0, _lodash2.default)(userData, 'profile.email')
            });
        }).catch(function (error) {
            reject(error);
        });
    });
};

var loadOnboardingModal = exports.loadOnboardingModal = function loadOnboardingModal(options) {
    var chatUtils = __webpack_require__("./src/utils/chat.js").default;

    return new Promise(function (resolve, reject) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/dibs-trade-onboarding/dist/bundle.js")).then(function (_ref) {
            var onboardingModal = _ref.onboardingModal;

            var modalOptions = _extends({}, options, {
                onSendSourcingDataSuccess: function onSendSourcingDataSuccess() {
                    return chatUtils.track.sourcingRequestSubmitted();
                }
            });

            var _onboardingModal = onboardingModal(modalOptions),
                Modal = _onboardingModal.Modal;

            _reactDom2.default.render(_react2.default.createElement(Modal), getContainerElement());
            markModalShown();
            resolve(true);
        }).catch(reject);
    });
};

var loadOnboardingModalWithOrigin = exports.loadOnboardingModalWithOrigin = function loadOnboardingModalWithOrigin(requestOrigin) {
    if (hasSeenModal()) {
        return;
    }

    var label = (0, _isPageType2.default)(_pageConstants.PAGE_TYPE.PDP) ? LABEL_PDP : LABEL_SEARCH_BROWSE;

    fetchTradeUserData().then(function (_ref2) {
        var email = _ref2.email,
            isVerifiedTrade = _ref2.isVerifiedTrade;

        if (isVerifiedTrade) {
            loadOnboardingModal({
                buyerEmail: email,
                requestOrigin: requestOrigin,
                trackingLabel: 'modal - ' + label
            });
        }
    });
};

var loadSourcingModal = exports.loadSourcingModal = function loadSourcingModal(options) {
    var chatUtils = __webpack_require__("./src/utils/chat.js").default;

    return new Promise(function (resolve, reject) {
        __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "./node_modules/dibs-trade-onboarding/dist/bundle.js")).then(function (_ref3) {
            var sourcingModal = _ref3.sourcingModal;

            var modalOptions = _extends({}, options, {
                onSendSourcingDataSuccess: function onSendSourcingDataSuccess() {
                    return chatUtils.track.sourcingRequestSubmitted();
                }
            });

            var _sourcingModal = sourcingModal(modalOptions),
                SourcingModal = _sourcingModal.SourcingModal;

            _reactDom2.default.render(_react2.default.createElement(SourcingModal), getContainerElement());
            resolve(true);
        }).catch(reject);
    });
};

/***/ }),

/***/ "./src/utils/userTracking.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.viewerFragment = exports.userFragment = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BUYER_STATUSES_MAP;

exports.init = init;

var _reactRelay = __webpack_require__("./node_modules/react-relay/index.js");

var _lodash = __webpack_require__("./node_modules/lodash.get/index.js");

var _lodash2 = _interopRequireDefault(_lodash);

var _dibsTracking = __webpack_require__("./node_modules/dibs-tracking/tracking.js");

var _dibsTracking2 = _interopRequireDefault(_dibsTracking);

var _md = __webpack_require__("./node_modules/md5/md5.js");

var _md2 = _interopRequireDefault(_md);

var _dibsCookieJar = __webpack_require__("./node_modules/dibs-cookie-jar/dist/index.js");

var _dibsBrowserStorage = __webpack_require__("./node_modules/dibs-browser-storage/index.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var USER_EMAIL_TOKEN = 'userEmailToken';
var USER_EMAIL = 'userEmail';
var STORAGE_TRANSACTIONS_STATUS = 'userTransactionsStatus';
var BUYER_STATUS_NONE = 'NONE';
var BUYER_STATUS_CONFIRMED_MULTIPLE = 'CONFIRMED_MULTIPLE';
var BUYER_STATUS_CONFIRMED_ONE = 'CONFIRMED_ONE';
var BUYER_STATUS_SUBMITTED = 'SUBMITTED';
var BUYER_STATUS_INITIATED = 'INITIATED';
var BUYER_STATUSES_MAP = (_BUYER_STATUSES_MAP = {}, _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_MULTIPLE, 'confirmed|multiple orders'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_CONFIRMED_ONE, 'confirmed|one order'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_SUBMITTED, 'submitted|none confirmed'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_INITIATED, 'initiated|none submitted'), _defineProperty(_BUYER_STATUSES_MAP, BUYER_STATUS_NONE, 'no orders initiated'), _BUYER_STATUSES_MAP);

/*
 * depending on transaction history, determine which value to add for the BUYER_STATUSES_MAP
*/
function getBuyerStatusFromTransactions(transactions) {
    var initiatedTransactions = transactions.initiatedTransactions,
        submittedTransactions = transactions.submittedTransactions,
        confirmedTransactions = transactions.confirmedTransactions;

    var buyerStatus = void 0;

    if (confirmedTransactions && confirmedTransactions.totalResults > 1) {
        buyerStatus = BUYER_STATUS_CONFIRMED_MULTIPLE;
    } else if (confirmedTransactions && confirmedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_CONFIRMED_ONE;
    } else if (submittedTransactions && submittedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_SUBMITTED;
    } else if (initiatedTransactions && initiatedTransactions.totalResults) {
        buyerStatus = BUYER_STATUS_INITIATED;
    } else {
        buyerStatus = BUYER_STATUS_NONE;
    }

    return { buyerStatus: buyerStatus };
}

/*
 * fetches all transactions created by user using different filters
 * in order to track order history
*/
function getTransactionsStatus(transactions) {
    var totalTransactions = 0;
    var transactionsStatus = {
        buyerStatus: BUYER_STATUS_NONE,
        totalTransactions: totalTransactions
    };
    // if user has any transactions, go through them to determine which value from BUYER_STATUSES_MAP it should have
    if (transactions.allTransactions) {
        totalTransactions = transactions.allTransactions.totalResults;
        transactionsStatus = getBuyerStatusFromTransactions(transactions);
        Object.assign(transactionsStatus, {
            totalTransactions: totalTransactions
        });

        _dibsBrowserStorage.sessionStorage.setItem(STORAGE_TRANSACTIONS_STATUS, transactionsStatus);
    } else {
        // otherwise default to sessionStorage (dont think we currently use it in mobile) or no transactions at all
        transactionsStatus = _dibsBrowserStorage.sessionStorage.getItem(STORAGE_TRANSACTIONS_STATUS) || transactionsStatus;
    }
    if (transactionsStatus) {
        transactionsStatus.buyerStatus = BUYER_STATUSES_MAP[transactionsStatus.buyerStatus];
    }

    return transactionsStatus;
}

/*
 * create the userType tag according to user permissions.
 * VIP|Trade|Unknown|undefined (logged out)
*/
function getCustomerType(user) {
    if (user.serviceId) {
        var isTrade = user.isTrade ? 'Trade' : '';
        var hasVipPermission = user.hasVipPermission ? 'VIP' : '';
        return '' + isTrade + (isTrade && hasVipPermission ? ' and ' : '') + hasVipPermission || 'consumer';
    } else if (user.everLoggedIn) {
        return undefined;
    } else {
        return 'Unknown';
    }
}

/*
 * creates the user tracking data.
*/
function trackUserAttributes(_ref) {
    var _ref$transactions = _ref.transactions,
        transactions = _ref$transactions === undefined ? {} : _ref$transactions,
        _ref$user = _ref.user,
        user = _ref$user === undefined ? {} : _ref$user;

    var userEmail = (0, _lodash2.default)(user, 'profile.email') || _dibsBrowserStorage.localStorage.getItem(USER_EMAIL);
    var transactionsStatus = getTransactionsStatus(transactions);

    /*
    * Appends cdn test value to data layer tracking object.
    * Here it only adds the value to global object variable,
    * tracking itself is done with 'tracking.addUserAttributes'
    */
    _dibsTracking2.default.updateGtmPageInfo({
        cdnTest3: 'newregpromo=' + !!(0, _lodash2.default)(user, 'activePromotion')
    });

    _dibsTracking2.default.addUserAttributes({
        loginStatus: user.serviceId ? 'Logged In' : 'Logged Out',
        registrationStatus: user.everLoggedIn ? 'Registered' : 'Not Registered',
        userID: user.serviceId,
        guestID: (0, _dibsCookieJar.getGuestId)(document.cookie),
        userEmail: userEmail ? (0, _md2.default)(userEmail) : undefined,
        userEmailAddress: user.serviceId ? userEmail : undefined,
        emailToken: _dibsBrowserStorage.localStorage.getItem(USER_EMAIL_TOKEN),
        userZip: (0, _lodash2.default)(user, 'profile.zipCode'),
        defaultCurrency: (0, _lodash2.default)(user, 'profile.currency'),
        firstSessionDate: user.firstSessionDate || undefined,
        contactDealerStatus: user.totalMessagesToDealers ? 'dealer contacted' : 'no dealer contacted',
        buyerStatus: transactionsStatus.buyerStatus,
        tradeStatus: user.verifiedTradeStatus,
        customerType: getCustomerType(user),
        tradeTier: (0, _lodash2.default)(user, 'tradeFirm.tier'),
        tradeFirmId: (0, _lodash2.default)(user, 'tradeFirm.serviceId')
    });
}

var userFragment = exports.userFragment = {
    user: function user() {
        return __webpack_require__("./src/utils/__generated__/userTracking_user.graphql.js");
    }
};

function getUserFragmentData(user) {
    var firstSessionDate = user.firstSessionDate,
        isTrade = user.isTrade,
        hasVipPermission = user.hasVipPermission,
        profile = user.profile,
        serviceId = user.serviceId,
        totalMessagesToDealers = user.totalMessagesToDealers,
        tradeFirm = user.tradeFirm,
        verifiedTradeStatus = user.verifiedTradeStatus,
        activePromotion = user.activePromotion;

    return {
        firstSessionDate: firstSessionDate,
        isTrade: isTrade,
        hasVipPermission: hasVipPermission,
        profile: profile,
        serviceId: serviceId,
        totalMessagesToDealers: totalMessagesToDealers,
        tradeFirm: tradeFirm,
        verifiedTradeStatus: verifiedTradeStatus,
        activePromotion: activePromotion
    };
}

var viewerFragment = exports.viewerFragment = {
    viewer: function viewer() {
        return __webpack_require__("./src/utils/__generated__/userTracking_viewer.graphql.js");
    }
};

function getViewerFragmentData(viewer) {
    var allTransactions = viewer.allTransactions,
        initiatedTransactions = viewer.initiatedTransactions,
        submittedTransactions = viewer.submittedTransactions,
        confirmedTransactionsMostRecent = viewer.confirmedTransactionsMostRecent;

    return {
        allTransactions: allTransactions,
        initiatedTransactions: initiatedTransactions,
        submittedTransactions: submittedTransactions,
        confirmedTransactions: confirmedTransactionsMostRecent
    };
}

/*
 * should be called on initial page load for all entries.
 * determines user tracking data to send to dibs-tracking.
 */
function init(_ref2) {
    var _ref2$viewer = _ref2.viewer,
        viewer = _ref2$viewer === undefined ? {} : _ref2$viewer,
        user = _ref2.user;

    var transactions = getViewerFragmentData(viewer);
    var everLoggedIn = (0, _dibsCookieJar.getEverLoggedIn)(document.cookie);
    var userFragmentData = user ? getUserFragmentData(user) : undefined;

    trackUserAttributes({ user: _extends({}, userFragmentData, { everLoggedIn: everLoggedIn }), transactions: transactions });
}

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__;

/***/ }),

/***/ "dll-reference dibs_vendor":
/***/ (function(module, exports) {

module.exports = dibs_vendor;

/***/ })

/******/ });


// WEBPACK FOOTER //
// dibs_buyer_layout_22.0.6_60c513c88d20559e42ec.js